/**-----------------------------------------------------------------------------------------
* Copyright © 2026 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import * as i0 from '@angular/core';
import { Injectable, isDevMode, EventEmitter, HostListener, HostBinding, Output, Input, Optional, Component, ContentChildren, Directive, InjectionToken, Inject, ElementRef, ViewContainerRef, ViewChild, ContentChild, forwardRef, SkipSelf, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { Subject, Subscription, fromEvent, merge, of, Observable, from } from 'rxjs';
import * as i12 from '@progress/kendo-angular-common';
import { isDocumentAvailable, isFirefox, isSafari, isChanged, hasObservers, KENDO_WEBMCP_HOST, normalizeKeys, Keys, TemplateContextDirective, MultiTabStop, guid, parseCSSClassNames, isPresent as isPresent$1, EventsOutsideAngularDirective, replaceMessagePlaceholder, anyChanged, PreventableEvent as PreventableEvent$1, ResizeSensorComponent, ToggleButtonTabStopDirective, ResizeBatchService, KENDO_TOGGLEBUTTONTABSTOP } from '@progress/kendo-angular-common';
const _c0 = ["kendoButton", ""];
const _c1 = ["*"];
function ButtonComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon-wrapper", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.icon)("svgIcon", ctx_r0.svgIcon);
  }
}
function ButtonComponent_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵelement(1, "img", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.imageUrl, i0.ɵɵsanitizeUrl);
  }
}
function ButtonComponent_ng_template_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.iconClass);
  }
}
function ButtonComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, ButtonComponent_ng_template_0_Conditional_0_Template, 1, 2, "kendo-icon-wrapper", 4);
    i0.ɵɵconditionalCreate(1, ButtonComponent_ng_template_0_Conditional_1_Template, 2, 1, "span", 5);
    i0.ɵɵconditionalCreate(2, ButtonComponent_ng_template_0_Conditional_2_Template, 1, 1, "span", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.icon || ctx_r0.svgIcon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.imageUrl ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.iconClass ? 2 : -1);
  }
}
function ButtonComponent_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonComponent_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 7);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const iconTemplate_r2 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r2);
  }
}
function ButtonComponent_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ButtonComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonComponent_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 7);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const iconTemplate_r2 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r2);
  }
}
function ButtonComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.arrowIcon.iconClass);
  }
}
function ButtonComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵelement(1, "kendo-icon-wrapper", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r0.arrowIcon.icon || "chevron-down")("svgIcon", ctx_r0.arrowIcon.svgIcon || ctx_r0.chevronDownIcon);
  }
}
const _c2 = [[["", "kendoButton", ""]]];
const _c3 = ["[kendoButton]"];
function ChipComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon-wrapper", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.icon)("svgIcon", ctx_r0.svgIcon);
  }
}
function ChipComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon-wrapper", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customFontClass", ctx_r0.customIconClass);
  }
}
function ChipComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵelement(1, "img", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", i0.ɵɵinterpolate(ctx_r0.avatarSettings.imageSrc), i0.ɵɵsanitizeUrl)("ngStyle", ctx_r0.avatarSettings.imageCssStyle);
    i0.ɵɵattribute("alt", ctx_r0.avatarSettings.imageAltText);
  }
}
function ChipComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", ctx_r0.avatarSettings.initialsCssStyle);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.avatarSettings.initials.substring(0, 2));
  }
}
function ChipComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵconditionalCreate(1, ChipComponent_Conditional_2_Conditional_1_Template, 2, 4, "span", 6);
    i0.ɵɵconditionalCreate(2, ChipComponent_Conditional_2_Conditional_2_Template, 2, 2, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r0.avatarSettings.cssStyle);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.avatarSettings == null ? null : ctx_r0.avatarSettings.imageSrc) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.avatarSettings == null ? null : ctx_r0.avatarSettings.initials) ? 2 : -1);
  }
}
function ChipComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
  }
}
function ChipComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function ChipComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵlistener("click", function ChipComponent_Conditional_6_Conditional_1_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onMenuClick($event));
    });
    i0.ɵɵelement(1, "kendo-icon-wrapper", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r0.defaultMenuIcon || ctx_r0.menuSvgIcon)("customFontClass", ctx_r0.menuIcon);
  }
}
function ChipComponent_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵlistener("click", function ChipComponent_Conditional_6_Conditional_2_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onRemoveClick($event));
    });
    i0.ɵɵelement(1, "kendo-icon-wrapper", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r0.removeSvgIcon || ctx_r0.defaultRemoveIcon)("customFontClass", ctx_r0.removeIcon);
  }
}
function ChipComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵconditionalCreate(1, ChipComponent_Conditional_6_Conditional_1_Template, 2, 2, "span", 9);
    i0.ɵɵconditionalCreate(2, ChipComponent_Conditional_6_Conditional_2_Template, 2, 2, "span", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hasMenu ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.removable ? 2 : -1);
  }
}
const _c4 = (a0, a1) => ({
  templateRef: a0,
  $implicit: a1
});
function ListComponent_For_2_Conditional_1_ng_template_1_Template(rf, ctx) {}
function ListComponent_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtemplate(1, ListComponent_For_2_Conditional_1_ng_template_1_Template, 0, 0, "ng-template", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("k-disabled", dataItem_r4.disabled);
    i0.ɵɵproperty("ngClass", dataItem_r4.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(4, _c4, ctx_r2.itemTemplate == null ? null : ctx_r2.itemTemplate.templateRef, dataItem_r4));
  }
}
function ListComponent_For_2_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon-wrapper", 6);
  }
  if (rf & 2) {
    const dataItem_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("name", dataItem_r4.icon)("svgIcon", dataItem_r4.svgIcon)("customFontClass", dataItem_r4.iconClass);
  }
}
function ListComponent_For_2_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 7);
  }
  if (rf & 2) {
    const dataItem_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("src", dataItem_r4.imageUrl, i0.ɵɵsanitizeUrl)("alt", dataItem_r4.imageAlt);
  }
}
function ListComponent_For_2_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getText(dataItem_r4), " ");
  }
}
function ListComponent_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵconditionalCreate(1, ListComponent_For_2_Conditional_2_Conditional_1_Template, 1, 3, "kendo-icon-wrapper", 6);
    i0.ɵɵconditionalCreate(2, ListComponent_For_2_Conditional_2_Conditional_2_Template, 1, 2, "img", 7);
    i0.ɵɵconditionalCreate(3, ListComponent_For_2_Conditional_2_Conditional_3_Template, 2, 1, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("k-disabled", dataItem_r4.disabled);
    i0.ɵɵproperty("ngClass", dataItem_r4.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵconditional(dataItem_r4.icon || dataItem_r4.iconClass || dataItem_r4.svgIcon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(dataItem_r4.imageUrl ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.getText(dataItem_r4) ? 3 : -1);
  }
}
function ListComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵlistener("click", function ListComponent_For_2_Template_li_click_0_listener($event) {
      const ɵ$index_3_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      $event.stopImmediatePropagation();
      return i0.ɵɵresetView(ctx_r2.onClick(ɵ$index_3_r2));
    })("blur", function ListComponent_For_2_Template_li_blur_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onBlur());
    });
    i0.ɵɵconditionalCreate(1, ListComponent_For_2_Conditional_1_Template, 2, 7, "span", 3);
    i0.ɵɵconditionalCreate(2, ListComponent_For_2_Conditional_2_Template, 4, 6, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r4 = ctx.$implicit;
    const ɵ$index_3_r2 = ctx.$index;
    const ɵ$count_3_r5 = ctx.$count;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("k-first", ɵ$index_3_r2 === 0)("k-last", ɵ$index_3_r2 === ɵ$count_3_r5 - 1);
    i0.ɵɵproperty("index", ɵ$index_3_r2);
    i0.ɵɵattribute("aria-disabled", dataItem_r4.disabled || null);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r2.itemTemplate == null ? null : ctx_r2.itemTemplate.templateRef) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ctx_r2.itemTemplate == null ? null : ctx_r2.itemTemplate.templateRef) ? 2 : -1);
  }
}
const _c5 = ["button"];
const _c6 = ["buttonList"];
const _c7 = ["popupTemplate"];
const _c8 = ["container"];
function DropDownButtonComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-button-list", 5, 3);
    i0.ɵɵlistener("onItemClick", function DropDownButtonComponent_ng_template_3_Template_kendo_button_list_onItemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onItemClick($event));
    })("keydown", function DropDownButtonComponent_ng_template_3_Template_kendo_button_list_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keyDownHandler($event));
    })("keyup", function DropDownButtonComponent_ng_template_3_Template_kendo_button_list_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keyUpHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.listId)("data", ctx_r1.data)("textField", ctx_r1.textField)("itemTemplate", ctx_r1.itemTemplate)("size", ctx_r1.size);
    i0.ɵɵattribute("dir", ctx_r1.dir)("aria-labelledby", ctx_r1.buttonId);
  }
}
const _c9 = ["kendoDialItem", ""];
const _c10 = (a0, a1, a2) => ({
  $implicit: a0,
  index: a1,
  isFocused: a2
});
function DialItemComponent_Conditional_0_ng_template_0_Template(rf, ctx) {}
function DialItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DialItemComponent_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.dialItemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c10, ctx_r0.item, ctx_r0.index, ctx_r0.isFocused));
  }
}
function DialItemComponent_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.item.label);
  }
}
function DialItemComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon-wrapper", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.item.icon)("customFontClass", ctx_r0.item.iconClass)("svgIcon", ctx_r0.item.svgIcon);
  }
}
function DialItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, DialItemComponent_Conditional_1_Conditional_0_Template, 2, 1, "span", 1);
    i0.ɵɵconditionalCreate(1, DialItemComponent_Conditional_1_Conditional_1_Template, 1, 3, "kendo-icon-wrapper", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.item.label ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.item.icon || ctx_r0.item.iconClass || ctx_r0.item.svgIcon ? 1 : -1);
  }
}
const _c11 = ["kendoDialList", ""];
function DialListComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 0);
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ɵ$index_1_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("item", ctx_r2.dialItems[ɵ$index_1_r2])("index", ɵ$index_1_r2)("dialItemTemplate", ctx_r2.dialItemTemplate)("isFocused", ctx_r2.isFocused(ɵ$index_1_r2))("ngClass", item_r1.cssClass)("ngStyle", item_r1.cssStyle)("align", ctx_r2.align);
  }
}
const _c12 = (a0, a1, a2) => ({
  keydown: a0,
  click: a1,
  pointerdown: a2
});
const _c13 = (a0, a1) => ({
  keydown: a0,
  focusout: a1
});
function FloatingActionButtonComponent_Conditional_2_ng_template_0_Template(rf, ctx) {}
function FloatingActionButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FloatingActionButtonComponent_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.fabTemplate == null ? null : ctx_r0.fabTemplate.templateRef);
  }
}
function FloatingActionButtonComponent_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon-wrapper", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.icon)("customFontClass", ctx_r0.iconClass)("svgIcon", ctx_r0.svgIcon);
  }
}
function FloatingActionButtonComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function FloatingActionButtonComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FloatingActionButtonComponent_Conditional_3_Conditional_0_Template, 1, 3, "kendo-icon-wrapper", 4);
    i0.ɵɵconditionalCreate(1, FloatingActionButtonComponent_Conditional_3_Conditional_1_Template, 2, 1, "span", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.icon || ctx_r0.iconClass || ctx_r0.svgIcon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.text ? 1 : -1);
  }
}
function FloatingActionButtonComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 6);
    i0.ɵɵlistener("click", function FloatingActionButtonComponent_ng_template_4_Template_ul_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onItemClick($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.dialListId)("ngClass", ctx_r0.dialClass)("dialItems", ctx_r0.dialItems)("dialItemTemplate", ctx_r0.dialItemTemplate == null ? null : ctx_r0.dialItemTemplate.templateRef)("align", ctx_r0.align)("kendoEventsOutsideAngular", i0.ɵɵpureFunction2(7, _c13, ctx_r0.keyDownHandler.bind(ctx_r0), ctx_r0.focusOutHandler.bind(ctx_r0)));
    i0.ɵɵattribute("aria-labelledby", ctx_r0.id);
  }
}
function SplitButtonComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
  }
}
function SplitButtonComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-button-list", 9);
    i0.ɵɵlistener("onItemClick", function SplitButtonComponent_ng_template_8_Template_kendo_button_list_onItemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onItemClick($event));
    })("keydown", function SplitButtonComponent_ng_template_8_Template_kendo_button_list_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keyDownHandler($event));
    })("keyup", function SplitButtonComponent_ng_template_8_Template_kendo_button_list_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keyUpHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.listId)("data", ctx_r1.data)("textField", ctx_r1.textField)("itemTemplate", ctx_r1.itemTemplate);
    i0.ɵɵattribute("dir", ctx_r1.dir);
  }
}
const _c14 = ["kendoSpeechToTextButton", ""];
const _c15 = ["kendoSmartPasteButton", ""];
function SmartPasteButtonComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon-wrapper", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.icon)("svgIcon", ctx_r0.svgIcon);
  }
}
function SmartPasteButtonComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵelement(1, "img", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.imageUrl, i0.ɵɵsanitizeUrl);
  }
}
function SmartPasteButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.iconClass);
  }
}
const _c16 = ["thumb"];
const _c17 = ["resizeSensor"];
function SegmentedControlComponent_For_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon-wrapper", 5);
  }
  if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerCssClass", button_r3["iconInnerCssClass"] ? "k-segmented-control-button-icon " + button_r3["iconInnerCssClass"] : "k-segmented-control-button-icon")("name", button_r3.icon)("svgIcon", button_r3.svgIcon);
  }
}
function SegmentedControlComponent_For_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r3.text);
  }
}
function SegmentedControlComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function SegmentedControlComponent_For_5_Template_button_click_0_listener() {
      const ctx_r1 = i0.ɵɵrestoreView(_r1);
      const button_r3 = ctx_r1.$implicit;
      const ɵ$index_5_r4 = ctx_r1.$index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.handleClick(button_r3, ɵ$index_5_r4));
    })("keydown", function SegmentedControlComponent_For_5_Template_button_keydown_0_listener($event) {
      const button_r3 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.handleKeydown($event, button_r3));
    });
    i0.ɵɵconditionalCreate(1, SegmentedControlComponent_For_5_Conditional_1_Template, 1, 3, "kendo-icon-wrapper", 5);
    i0.ɵɵconditionalCreate(2, SegmentedControlComponent_For_5_Conditional_2_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r3 = ctx.$implicit;
    const ɵ$index_5_r4 = ctx.$index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("k-disabled", button_r3.disabled)("k-selected", ctx_r4.selectedButtonIndex === ɵ$index_5_r4);
    i0.ɵɵattribute("aria-disabled", button_r3.disabled ? true : null)("title", button_r3.title)("aria-label", button_r3.title && !button_r3.text ? button_r3.title : null)("aria-pressed", ctx_r4.selectedButtonIndex === ɵ$index_5_r4 ? "true" : "false");
    i0.ɵɵadvance();
    i0.ɵɵconditional(button_r3.icon || button_r3.svgIcon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(button_r3.text ? 2 : -1);
  }
}
export { ToggleButtonTabStopDirective } from '@progress/kendo-angular-common';
import { chevronDownIcon, xCircleIcon, moreVerticalIcon, microphoneIcon, stopIcon, pasteSparkleIcon } from '@progress/kendo-svg-icons';
import * as i1 from '@progress/kendo-angular-l10n';
import { LocalizationService, L10N_PREFIX, ComponentMessages } from '@progress/kendo-angular-l10n';
import { validatePackage } from '@progress/kendo-licensing';
import { IconWrapperComponent, IconsService } from '@progress/kendo-angular-icons';
import { NgClass, NgTemplateOutlet, NgStyle } from '@angular/common';
import { filter, tap, take, debounceTime } from 'rxjs/operators';
import * as i3 from '@progress/kendo-angular-popup';
import { PopupService } from '@progress/kendo-angular-popup';
import * as i4 from '@angular/animations';
import { sequence, query, style, stagger, animate } from '@angular/animations';
import { KendoSpeechRecognition } from '@progress/kendo-webspeech-common';
import * as i2 from '@angular/common/http';
import { HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import * as i3$1 from '@angular/forms';
import { KendoSmartPaste } from '@progress/kendo-smartpaste-common';

/**
 * @hidden
 */
class KendoButtonService {
  buttonClicked = new Subject();
  buttonClicked$ = this.buttonClicked.asObservable();
  click(button) {
    this.buttonClicked.next(button);
  }
  static ɵfac = function KendoButtonService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || KendoButtonService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: KendoButtonService,
    factory: KendoButtonService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KendoButtonService, [{
    type: Injectable
  }], null, null);
})();

/**
 * @hidden
 */
const packageMetadata = {
  name: '@progress/kendo-angular-buttons',
  productName: 'Kendo UI for Angular',
  productCode: 'KENDOUIANGULAR',
  productCodes: ['KENDOUIANGULAR'],
  publishDate: 1780593661,
  version: '24.1.0',
  licensingDocsUrl: 'https://www.telerik.com/kendo-angular-ui/my-license/'
};

/**
 * @hidden
 */
const resolvedPromise = Promise.resolve(null);
/**
 * @hidden
 */
const isPresent = value => value !== null && value !== undefined;
/**
 * @hidden
 */
const tick = f => resolvedPromise.then(f);
/**
 * @hidden
 */
function isDocumentNode(container) {
  return container.nodeType === 9;
}
/**
 * @hidden
 */
function closest(element, selector) {
  if (element.closest) {
    return element.closest(selector);
  }
  const matches = Element.prototype.matches ? (el, sel) => el.matches(sel) : (el, sel) => el.msMatchesSelector(sel);
  let node = element;
  while (node && !isDocumentNode(node)) {
    if (matches(node, selector)) {
      return node;
    }
    node = node.parentNode;
  }
}
/**
 * @hidden
 */
const SIZES = {
  xsmall: 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg'
};
const ROUNDNESS = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full',
  none: 'none'
};
/**
 * @hidden
 *
 * Returns the styling classes to be added and removed.
 */
const getStylingClasses = (componentType, stylingOption, previousValue, newValue) => {
  switch (stylingOption) {
    case 'size':
      {
        return {
          toRemove: previousValue ? `k-${componentType}-${SIZES[previousValue]}` : null,
          toAdd: newValue ? `k-${componentType}-${SIZES[newValue]}` : null
        };
      }
    case 'rounded':
      {
        let roundedClassToAdd = null;
        if (newValue) {
          if (newValue !== 'none') {
            roundedClassToAdd = `k-rounded-${ROUNDNESS[newValue]}`;
          } else {
            roundedClassToAdd = 'k-rounded-none';
          }
        }
        return {
          toRemove: previousValue ? `k-rounded-${ROUNDNESS[previousValue]}` : null,
          toAdd: roundedClassToAdd || null
        };
      }
    case 'fillMode':
      {
        return {
          toRemove: previousValue ? `k-${componentType}-${previousValue}` : null,
          toAdd: newValue ? `k-${componentType}-${newValue}` : null
        };
      }
    default:
      break;
  }
};
/**
 * @hidden
 *
 * Returns the themeColor classes to be added and removed
 */
const getThemeColorClasses = (componentType, previousValue, newValue) => {
  return {
    toRemove: previousValue ? `k-${componentType}-${previousValue}` : null,
    toAdd: newValue ? `k-${componentType}-${newValue}` : null
  };
};
/**
 * @hidden
 */
const toggleClass = (className, add, renderer, element) => {
  if (add) {
    renderer.addClass(element, className);
  } else {
    renderer.removeClass(element, className);
  }
};
/**
 * @hidden
 *
 * Checks for an empty object - {}
 */
const isObjectEmpty = obj => obj && Object.keys(obj).length === 0 && obj.constructor === Object;

/**
 * Represents the Kendo UI Button component for Angular.
 *
 * As of package v17, the `span[kendoButton]` and `kendo-button` selectors are removed.
 * Use the `button[kendoButton]` selector only.
 *
 * @example
 * ```html
 * <button kendoButton [icon]="'save'" [themeColor]="'primary'">Save</button>
 * ```
 */
class ButtonComponent {
  renderer;
  service;
  ngZone;
  /**
   * @hidden
   * @default false
   * required for DropDownButton arrow icon.
   */
  arrowIcon = false;
  /**
   * Adds visual styling to indicate when the Button is active.
   *
   * @default false
   */
  toggleable = false;
  /**
   * Backwards-compatible alias
   *
   * @hidden
   */
  get togglable() {
    return this.toggleable;
  }
  /**
   * @hidden
   */
  set togglable(value) {
    this.toggleable = value;
  }
  /**
   * Sets the selected state of the Button.
   * Use with the `toggleable` property.
   *
   * @default false
   */
  get selected() {
    return this._selected || false;
  }
  set selected(value) {
    this._selected = value;
  }
  /**
   * @hidden
   */
  set tabIndex(index) {
    this.element.tabIndex = index;
  }
  get tabIndex() {
    return this.element.tabIndex;
  }
  /**
   * Specifies a URL for an `img` element inside the Button.
   * The URL can be relative or absolute. If relative, it is evaluated with relation to the web page URL.
   */
  imageUrl;
  /**
   * Sets the icon position relative to the button text.
   * @hidden
   * @default 'start'
   */
  iconPosition = 'start';
  /**
   * Defines a CSS class, or multiple classes separated by spaces applied to a `span` element inside the Button. Use the `iconClass` to add custom icons.
   */
  set iconClass(value) {
    if (isDevMode() && value && (this.icon || this.svgIcon)) {
      throw new Error('Setting both icon/svgIcon and iconClass options at the same time is not supported.');
    }
    this._iconClass = value;
  }
  get iconClass() {
    return this._iconClass;
  }
  /**
   * Sets the name of an existing font icon in the Kendo UI theme.
   */
  set icon(name) {
    if (isDevMode() && name && this.iconClass) {
      throw new Error('Setting both icon/svgIcon and iconClass options at the same time is not supported.');
    }
    this._icon = name;
  }
  get icon() {
    return this._icon;
  }
  /**
   * When `true`, disables the Button and prevents user interaction.
   *
   * @default false
   */
  set disabled(disabled) {
    //Required, because in FF focused buttons are not blurred on disabled
    if (disabled && isDocumentAvailable() && isFirefox(navigator.userAgent)) {
      this.blur();
    }
    this.isDisabled = disabled;
    this.renderer.setProperty(this.element, 'disabled', disabled);
  }
  get disabled() {
    return this.isDisabled;
  }
  /**
   * Sets the padding of the Button.
   * See [Button Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/button/appearance#size). The default value is set by the Kendo theme.
   */
  set size(size) {
    this.handleClasses(size, 'size');
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the Button.
   * See [Button Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/button/appearance#roundness). The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.handleClasses(rounded, 'rounded');
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the background and border styles of the Button.
   * See [Button Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/button/appearance#fill-mode). The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.handleClasses(fillMode, 'fillMode');
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Sets a predefined theme color for the Button.
   * The theme color applies as a background and border color and adjusts the text color.
   * See [Button Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/button/appearance#theme-colors). The default value is set by the Kendo theme.
   */
  set themeColor(themeColor) {
    this.handleThemeColor(themeColor);
    this._themeColor = themeColor;
  }
  get themeColor() {
    return this._themeColor;
  }
  /**
   * Sets an SVG icon to display inside the Button.
   */
  set svgIcon(icon) {
    if (isDevMode() && icon && this.iconClass) {
      throw new Error('Setting both icon/svgIcon and iconClass options at the same time is not supported.');
    }
    this._svgIcon = icon;
  }
  get svgIcon() {
    return this._svgIcon;
  }
  /**
   * Fires when the selected state of a toggleable button changes.
   * The event argument is the new selected state (`boolean`).
   */
  selectedChange = new EventEmitter();
  /**
   * Fires when the user clicks the Button.
   */
  click = new EventEmitter();
  element;
  isDisabled = false;
  chevronDownIcon = chevronDownIcon;
  _size = undefined;
  _rounded = undefined;
  _fillMode = undefined;
  _themeColor = undefined;
  _focused = false;
  direction;
  _selected;
  subs = new Subscription();
  _iconClass;
  _icon;
  _svgIcon;
  set isFocused(isFocused) {
    toggleClass('k-focus', isFocused, this.renderer, this.element);
    this._focused = isFocused;
  }
  get isFocused() {
    return this._focused;
  }
  get iconButtonClass() {
    const hasIcon = this.icon || this.iconClass || this.imageUrl || this.svgIcon;
    return hasIcon && !this.hasText;
  }
  get classDisabled() {
    return this.isDisabled;
  }
  get classActive() {
    return this.selected;
  }
  get getDirection() {
    return this.direction;
  }
  /**
   * @hidden
   */
  onFocus() {
    this.isFocused = true;
  }
  /**
   * @hidden
   */
  onBlur() {
    this.isFocused = false;
  }
  /**
   * Alias for ElementRef.nativeElement to workaround
   * ViewChild() selectors that used to return the host element before v11.
   *
   * @hidden
   */
  get nativeElement() {
    return this.element;
  }
  constructor(element, renderer, service, localization, ngZone) {
    this.renderer = renderer;
    this.service = service;
    this.ngZone = ngZone;
    validatePackage(packageMetadata);
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.subs.add(localization.changes.subscribe(({
      rtl
    }) => this.direction = rtl ? 'rtl' : 'ltr'));
    this.element = element.nativeElement;
  }
  ngOnInit() {
    this.renderer.addClass(this.element, 'k-button');
    if (!this.element.hasAttribute('role') && this.togglable) {
      this.toggleAriaPressed(this.toggleable);
    }
    this.ngZone.runOutsideAngular(() => {
      this.subs.add(this.renderer.listen(this.element, 'click', this._onButtonClick.bind(this)));
      this.subs.add(this.renderer.listen(this.element, 'mousedown', event => {
        const isBrowserSafari = isDocumentAvailable() && isSafari(navigator.userAgent);
        if (!this.isDisabled && isBrowserSafari) {
          event.preventDefault();
          this.element.focus();
        }
      }));
    });
  }
  ngOnChanges(change) {
    if (isChanged('togglable', change) || isChanged('toggleable', change)) {
      this.toggleAriaPressed(this.toggleable);
    }
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  /**
   * @hidden
   */
  get hasText() {
    return isDocumentAvailable() && this.element.textContent.trim().length > 0;
  }
  /**
   * Focuses the Button component.
   */
  focus() {
    if (isDocumentAvailable()) {
      this.element.focus();
      this.isFocused = true;
    }
  }
  /**
   * Removes focus from the Button component.
   */
  blur() {
    if (isDocumentAvailable()) {
      this.element.blur();
      this.isFocused = false;
    }
  }
  /**
   * @hidden
   */
  setAttribute(attribute, value) {
    this.renderer.setAttribute(this.element, attribute, value);
  }
  /**
   * @hidden
   */
  removeAttribute(attribute) {
    this.renderer.removeAttribute(this.element, attribute);
  }
  /**
   * @hidden
   *
   * Internal setter that triggers selectedChange
   */
  setSelected(value) {
    const changed = this.selected !== value;
    this.selected = value;
    this.setAttribute('aria-pressed', this.selected.toString());
    toggleClass('k-selected', this.selected, this.renderer, this.element);
    if (changed && hasObservers(this.selectedChange)) {
      this.ngZone.run(() => {
        this.selectedChange.emit(value);
      });
    }
  }
  toggleAriaPressed(shouldSet) {
    if (!isDocumentAvailable()) {
      return;
    }
    if (shouldSet) {
      this.setAttribute('aria-pressed', this.selected.toString());
    } else {
      this.removeAttribute('aria-pressed');
    }
  }
  _onButtonClick() {
    if (!this.disabled && this.service) {
      this.ngZone.run(() => {
        this.service.click(this);
      });
    }
    if (this.togglable && !this.service) {
      this.setSelected(!this.selected);
    }
  }
  handleClasses(value, input) {
    const elem = this.element;
    const classes = getStylingClasses('button', input, this[input], value);
    if (input === 'fillMode') {
      this.handleThemeColor(this.themeColor);
    }
    if (classes.toRemove) {
      this.renderer.removeClass(elem, classes.toRemove);
    }
    if (classes.toAdd) {
      this.renderer.addClass(elem, classes.toAdd);
    }
  }
  handleThemeColor(value) {
    const elem = this.element;
    const themeColorClass = getThemeColorClasses('button', this.themeColor, value);
    if (themeColorClass.toRemove) {
      this.renderer.removeClass(elem, themeColorClass.toRemove);
    }
    if (themeColorClass.toAdd) {
      this.renderer.addClass(elem, themeColorClass.toAdd);
    }
  }
  static ɵfac = function ButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(KendoButtonService, 8), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ButtonComponent,
    selectors: [["button", "kendoButton", ""]],
    hostVars: 7,
    hostBindings: function ButtonComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("focus", function ButtonComponent_focus_HostBindingHandler() {
          return ctx.onFocus();
        })("blur", function ButtonComponent_blur_HostBindingHandler() {
          return ctx.onBlur();
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.getDirection);
        i0.ɵɵclassProp("k-icon-button", ctx.iconButtonClass)("k-disabled", ctx.classDisabled)("k-selected", ctx.classActive);
      }
    },
    inputs: {
      arrowIcon: "arrowIcon",
      toggleable: "toggleable",
      togglable: "togglable",
      selected: "selected",
      tabIndex: "tabIndex",
      imageUrl: "imageUrl",
      iconPosition: "iconPosition",
      iconClass: "iconClass",
      icon: "icon",
      disabled: "disabled",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      themeColor: "themeColor",
      svgIcon: "svgIcon"
    },
    outputs: {
      selectedChange: "selectedChange",
      click: "click"
    },
    exportAs: ["kendoButton"],
    features: [i0.ɵɵProvidersFeature([LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.button'
    }, {
      provide: KENDO_WEBMCP_HOST,
      useExisting: ButtonComponent
    }]), i0.ɵɵNgOnChangesFeature],
    attrs: _c0,
    ngContentSelectors: _c1,
    decls: 8,
    vars: 4,
    consts: [["iconTemplate", ""], [1, "k-button-text"], [1, "k-button-icon", 3, "ngClass"], [1, "k-button-arrow"], ["innerCssClass", "k-button-icon", 3, "name", "svgIcon"], [1, "k-button-icon", "k-icon"], ["role", "presentation", 1, "k-image", 3, "src"], [4, "ngTemplateOutlet"], [3, "name", "svgIcon"]],
    template: function ButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, ButtonComponent_ng_template_0_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵconditionalCreate(2, ButtonComponent_Conditional_2_Template, 1, 1, "ng-container");
        i0.ɵɵelementStart(3, "span", 1);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(5, ButtonComponent_Conditional_5_Template, 1, 1, "ng-container");
        i0.ɵɵconditionalCreate(6, ButtonComponent_Conditional_6_Template, 1, 1, "span", 2);
        i0.ɵɵconditionalCreate(7, ButtonComponent_Conditional_7_Template, 2, 2, "span", 3);
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.iconPosition === "start" ? 2 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.iconPosition === "end" ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.arrowIcon.iconClass ? 6 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.arrowIcon && !ctx.arrowIcon.iconClass ? 7 : -1);
      }
    },
    dependencies: [IconWrapperComponent, NgClass, NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoButton',
      providers: [LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.button'
      }, {
        provide: KENDO_WEBMCP_HOST,
        useExisting: ButtonComponent
      }],
      selector: 'button[kendoButton]',
      template: `
        <ng-template #iconTemplate>
            @if (icon || svgIcon) {
                <kendo-icon-wrapper
                    innerCssClass="k-button-icon"
                    [name]="icon"
                    [svgIcon]="svgIcon">
                </kendo-icon-wrapper>
            }
            @if (imageUrl) {
                <span class="k-button-icon k-icon">
                    <img [src]="imageUrl" class="k-image" role="presentation" />
                </span>
            }
            @if (iconClass) {
                <span class="k-button-icon" [ngClass]="iconClass"></span>
            }
        </ng-template>
        @if (iconPosition === 'start') {
            <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        }
        <span class="k-button-text">
            <ng-content></ng-content>
        </span>
        @if (iconPosition === 'end') {
            <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        }
        @if ($any(arrowIcon).iconClass) {
            <span class="k-button-icon" [ngClass]="$any(arrowIcon).iconClass"></span>
        }
        @if (arrowIcon && !$any(arrowIcon).iconClass) {
            <span class="k-button-arrow">
                <kendo-icon-wrapper
                    [name]="$any(arrowIcon).icon || 'chevron-down'"
                    [svgIcon]="$any(arrowIcon).svgIcon || chevronDownIcon">
                </kendo-icon-wrapper>
            </span>
        }

        `,
      standalone: true,
      imports: [IconWrapperComponent, NgClass, NgTemplateOutlet]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: KendoButtonService,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i1.LocalizationService
  }, {
    type: i0.NgZone
  }], {
    arrowIcon: [{
      type: Input
    }],
    toggleable: [{
      type: Input
    }],
    togglable: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    tabIndex: [{
      type: Input
    }],
    imageUrl: [{
      type: Input
    }],
    iconPosition: [{
      type: Input
    }],
    iconClass: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    themeColor: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    selectedChange: [{
      type: Output
    }],
    click: [{
      type: Output
    }],
    iconButtonClass: [{
      type: HostBinding,
      args: ['class.k-icon-button']
    }],
    classDisabled: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    classActive: [{
      type: HostBinding,
      args: ['class.k-selected']
    }],
    getDirection: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    onFocus: [{
      type: HostListener,
      args: ['focus']
    }],
    onBlur: [{
      type: HostListener,
      args: ['blur']
    }]
  });
})();

/**
 * @hidden
 */
class PreventableEvent {
  prevented = false;
  /**
   * Prevents the default action for a specified event.
   * In this way, the source component suppresses the built-in behavior that follows the event.
   */
  preventDefault() {
    this.prevented = true;
  }
  /**
   * If the event is prevented by any of its subscribers, returns `true`.
   *
   * @returns `true` if the default action was prevented. Otherwise, returns `false`.
   */
  isDefaultPrevented() {
    return this.prevented;
  }
}

/**
 * @hidden
 */
const tabindex = 'tabindex';
/**
 * Represents the Kendo UI ButtonGroup component for Angular.
 *
 * @example
 * ```html
 * <kendo-buttongroup>
 *   <button kendoButton>Left</button>
 *   <button kendoButton>Middle</button>
 *   <button kendoButton>Right</button>
 * </kendo-buttongroup>
 * ```
 *
 * @remarks
 * Supported children components are: {@link ButtonComponent}.
 */
class ButtonGroupComponent {
  service;
  renderer;
  element;
  /**
   * To disable a specific button, set **only** its `disabled` property to `true`.
   * If you also set the ButtonGroup `disabled` property, it takes precedence over
   * the `disabled` properties of the underlying buttons and they are ignored.
   */
  disabled;
  /**
   * Sets the selection mode of the ButtonGroup.
   *
   * @default 'multiple'
   */
  selection = 'multiple';
  /**
   * Sets the width of the ButtonGroup.
   * When set, the buttons resize automatically to fill the full width of the group wrapper and acquire the same width.
   */
  width;
  /**
   * Specifies the [`tabIndex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
   *
   * @default 0
   */
  set tabIndex(value) {
    this._tabIndex = value;
    this.currentTabIndex = value;
  }
  get tabIndex() {
    return this._tabIndex;
  }
  /**
   * When set to `true`, the component is a single tab-stop,
   * and focus moves through the inner buttons using the arrow keys.
   *
   * When set to `false`, the inner buttons are part of the natural tab sequence of the page.
   *
   * @default true
   *
   * @remarks
   * This property is related to accessibility.
   */
  navigable = true;
  /**
   * Fires every time keyboard navigation occurs within the ButtonGroup.
   */
  navigate = new EventEmitter();
  buttons;
  _tabIndex = 0;
  currentTabIndex = 0;
  lastFocusedIndex = -1;
  direction;
  subs = new Subscription();
  wrapperClasses = true;
  get disabledClass() {
    return this.disabled;
  }
  get stretchedClass() {
    return !!this.width;
  }
  role = 'group';
  get dir() {
    return this.direction;
  }
  get ariaDisabled() {
    return this.disabled;
  }
  get wrapperWidth() {
    return this.width;
  }
  get wrapperTabIndex() {
    if (this.disabled) {
      return undefined;
    }
    return this.navigable ? this.currentTabIndex : undefined;
  }
  constructor(service, localization, renderer, element) {
    this.service = service;
    this.renderer = renderer;
    this.element = element;
    validatePackage(packageMetadata);
    this.subs.add(localization.changes.subscribe(({
      rtl
    }) => this.direction = rtl ? 'rtl' : 'ltr'));
  }
  ngOnInit() {
    this.subs.add(this.service.buttonClicked$.subscribe(button => {
      let newSelectionValue;
      if (this.isSelectionSingle()) {
        newSelectionValue = true;
        this.deactivate(this.buttons.filter(current => current !== button));
      } else {
        if (this.navigable) {
          this.defocus(this.buttons.toArray());
        }
        newSelectionValue = !button.selected;
      }
      if (button.togglable) {
        button.setSelected(newSelectionValue);
      }
      if (this.navigable) {
        this.currentTabIndex = -1;
        this.renderer.setAttribute(button, tabindex, '0');
      }
    }));
    this.handleSubs('focus', () => this.navigable, this.focusHandler);
    this.handleSubs('keydown', () => this.navigable && !this.disabled, event => this.navigateFocus(event));
    this.handleSubs('focusout', event => this.navigable && event.relatedTarget && event.relatedTarget.parentNode !== this.element.nativeElement, () => {
      this.lastFocusedIndex = this.buttons.toArray().findIndex(button => button.tabIndex !== -1);
      this.defocus(this.buttons.toArray());
      this.currentTabIndex = this.tabIndex;
    });
    this.subs.add(fromEvent(this.element.nativeElement, 'focusout').pipe(filter(event => this.navigable && event.relatedTarget && event.relatedTarget.parentNode !== this.element.nativeElement)).subscribe(() => {
      this.defocus(this.buttons.toArray());
      this.currentTabIndex = this.tabIndex;
    }));
  }
  ngOnChanges(changes) {
    if (isChanged('disabled', changes)) {
      this.buttons.forEach(button => {
        if (isPresent(this.disabled)) {
          button.disabled = this.disabled;
        }
      });
    }
    if (isChanged('navigable', changes)) {
      if (changes['navigable'].currentValue) {
        this.defocus(this.buttons.toArray());
        this.currentTabIndex = 0;
      } else {
        this.currentTabIndex = -1;
        this.buttons.forEach(button => this.renderer.setAttribute(button, tabindex, '0'));
      }
    }
  }
  ngAfterContentInit() {
    if (!this.navigable) {
      return;
    }
    this.defocus(this.buttons.toArray());
  }
  ngAfterViewChecked() {
    if (this.buttons.length) {
      this.renderer.addClass(this.buttons.first.element, 'k-group-start');
      this.renderer.addClass(this.buttons.last.element, 'k-group-end');
    }
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  ngAfterContentChecked() {
    this.verifySettings();
  }
  navigateFocus(event) {
    const navigationButtons = this.buttons.toArray().filter(button => !button.disabled);
    const focusedIndex = navigationButtons.findIndex(current => current.element.tabIndex !== -1);
    const firstIndex = 0;
    const lastIndex = navigationButtons.length - 1;
    const eventArgs = new PreventableEvent();
    const code = normalizeKeys(event);
    if (code === Keys.ArrowRight && focusedIndex < lastIndex) {
      this.navigate.emit(eventArgs);
      if (!eventArgs.isDefaultPrevented()) {
        this.defocus(navigationButtons);
        this.focus(navigationButtons.filter((_current, index) => {
          return index === focusedIndex + 1;
        }));
      }
    }
    if (code === Keys.ArrowLeft && focusedIndex > firstIndex) {
      this.navigate.emit(eventArgs);
      if (!eventArgs.isDefaultPrevented()) {
        this.defocus(navigationButtons);
        this.focus(navigationButtons.filter((_current, index) => {
          return index === focusedIndex - 1;
        }));
      }
    }
  }
  deactivate(buttons) {
    buttons.forEach(button => {
      button.setSelected(false);
      if (this.navigable) {
        this.renderer.setAttribute(button, tabindex, '-1');
      }
    });
  }
  activate(buttons) {
    buttons.forEach(button => {
      button.setSelected(true);
      if (this.navigable) {
        this.renderer.setAttribute(button, tabindex, '0');
      }
      button.focus();
    });
  }
  defocus(buttons) {
    buttons.forEach(button => {
      this.renderer.setAttribute(button, tabindex, '-1');
    });
  }
  focus(buttons) {
    buttons.forEach(button => {
      this.renderer.setAttribute(button, tabindex, '0');
      button.focus();
    });
  }
  verifySettings() {
    if (isDevMode()) {
      if (this.isSelectionSingle() && this.buttons.filter(button => button.selected).length > 1) {
        throw new Error('Having multiple selected buttons with single selection mode is not supported');
      }
    }
  }
  isSelectionSingle() {
    return this.selection === 'single';
  }
  handleSubs(eventName, predicate, handler) {
    this.subs.add(fromEvent(this.element.nativeElement, eventName).pipe(filter(predicate)).subscribe(handler));
  }
  focusHandler = () => {
    this.currentTabIndex = -1;
    this.defocus(this.buttons.toArray());
    const firstFocusableIndex = this.buttons.toArray().findIndex(current => !current.disabled);
    const index = this.lastFocusedIndex === -1 ? firstFocusableIndex : this.lastFocusedIndex;
    this.focus(this.buttons.filter((_current, i) => {
      return i === index;
    }));
  };
  static ɵfac = function ButtonGroupComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonGroupComponent)(i0.ɵɵdirectiveInject(KendoButtonService), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ButtonGroupComponent,
    selectors: [["kendo-buttongroup"]],
    contentQueries: function ButtonGroupComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ButtonComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttons = _t);
      }
    },
    hostVars: 12,
    hostBindings: function ButtonGroupComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role)("dir", ctx.dir)("aria-disabled", ctx.ariaDisabled)("tabindex", ctx.wrapperTabIndex);
        i0.ɵɵstyleProp("width", ctx.wrapperWidth);
        i0.ɵɵclassProp("k-button-group", ctx.wrapperClasses)("k-disabled", ctx.disabledClass)("k-button-group-stretched", ctx.stretchedClass);
      }
    },
    inputs: {
      disabled: "disabled",
      selection: "selection",
      width: "width",
      tabIndex: "tabIndex",
      navigable: "navigable"
    },
    outputs: {
      navigate: "navigate"
    },
    exportAs: ["kendoButtonGroup"],
    features: [i0.ɵɵProvidersFeature([KendoButtonService, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.buttongroup'
    }]), i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c3,
    decls: 1,
    vars: 0,
    template: function ButtonGroupComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c2);
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonGroupComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoButtonGroup',
      providers: [KendoButtonService, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.buttongroup'
      }],
      selector: 'kendo-buttongroup',
      template: `
        <ng-content select="[kendoButton]"></ng-content>
    `,
      standalone: true
    }]
  }], () => [{
    type: KendoButtonService
  }, {
    type: i1.LocalizationService
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }], {
    disabled: [{
      type: Input,
      args: ['disabled']
    }],
    selection: [{
      type: Input,
      args: ['selection']
    }],
    width: [{
      type: Input,
      args: ['width']
    }],
    tabIndex: [{
      type: Input
    }],
    navigable: [{
      type: Input
    }],
    navigate: [{
      type: Output
    }],
    buttons: [{
      type: ContentChildren,
      args: [ButtonComponent]
    }],
    wrapperClasses: [{
      type: HostBinding,
      args: ['class.k-button-group']
    }],
    disabledClass: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    stretchedClass: [{
      type: HostBinding,
      args: ['class.k-button-group-stretched']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    dir: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    ariaDisabled: [{
      type: HostBinding,
      args: ['attr.aria-disabled']
    }],
    wrapperWidth: [{
      type: HostBinding,
      args: ['style.width']
    }],
    wrapperTabIndex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }]
  });
})();

/**
 * Displays a Chip that represents an input, attribute, or action.
 *
 * @example
 * ```html
 * <kendo-chip label="Chip Label"></kendo-chip>
 * ```
 */
class ChipComponent {
  element;
  renderer;
  ngZone;
  localizationService;
  /**
   * Sets the label text of the Chip.
   *
   * @remarks
   * This property is related to accessibility.
   */
  label;
  /**
   * Defines the name for an existing icon in a Kendo UI theme.
   * The icon is rendered inside the Chip by a `span.k-icon` element.
   */
  icon;
  /**
   * Defines an [`SVGIcon`](https://www.telerik.com/kendo-angular-ui/components/icons/api/svgicon) to render inside the Chip using
   * a [`KendoSVGIcon`](https://www.telerik.com/kendo-angular-ui/components/icons/api/svgiconcomponent) component.
   */
  svgIcon;
  /**
   * Defines a CSS class, or multiple classes separated by spaces,
   * applied to a `span` element. Use the `iconClass` to add custom icons.
   */
  iconClass;
  /**
   * Use these settings to render an avatar within the Chip.
   */
  avatarSettings;
  /**
   * Specifies the selected state of the Chip.
   * @default false
   */
  selected = false;
  /**
   * Specifies if the Chip is removable.
   * If set to `true`, the Chip renders a remove icon.
   * @default false
   */
  removable = false;
  /**
   * Specifies a custom remove font icon class to render when the Chip is removable.
   * [see example](https://www.telerik.com/kendo-angular-ui/components/styling/icons)
   */
  removeIcon;
  /**
   * Specifies a custom remove SVG icon to render when the Chip is removable.
   */
  removeSvgIcon;
  /**
   * @hidden
   *
   * Determines whether the Chip has a menu.
   */
  hasMenu = false;
  /**
   * @hidden
   *
   * Specifies a custom menu font icon class to render when the Chip has a menu.
   */
  menuIcon;
  /**
   * @hidden
   *
   * Specifies a custom menu SVG icon to render when the Chip has a menu.
   */
  menuSvgIcon;
  /**
   * If set to `true`, the Chip is disabled.
   * @default false
   */
  disabled = false;
  /**
   * Sets the padding of the Chip.
   * See [Chip Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/chip/appearance#size). The default value is set by the Kendo theme.
   */
  set size(size) {
    !this.sizeIsSet && (this.sizeIsSet = true);
    this.handleClasses(size, 'size');
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the Chip.
   * See [Chip Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/chip/appearance#roundness). The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.handleClasses(rounded, 'rounded');
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the background and border styles of the Chip.
   * See [Chip Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/chip/appearance#fill-mode). The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.handleClasses(fillMode, 'fillMode');
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Sets a predefined theme color for the Chip.
   * The theme color applies as a background and border color and adjusts the text color.
   * See [Chip Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/chip/appearance#theme-colors). The default value is set by the Kendo theme.
   */
  set themeColor(themeColor) {
    this.handleThemeColor(themeColor);
    this._themeColor = themeColor;
  }
  get themeColor() {
    return this._themeColor;
  }
  /**
   * Fires when the user clicks the remove icon of the Chip.
   */
  remove = new EventEmitter();
  /**
   * @hidden
   *
   * Fires when the user clicks the menu icon of the Chip.
   */
  menuToggle = new EventEmitter();
  /**
   * Fires when the user clicks the content of the Chip.
   */
  contentClick = new EventEmitter();
  tabIndex = 0;
  hostClass = true;
  get disabledClass() {
    return this.disabled || null;
  }
  get selectedClass() {
    return this.selected;
  }
  get focusedClass() {
    return this.focused;
  }
  /**
   * @hidden
   */
  direction;
  /**
   * @hidden
   */
  defaultRemoveIcon = xCircleIcon;
  /**
   * @hidden
   */
  defaultMenuIcon = moreVerticalIcon;
  /**
   * @hidden
   */
  sizeIsSet = false;
  _size = undefined;
  _rounded = undefined;
  _fillMode = undefined;
  _themeColor = undefined;
  focused = false;
  subs = new Subscription();
  constructor(element, renderer, ngZone, localizationService) {
    this.element = element;
    this.renderer = renderer;
    this.ngZone = ngZone;
    this.localizationService = localizationService;
    validatePackage(packageMetadata);
    this.direction = localizationService.rtl ? 'rtl' : 'ltr';
  }
  ngOnInit() {
    this.subs.add(this.localizationService.changes.subscribe(({
      rtl
    }) => this.direction = rtl ? 'rtl' : 'ltr'));
    this.renderer.setAttribute(this.element.nativeElement, 'role', 'button');
    this.renderer.setAttribute(this.element.nativeElement, 'aria-pressed', `${this.selected}`);
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  ngOnChanges(changes) {
    if (changes?.['selected']) {
      const hasAriaSelected = this.element.nativeElement.hasAttribute('aria-selected');
      if (!hasAriaSelected) {
        this.renderer.setAttribute(this.element.nativeElement, 'aria-pressed', `${this.selected}`);
      }
    }
  }
  ngAfterViewInit() {
    const chip = this.element.nativeElement;
    this.attachElementEventHandlers(chip);
  }
  /**
   * @hidden
   */
  get kendoIconClass() {
    this.verifyIconSettings([this.iconClass]);
    return `k-i-${this.icon}`;
  }
  /**
   * @hidden
   */
  get customIconClass() {
    this.verifyIconSettings([this.icon]);
    return this.iconClass;
  }
  /**
   * @hidden
   */
  get removeIconClass() {
    return this.removeIcon ? this.removeIcon : 'k-i-x-circle';
  }
  /**
   * Focuses the Chip component.
   */
  focus() {
    if (isDocumentAvailable()) {
      this.element.nativeElement.focus();
    }
  }
  /**
   * Blurs the Chip component.
   */
  blur() {
    if (isDocumentAvailable()) {
      this.element.nativeElement.blur();
    }
  }
  /**
   * @hidden
   */
  onRemoveClick(e) {
    if (this.removable) {
      this.remove.emit({
        sender: this,
        originalEvent: e
      });
    }
  }
  /**
   * @hidden
   */
  onMenuClick(e) {
    if (this.hasMenu) {
      this.menuToggle.emit({
        sender: this,
        originalEvent: e
      });
    }
  }
  attachElementEventHandlers(chip) {
    this.ngZone.runOutsideAngular(() => {
      this.subs.add(this.renderer.listen(chip, 'focus', () => {
        this.renderer.addClass(chip, 'k-focus');
      }));
      this.subs.add(this.renderer.listen(chip, 'blur', () => {
        this.renderer.removeClass(chip, 'k-focus');
      }));
      this.subs.add(this.renderer.listen(chip, 'click', e => {
        const isActionClicked = closest(e.target, '.k-chip-action');
        if (!isActionClicked) {
          this.ngZone.run(() => {
            this.contentClick.emit({
              sender: this,
              originalEvent: e
            });
          });
        }
      }));
      this.subs.add(this.renderer.listen(chip, 'keydown', this.keyDownHandler.bind(this)));
    });
  }
  /**
   * @hidden
   */
  verifyIconSettings(iconsToCheck) {
    if (isDevMode()) {
      if (iconsToCheck.filter(icon => icon !== null && icon !== undefined).length > 0) {
        this.renderer.removeClass(this.element.nativeElement, 'k-chip-has-icon');
        throw new Error('Invalid configuration: Having multiple icons is not supported. Only a single icon on a chip can be displayed.');
      }
    }
  }
  handleClasses(value, input) {
    const elem = this.element.nativeElement;
    const classes = getStylingClasses('chip', input, this[input], value);
    if (input === 'fillMode') {
      this.handleThemeColor(this.themeColor);
    }
    if (classes.toRemove) {
      this.renderer.removeClass(elem, classes.toRemove);
    }
    if (classes.toAdd) {
      this.renderer.addClass(elem, classes.toAdd);
    }
  }
  handleThemeColor(value) {
    const elem = this.element.nativeElement;
    const themeColorClass = getThemeColorClasses('chip', this.themeColor, value);
    if (themeColorClass.toRemove) {
      this.renderer.removeClass(elem, themeColorClass.toRemove);
    }
    if (themeColorClass.toAdd) {
      this.renderer.addClass(elem, themeColorClass.toAdd);
    }
  }
  keyDownHandler(e) {
    const code = normalizeKeys(e);
    const isEnterOrSpace = code === Keys.Enter || code === Keys.Space;
    const isDeleteOrBackspace = code === Keys.Delete || code === Keys.Backspace;
    if (this.disabled) {
      return;
    }
    if (isEnterOrSpace) {
      this.ngZone.run(() => {
        this.contentClick.emit({
          sender: this,
          originalEvent: e
        });
      });
    } else if (isDeleteOrBackspace && this.removable) {
      this.ngZone.run(() => {
        this.remove.emit({
          sender: this,
          originalEvent: e
        });
      });
    }
  }
  static ɵfac = function ChipComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChipComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ChipComponent,
    selectors: [["kendo-chip"]],
    hostVars: 11,
    hostBindings: function ChipComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("tabindex", ctx.tabIndex)("aria-disabled", ctx.disabledClass)("dir", ctx.direction);
        i0.ɵɵclassProp("k-chip", ctx.hostClass)("k-disabled", ctx.disabledClass)("k-selected", ctx.selectedClass)("k-focus", ctx.focusedClass);
      }
    },
    inputs: {
      label: "label",
      icon: "icon",
      svgIcon: "svgIcon",
      iconClass: "iconClass",
      avatarSettings: "avatarSettings",
      selected: "selected",
      removable: "removable",
      removeIcon: "removeIcon",
      removeSvgIcon: "removeSvgIcon",
      hasMenu: "hasMenu",
      menuIcon: "menuIcon",
      menuSvgIcon: "menuSvgIcon",
      disabled: "disabled",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      themeColor: "themeColor"
    },
    outputs: {
      remove: "remove",
      menuToggle: "menuToggle",
      contentClick: "contentClick"
    },
    features: [i0.ɵɵProvidersFeature([LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.chip'
    }]), i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c1,
    decls: 7,
    vars: 6,
    consts: [["size", "small", "innerCssClass", "k-chip-icon", 3, "name", "svgIcon"], ["size", "small", "innerCssClass", "k-chip-icon", 3, "customFontClass"], [1, "k-chip-avatar", "k-avatar", 3, "ngStyle"], [1, "k-chip-content"], [1, "k-chip-label"], [1, "k-chip-actions"], [1, "k-avatar-image"], [1, "k-avatar-text", 3, "ngStyle"], [3, "src", "ngStyle"], [1, "k-chip-action", "k-chip-more-action"], [1, "k-chip-action", "k-chip-remove-action"], [1, "k-chip-action", "k-chip-more-action", 3, "click"], ["name", "more-vertical", "size", "small", 3, "svgIcon", "customFontClass"], [1, "k-chip-action", "k-chip-remove-action", 3, "click"], ["name", "x-circle", "size", "small", 3, "svgIcon", "customFontClass"]],
    template: function ChipComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵconditionalCreate(0, ChipComponent_Conditional_0_Template, 1, 2, "kendo-icon-wrapper", 0);
        i0.ɵɵconditionalCreate(1, ChipComponent_Conditional_1_Template, 1, 1, "kendo-icon-wrapper", 1);
        i0.ɵɵconditionalCreate(2, ChipComponent_Conditional_2_Template, 3, 3, "span", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵconditionalCreate(4, ChipComponent_Conditional_4_Template, 2, 1, "span", 4);
        i0.ɵɵconditionalCreate(5, ChipComponent_Conditional_5_Template, 1, 0);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(6, ChipComponent_Conditional_6_Template, 3, 2, "span", 5);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.icon || ctx.svgIcon ? 0 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.iconClass ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.avatarSettings ? 2 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.label ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.label ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.hasMenu || ctx.removable ? 6 : -1);
      }
    },
    dependencies: [NgStyle, IconWrapperComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChipComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-chip',
      template: `
        @if (icon || svgIcon) {
          <kendo-icon-wrapper
            size="small"
            innerCssClass="k-chip-icon"
            [name]="icon"
          [svgIcon]="svgIcon"></kendo-icon-wrapper>
        }

        @if (iconClass) {
          <kendo-icon-wrapper
            size="small"
            innerCssClass="k-chip-icon"
          [customFontClass]="customIconClass"></kendo-icon-wrapper>
        }
        @if (avatarSettings) {
          <span
            class="k-chip-avatar k-avatar"
            [ngStyle]="avatarSettings.cssStyle">
            @if (avatarSettings?.imageSrc) {
              <span class="k-avatar-image">
                <img src="{{ avatarSettings.imageSrc }}" [ngStyle]="avatarSettings.imageCssStyle" [attr.alt]="avatarSettings.imageAltText" />
              </span>
            }
            @if (avatarSettings?.initials) {
              <span class="k-avatar-text" [ngStyle]="avatarSettings.initialsCssStyle">{{ avatarSettings.initials.substring(0, 2) }}</span>
            }
          </span>
        }

        <span class="k-chip-content">
          @if (label) {
            <span class="k-chip-label">
              {{ label }}
            </span>
          }
          @if (!label) {
            <ng-content></ng-content>
          }
        </span>

        @if (hasMenu || removable) {
          <span class="k-chip-actions">
            @if (hasMenu) {
              <span class="k-chip-action k-chip-more-action"
                (click)="onMenuClick($event)">
                <kendo-icon-wrapper
                  name="more-vertical"
                  size="small"
                  [svgIcon]="defaultMenuIcon || menuSvgIcon"
                [customFontClass]="menuIcon"></kendo-icon-wrapper>
              </span>
            }
            @if (removable) {
              <span class="k-chip-action k-chip-remove-action"
                (click)="onRemoveClick($event)">
                <kendo-icon-wrapper
                  name="x-circle"
                  size="small"
                  [svgIcon]="removeSvgIcon || defaultRemoveIcon"
                [customFontClass]="removeIcon"></kendo-icon-wrapper>
              </span>
            }
          </span>
        }
        `,
      providers: [LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.chip'
      }],
      standalone: true,
      imports: [NgStyle, IconWrapperComponent]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i0.NgZone
  }, {
    type: i1.LocalizationService
  }], {
    label: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    iconClass: [{
      type: Input
    }],
    avatarSettings: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    removable: [{
      type: Input
    }],
    removeIcon: [{
      type: Input
    }],
    removeSvgIcon: [{
      type: Input
    }],
    hasMenu: [{
      type: Input
    }],
    menuIcon: [{
      type: Input
    }],
    menuSvgIcon: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    themeColor: [{
      type: Input
    }],
    remove: [{
      type: Output
    }],
    menuToggle: [{
      type: Output
    }],
    contentClick: [{
      type: Output
    }],
    tabIndex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    hostClass: [{
      type: HostBinding,
      args: ['class.k-chip']
    }],
    disabledClass: [{
      type: HostBinding,
      args: ['attr.aria-disabled']
    }, {
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    selectedClass: [{
      type: HostBinding,
      args: ['class.k-selected']
    }],
    focusedClass: [{
      type: HostBinding,
      args: ['class.k-focus']
    }],
    direction: [{
      type: HostBinding,
      args: ['attr.dir']
    }]
  });
})();

/**
 * Represents the Kendo UI ChipList component for Angular. Displays a list of Chip components.
 *
 * @example
 * ```html
 * <kendo-chiplist selection="multiple">
 *   <kendo-chip label="Chip 1"></kendo-chip>
 *   <kendo-chip label="Chip 2"></kendo-chip>
 * </kendo-chiplist>
 * ```
 * @remarks
 * Supported children components are: {@link ChipComponent}.
 */
class ChipListComponent {
  localizationService;
  renderer;
  element;
  ngZone;
  hostClass = true;
  /**
   * @hidden
   */
  orientation = 'horizontal';
  /**
   * @hidden
   */
  direction;
  /**
   * Sets the selection mode of the ChipList.
   *
   * @default 'none'
   */
  selection = 'none';
  /**
   * Sets the gap between the Chips in the ChipList.
   * See [ChipList Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/chiplist/appearance#size). The default value is set by the Kendo theme.
   */
  set size(size) {
    this.handleClasses(size, 'size');
    this.chips?.forEach(chip => this.setChipSize(chip, size));
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Fires when the ChipList selection changes.
   */
  selectedChange = new EventEmitter();
  /**
   * Fires when the user clicks the remove icon of a Chip in the ChipList.
   */
  remove = new EventEmitter();
  chips;
  get multiple() {
    return this.selection === 'multiple' ? true : undefined;
  }
  /**
   * @hidden
   */
  role = 'listbox';
  dynamicRTLSubscription;
  _size = undefined;
  subs = new Subscription();
  _navigable = true;
  /**
   * @hidden
   */
  onClick($event) {
    const target = $event.target;
    const isRemoveClicked = closest(target, '.k-chip-remove-action');
    const clickedChip = closest(target, '.k-chip');
    const chip = this.chips.find(chip => clickedChip === chip.element.nativeElement);
    this.currentActiveIndex = this.chips.toArray().indexOf(chip);
    chip?.focus();
    if (chip && this.navigable) {
      this.chips.forEach(c => {
        this.renderer.setAttribute(c.element.nativeElement, 'tabindex', '-1');
      });
      this.renderer.setAttribute(chip.element.nativeElement, 'tabindex', '0');
    }
    if (isRemoveClicked && clickedChip) {
      const removeEventArgs = {
        sender: this,
        originalEvent: $event,
        removedChip: chip
      };
      this.remove.emit(removeEventArgs);
    }
    if (this.selection !== 'none' && clickedChip && !isRemoveClicked) {
      this.setSelection(chip);
    }
  }
  /**
   * By default, keyboard navigation is available through arrow keys and roving tabindex.
   * When set to `false`, all chips are part of the default tabbing sequence of the page.
   *
   * @default true
   *
   * @remarks
   * This property is related to accessibility.
   */
  set navigable(value) {
    this._navigable = value;
    this.chips?.forEach(c => this.renderer.setAttribute(c.element.nativeElement, 'tabindex', value ? '-1' : '0'));
    if (this.chips?.first) {
      this.renderer.setAttribute(this.chips.first.element.nativeElement, 'tabindex', '0');
    }
  }
  get navigable() {
    return this._navigable;
  }
  currentActiveIndex = 0;
  constructor(localizationService, renderer, element, ngZone) {
    this.localizationService = localizationService;
    this.renderer = renderer;
    this.element = element;
    this.ngZone = ngZone;
    validatePackage(packageMetadata);
    this.direction = localizationService.rtl ? 'rtl' : 'ltr';
  }
  ngOnInit() {
    this.dynamicRTLSubscription = this.localizationService.changes.subscribe(({
      rtl
    }) => this.direction = rtl ? 'rtl' : 'ltr');
  }
  ngAfterViewInit() {
    const stylingInputs = ['size'];
    stylingInputs.forEach(input => {
      this.handleClasses(this[input], input);
    });
    this.attachElementEventHandlers();
    this.updateChips();
  }
  ngAfterContentInit() {
    this.subs.add(this.chips?.changes.subscribe(() => this.updateChips()));
  }
  ngOnDestroy() {
    if (this.dynamicRTLSubscription) {
      this.dynamicRTLSubscription.unsubscribe();
    }
    this.subs.unsubscribe();
  }
  selectedChips() {
    return this.chips.reduce((acc, cur, idx) => {
      return cur.selected ? acc.concat(idx) : acc;
    }, []);
  }
  /**
   * Updates the selection on click of a Chip. Emits events.
   */
  setSelection(chip) {
    if (this.selection === 'single') {
      this.clearSelection(chip);
    }
    chip.selected = !chip.selected;
    const chipEl = chip.element.nativeElement;
    this.renderer.setAttribute(chipEl, 'aria-selected', `${chip.selected}`);
    this.selectedChange.emit(this.selectedChips());
  }
  clearSelection(chip) {
    this.chips.forEach(c => {
      if (chip !== c) {
        c.selected = false;
        this.renderer.setAttribute(c.element.nativeElement, 'aria-selected', 'false');
      }
    });
  }
  handleClasses(value, input) {
    const elem = this.element.nativeElement;
    const classes = getStylingClasses('chip-list', input, this[input], value);
    if (classes.toRemove) {
      this.renderer.removeClass(elem, classes.toRemove);
    }
    if (classes.toAdd) {
      this.renderer.addClass(elem, classes.toAdd);
    }
  }
  attachElementEventHandlers() {
    const chiplist = this.element.nativeElement;
    this.ngZone.runOutsideAngular(() => {
      this.subs.add(this.renderer.listen(chiplist, 'keydown', this.keyDownHandler.bind(this)));
    });
  }
  keyDownHandler(e) {
    // on some keyboards, arrow keys, page up/down, home/end, Enter are mapped to numpad keys
    const code = normalizeKeys(e);
    const isEnterOrSpace = code === Keys.Enter || code === Keys.Space;
    const isDeleteOrBackspace = code === Keys.Delete || code === Keys.Backspace;
    const isLeftArrow = code === Keys.ArrowLeft;
    const isRightArrow = code === Keys.ArrowRight;
    if (isEnterOrSpace) {
      const target = e.target;
      const clickedChip = closest(target, '.k-chip');
      const chip = this.chips.find(chip => clickedChip === chip.element.nativeElement);
      this.currentActiveIndex = this.chips.toArray().findIndex(chip => clickedChip === chip.element.nativeElement);
      if (this.selection !== 'none' && clickedChip) {
        this.ngZone.run(() => {
          this.setSelection(chip);
        });
      }
    } else if (isDeleteOrBackspace) {
      const target = e.target;
      const clickedChip = closest(target, '.k-chip');
      const chip = this.chips.find(chip => clickedChip === chip.element.nativeElement);
      if (clickedChip) {
        const removeEventArgs = {
          sender: this,
          originalEvent: e,
          removedChip: chip
        };
        this.ngZone.run(() => {
          this.remove.emit(removeEventArgs);
        });
      }
    } else if (isLeftArrow) {
      this.handleArrowKeys('left');
    } else if (isRightArrow) {
      this.handleArrowKeys('right');
    }
  }
  handleArrowKeys(direction) {
    if (!this.navigable) {
      return;
    }
    const directionDelta = direction === 'left' ? -1 : 1;
    this.currentActiveIndex = this.currentActiveIndex + directionDelta;
    if (this.currentActiveIndex >= this.chips.length) {
      this.currentActiveIndex = 0;
    } else if (this.currentActiveIndex < 0) {
      this.currentActiveIndex = this.chips.length - 1;
    }
    this.chips.forEach((chip, idx) => {
      this.renderer.setAttribute(chip.element.nativeElement, 'tabindex', '-1');
      if (idx === this.currentActiveIndex) {
        this.renderer.setAttribute(chip.element.nativeElement, 'tabindex', '0');
        chip.focus();
      }
    });
  }
  updateChips() {
    this.normalizeActiveIndex();
    this.chips.forEach((chip, idx) => {
      const chipEl = chip.element.nativeElement;
      this.renderer.removeAttribute(chipEl, 'aria-pressed');
      if (this.role === 'listbox') {
        this.renderer.setAttribute(chipEl, 'role', 'option');
        if (this.selection !== 'none') {
          this.renderer.setAttribute(chipEl, 'aria-selected', `${chip.selected}`);
        }
      }
      if (!this.navigable) {
        return;
      }
      this.renderer.setAttribute(chipEl, 'tabindex', '-1');
      if (idx === this.currentActiveIndex) {
        this.renderer.setAttribute(chipEl, 'tabindex', '0');
        if (isDocumentAvailable() && document.activeElement.closest('.k-chip-list')) {
          chip.focus();
        }
      }
      if (chip.removable) {
        this.renderer.setAttribute(chipEl, 'aria-keyshortcuts', 'Enter Delete');
      }
      this.setChipSize(chip, this.size);
    });
  }
  normalizeActiveIndex() {
    if (this.currentActiveIndex >= this.chips.length) {
      this.currentActiveIndex = Math.max(this.chips.length - 1, 0);
    }
  }
  setChipSize(chip, size) {
    const hasSize = chip.sizeIsSet;
    if (!hasSize && chip.size !== size) {
      chip.size = size;
    }
    if (!hasSize) {
      chip.sizeIsSet = false;
    }
  }
  static ɵfac = function ChipListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChipListComponent)(i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ChipListComponent,
    selectors: [["kendo-chiplist"], ["kendo-chip-list"]],
    contentQueries: function ChipListComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ChipComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chips = _t);
      }
    },
    hostVars: 6,
    hostBindings: function ChipListComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function ChipListComponent_click_HostBindingHandler($event) {
          return ctx.onClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-orientation", ctx.orientation)("dir", ctx.direction)("aria-multiselectable", ctx.multiple)("role", ctx.role);
        i0.ɵɵclassProp("k-chip-list", ctx.hostClass);
      }
    },
    inputs: {
      orientation: "orientation",
      selection: "selection",
      size: "size",
      role: "role",
      navigable: "navigable"
    },
    outputs: {
      selectedChange: "selectedChange",
      remove: "remove"
    },
    features: [i0.ɵɵProvidersFeature([LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.chiplist'
    }])],
    ngContentSelectors: _c1,
    decls: 1,
    vars: 0,
    template: function ChipListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChipListComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-chiplist, kendo-chip-list',
      template: `
        <ng-content></ng-content>
    `,
      providers: [LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.chiplist'
      }],
      standalone: true
    }]
  }], () => [{
    type: i1.LocalizationService
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }, {
    type: i0.NgZone
  }], {
    hostClass: [{
      type: HostBinding,
      args: ['class.k-chip-list']
    }],
    orientation: [{
      type: HostBinding,
      args: ['attr.aria-orientation']
    }, {
      type: Input
    }],
    direction: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    selection: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    selectedChange: [{
      type: Output
    }],
    remove: [{
      type: Output
    }],
    chips: [{
      type: ContentChildren,
      args: [ChipComponent]
    }],
    multiple: [{
      type: HostBinding,
      args: ['attr.aria-multiselectable']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }, {
      type: Input
    }],
    onClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }],
    navigable: [{
      type: Input
    }]
  });
})();

/**
 * Renders the list item content.
 *
 * To define the item template, nest a `<ng-template>` tag with the `kendo<ComponentName>ItemTemplate` directive inside the component tag.
 *
 * - Use the `kendoDropDownButtonItemTemplate` directive for the DropDownButton.
 * - Use the `kendoSplitButtonItemTemplate` directive for the SplitButton.
 *
 * The template context is set to the current component. Use the `let-dataItem` directive to reference the current data item.
 *
 * @example
 * ```html
 * <kendo-splitbutton [data]="listItems">
 *   <ng-template kendoSplitButtonItemTemplate let-dataItem>
 *     <span>{{dataItem}} option</span>
 *   </ng-template>
 * </kendo-splitbutton>
 * <kendo-dropdownbutton [data]="listItems">
 *   <ng-template kendoDropDownButtonItemTemplate let-dataItem>
 *     <span>{{dataItem}} option</span>
 *   </ng-template>
 * </kendo-dropdownbutton>
 * ```
 *
 * For more examples, refer to the article on the [DropDownButton templates](https://www.telerik.com/kendo-angular-ui/components/buttons/dropdownbutton/items-and-templates).
 */
class ButtonItemTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function ButtonItemTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonItemTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ButtonItemTemplateDirective,
    selectors: [["", "kendoDropDownButtonItemTemplate", ""], ["", "kendoSplitButtonItemTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonItemTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownButtonItemTemplate],[kendoSplitButtonItemTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * @hidden
 */
class FocusService {
  onFocus = new EventEmitter();
  focusedIndex;
  isFocused(index) {
    return index === this.focused;
  }
  focus(index) {
    if (this.isFocused(index)) {
      return;
    }
    this.focused = index;
    this.onFocus.emit(index);
  }
  resetFocus() {
    this.focused = -1;
  }
  get focused() {
    return this.focusedIndex;
  }
  set focused(index) {
    this.focusedIndex = index;
    this.onFocus.emit(index);
  }
  static ɵfac = function FocusService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FocusService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FocusService,
    factory: FocusService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FocusService, [{
    type: Injectable
  }], null, null);
})();

/**
 * @hidden
 */
var KeyEvents;
(function (KeyEvents) {
  KeyEvents[KeyEvents["keydown"] = 0] = "keydown";
  KeyEvents[KeyEvents["keypress"] = 1] = "keypress";
  KeyEvents[KeyEvents["keyup"] = 2] = "keyup";
})(KeyEvents || (KeyEvents = {}));

/**
 * @hidden
 */
var NavigationAction;
(function (NavigationAction) {
  NavigationAction[NavigationAction["Undefined"] = 0] = "Undefined";
  NavigationAction[NavigationAction["Open"] = 1] = "Open";
  NavigationAction[NavigationAction["Close"] = 2] = "Close";
  NavigationAction[NavigationAction["Enter"] = 3] = "Enter";
  NavigationAction[NavigationAction["EnterPress"] = 4] = "EnterPress";
  NavigationAction[NavigationAction["EnterUp"] = 5] = "EnterUp";
  NavigationAction[NavigationAction["Tab"] = 6] = "Tab";
  NavigationAction[NavigationAction["Esc"] = 7] = "Esc";
  NavigationAction[NavigationAction["Navigate"] = 8] = "Navigate";
})(NavigationAction || (NavigationAction = {}));

/**
 * @hidden
 */
const NAVIGATION_CONFIG = new InjectionToken('navigation.config');

/**
 * @hidden
 */
class NavigationService {
  navigate = new EventEmitter();
  open = new EventEmitter();
  close = new EventEmitter();
  enter = new EventEmitter();
  enterpress = new EventEmitter();
  enterup = new EventEmitter();
  tab = new EventEmitter();
  esc = new EventEmitter();
  useLeftRightArrows;
  constructor(config) {
    this.useLeftRightArrows = config.useLeftRightArrows;
  }
  process(args) {
    const keyCode = args.code;
    const keyEvent = args.keyEvent;
    let index;
    let action = NavigationAction.Undefined;
    if (keyEvent === KeyEvents.keyup) {
      if (this.isEnterOrSpace(keyCode)) {
        action = NavigationAction.EnterUp;
      }
    } else {
      if (args.altKey && keyCode === Keys.ArrowDown) {
        action = NavigationAction.Open;
      } else if (args.altKey && keyCode === Keys.ArrowUp) {
        action = NavigationAction.Close;
      } else if (this.isEnterOrSpace(keyCode)) {
        action = NavigationAction.Enter;
      } else if (keyCode === Keys.Escape) {
        action = NavigationAction.Esc;
      } else if (keyCode === Keys.Tab) {
        action = NavigationAction.Tab;
      } else if (keyCode === Keys.ArrowUp || this.useLeftRightArrows && keyCode === Keys.ArrowLeft) {
        const step = args.flipNavigation ? 1 : -1;
        const start = args.flipNavigation ? args.min : args.max;
        const end = args.flipNavigation ? args.max : args.min;
        index = this.next({
          current: args.current,
          start: start,
          end: end,
          step: step
        });
        action = NavigationAction.Navigate;
      } else if (keyCode === Keys.ArrowDown || this.useLeftRightArrows && keyCode === Keys.ArrowRight) {
        const step = args.flipNavigation ? -1 : 1;
        const start = args.flipNavigation ? args.max : args.min;
        const end = args.flipNavigation ? args.min : args.max;
        index = this.next({
          current: args.current,
          start: start,
          end: end,
          step: step
        });
        action = NavigationAction.Navigate;
      } else if (keyCode === Keys.Home) {
        index = args.min;
        action = NavigationAction.Navigate;
      } else if (keyCode === Keys.End) {
        index = args.max;
        action = NavigationAction.Navigate;
      }
    }
    if (action !== NavigationAction.Undefined) {
      this[NavigationAction[action].toLowerCase()].emit({
        index,
        target: args.target,
        esc: action === NavigationAction.Esc
      });
    }
    return action;
  }
  isEnterOrSpace(keyCode) {
    return keyCode === Keys.Enter || keyCode === Keys.Space;
  }
  next(args) {
    if (!isPresent(args.current)) {
      return args.start;
    } else {
      return args.current !== args.end ? args.current + args.step : args.end;
    }
  }
  static ɵfac = function NavigationService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavigationService)(i0.ɵɵinject(NAVIGATION_CONFIG));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NavigationService,
    factory: NavigationService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationService, [{
    type: Injectable
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [NAVIGATION_CONFIG]
    }]
  }], null);
})();

/**
 * @hidden
 */
class PopupContainerService {
  container;
  template;
  static ɵfac = function PopupContainerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PopupContainerService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PopupContainerService,
    factory: PopupContainerService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopupContainerService, [{
    type: Injectable
  }], null, null);
})();

/**
 * @hidden
 */
class FocusableDirective {
  focusService;
  renderer;
  index;
  element;
  subs = new Subscription();
  constructor(focusService, elementRef, renderer) {
    this.focusService = focusService;
    this.renderer = renderer;
    this.element = elementRef.nativeElement;
    this.subscribeEvents();
  }
  ngOnInit() {
    if (this.index === this.focusService.focused) {
      this.renderer.addClass(this.element, 'k-focus');
    } else {
      this.renderer.removeClass(this.element, 'k-focus');
    }
  }
  /**
   * @hidden
   */
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  subscribeEvents() {
    if (!isDocumentAvailable()) {
      return;
    }
    this.subs.add(this.focusService.onFocus.subscribe(index => {
      if (this.index === index) {
        this.renderer.addClass(this.element, 'k-focus');
        this.renderer.setAttribute(this.element, 'tabindex', '0');
        this.element.focus();
      } else {
        this.renderer.setAttribute(this.element, 'tabindex', '-1');
        this.renderer.removeClass(this.element, 'k-focus');
      }
    }));
  }
  static ɵfac = function FocusableDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FocusableDirective)(i0.ɵɵdirectiveInject(FocusService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FocusableDirective,
    selectors: [["", "kendoButtonFocusable", ""]],
    inputs: {
      index: "index"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FocusableDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoButtonFocusable]',
      standalone: true
    }]
  }], () => [{
    type: FocusService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    index: [{
      type: Input
    }]
  });
})();

/**
 * @hidden
 */
class ListComponent {
  data;
  textField;
  itemTemplate;
  onItemClick = new EventEmitter();
  onItemBlur = new EventEmitter();
  set size(size) {
    if (size) {
      this.sizeClass = `k-menu-group-${SIZES[size]}`;
    } else {
      this.sizeClass = '';
    }
  }
  sizeClass = '';
  constructor() {
    validatePackage(packageMetadata);
  }
  getText(dataItem) {
    if (dataItem) {
      return this.textField ? dataItem[this.textField] : dataItem.text || dataItem;
    }
    return undefined;
  }
  getIconClasses(dataItem) {
    const icon = dataItem.icon ? 'k-icon k-i-' + dataItem.icon : undefined;
    const classes = {};
    classes[icon || dataItem.iconClass] = true;
    return classes;
  }
  onClick(index) {
    this.onItemClick.emit(index);
  }
  onBlur() {
    this.onItemBlur.emit();
  }
  static ɵfac = function ListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ListComponent,
    selectors: [["kendo-button-list"]],
    inputs: {
      data: "data",
      textField: "textField",
      itemTemplate: "itemTemplate",
      size: "size"
    },
    outputs: {
      onItemClick: "onItemClick",
      onItemBlur: "onItemBlur"
    },
    decls: 3,
    vars: 1,
    consts: [["role", "list", 1, "k-menu-group", 3, "ngClass"], ["kendoButtonFocusable", "", "tabindex", "-1", "role", "listitem", 1, "k-item", "k-menu-item", 3, "index", "k-first", "k-last"], ["kendoButtonFocusable", "", "tabindex", "-1", "role", "listitem", 1, "k-item", "k-menu-item", 3, "click", "blur", "index"], [1, "k-link", "k-menu-link", 3, "k-disabled", "ngClass"], [1, "k-link", "k-menu-link", 3, "ngClass"], [3, "templateContext"], [3, "name", "svgIcon", "customFontClass"], [1, "k-image", 3, "src", "alt"], [1, "k-menu-link-text"]],
    template: function ListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵrepeaterCreate(1, ListComponent_For_2_Template, 3, 8, "li", 1, i0.ɵɵrepeaterTrackByIdentity);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.sizeClass);
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.data);
      }
    },
    dependencies: [NgClass, FocusableDirective, TemplateContextDirective, IconWrapperComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-button-list',
      template: `
        <ul class="k-menu-group" role="list" [ngClass]="sizeClass">
          @for (dataItem of data; track dataItem; let index = $index; let isFirst = $first; let isLast = $last) {
            <li kendoButtonFocusable
              [index]="index"
              tabindex="-1"
              class="k-item k-menu-item"
              [class.k-first]="isFirst"
              [class.k-last]="isLast"
              role="listitem"
              [attr.aria-disabled]="dataItem.disabled || null"
              (click)="$event.stopImmediatePropagation(); onClick(index);"
              (blur)="onBlur()">
              @if (itemTemplate?.templateRef) {
                <span
                  class="k-link k-menu-link"
                  [class.k-disabled]="dataItem.disabled"
                  [ngClass]="dataItem.cssClass">
                  <ng-template
                    [templateContext]="{ templateRef: itemTemplate?.templateRef, $implicit: dataItem }"
                  ></ng-template>
                </span>
              }
              @if (!itemTemplate?.templateRef) {
                <span
                  class="k-link k-menu-link"
                  [class.k-disabled]="dataItem.disabled"
                  [ngClass]="dataItem.cssClass">
                  @if (dataItem.icon || dataItem.iconClass || dataItem.svgIcon) {
                    <kendo-icon-wrapper
                      [name]="dataItem.icon"
                      [svgIcon]="dataItem.svgIcon"
                      [customFontClass]="dataItem.iconClass"
                    ></kendo-icon-wrapper>
                  }
                  @if (dataItem.imageUrl) {
                    <img
                      class="k-image"
                      [src]="dataItem.imageUrl"
                      [alt]="dataItem.imageAlt"
                      >
                  }
                  @if (getText(dataItem)) {
                    <span class="k-menu-link-text">
                      {{ getText(dataItem) }}
                    </span>
                  }
                </span>
              }
            </li>
          }
        </ul>
        `,
      standalone: true,
      imports: [NgClass, FocusableDirective, TemplateContextDirective, IconWrapperComponent]
    }]
  }], () => [], {
    data: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    itemTemplate: [{
      type: Input
    }],
    onItemClick: [{
      type: Output
    }],
    onItemBlur: [{
      type: Output
    }],
    size: [{
      type: Input
    }]
  });
})();

/**
 * @hidden
 */
class ListButton extends MultiTabStop {
  focusService;
  navigationService;
  wrapperRef;
  _zone;
  popupService;
  elRef;
  cdr;
  containerService;
  listId = guid();
  buttonId = guid();
  _data;
  _open = false;
  _disabled = false;
  _active = false;
  _popupSettings = {
    animate: true,
    popupClass: ''
  };
  _isFocused = false;
  _itemClick;
  _blur;
  wrapper;
  subs = new Subscription();
  direction;
  popupRef;
  popupSubs = new Subscription();
  button;
  buttonList;
  popupTemplate;
  container;
  /**
   * Sets the disabled state of the DropDownButton.
   * When `true`, the button is disabled and cannot be interacted with.
   */
  set disabled(value) {
    if (value && this.openState) {
      this.openState = false;
    }
    this._disabled = value;
  }
  get disabled() {
    return this._disabled;
  }
  /**
   * Specifies the [`tabIndex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
   * Determines the order of focus when navigating with the keyboard.
   *
   * @default 0
   */
  tabIndex = 0;
  /**
   * The CSS classes applied to the main button.
   * Supports the same values as [`ngClass`](link:site.data.urls.angular['ngclassapi']).
   */
  buttonClass;
  /**
   * Fires when the popup is about to open.
   * This event is preventable. Canceling the event keeps the popup closed.
   */
  open = new EventEmitter();
  /**
   * Fires when the popup is about to close.
   * This event is preventable. Canceling the event keeps the popup open.
   */
  close = new EventEmitter();
  /**
   * Needed by the kendoToggleButtonTabStop directive
   *
   * @hidden
   */
  escape = new EventEmitter();
  /**
   * @hidden
   */
  get componentTabIndex() {
    return this.disabled ? -1 : this.tabIndex;
  }
  get appendTo() {
    const {
      appendTo
    } = this.popupSettings;
    if (!appendTo || appendTo === 'root') {
      return undefined;
    }
    return appendTo === 'component' ? this.containerService.container : appendTo;
  }
  /**
   * Configures the popup of the DropDownButton.
   */
  set popupSettings(settings) {
    this._popupSettings = {
      animate: true,
      popupClass: '',
      ...settings
    };
  }
  get popupSettings() {
    return this._popupSettings;
  }
  /**
   * @hidden
   */
  get anchorAlign() {
    const align = {
      horizontal: this.popupSettings.align || 'left',
      vertical: 'bottom'
    };
    if (this.direction === 'rtl' && !isPresent(this.popupSettings.align)) {
      align.horizontal = 'right';
    }
    return align;
  }
  /**
   * @hidden
   */
  get popupAlign() {
    const align = {
      horizontal: this.popupSettings.align || 'left',
      vertical: 'top'
    };
    if (this.direction === 'rtl' && !isPresent(this.popupSettings.align)) {
      align.horizontal = 'right';
    }
    return align;
  }
  isClosePrevented = false;
  constructor(focusService, navigationService, wrapperRef, _zone, popupService, elRef, localization, cdr, containerService) {
    super();
    this.focusService = focusService;
    this.navigationService = navigationService;
    this.wrapperRef = wrapperRef;
    this._zone = _zone;
    this.popupService = popupService;
    this.elRef = elRef;
    this.cdr = cdr;
    this.containerService = containerService;
    validatePackage(packageMetadata);
    this.focusService = focusService;
    this.navigationService = navigationService;
    this.wrapper = wrapperRef.nativeElement;
    this.subs.add(localization.changes.subscribe(({
      rtl
    }) => this.direction = rtl ? 'rtl' : 'ltr'));
    this.subscribeEvents();
  }
  ngOnChanges(changes) {
    if (isChanged("popupSettings", changes) && isPresent(this.popupRef)) {
      const popup = this.popupRef.popup.instance;
      const newSettings = changes['popupSettings'].currentValue;
      popup.popupClass = newSettings.popupClass;
      popup.animate = newSettings.animate;
      popup.popupAlign = this.popupAlign;
    }
  }
  get popupClasses() {
    const popupClasses = ['k-menu-popup'];
    if (!this._popupSettings.popupClass) {
      return popupClasses.join(' ');
    }
    const parsedPopupClasses = parseCSSClassNames(this._popupSettings.popupClass);
    if (parsedPopupClasses?.length) {
      popupClasses.push(...parsedPopupClasses);
    }
    return popupClasses.join(' ');
  }
  get openState() {
    return this._open;
  }
  /**
   * @hidden
   */
  set openState(open) {
    if (this.disabled) {
      return;
    }
    this._open = open;
  }
  /**
   * Returns the current open state of the popup.
   */
  get isOpen() {
    return this._open;
  }
  /**
   * @hidden
   */
  togglePopupVisibility() {
    if (this._disabled) {
      return;
    }
    this._toggle(!this.openState, true);
    if (!this.isClosePrevented) {
      this.focusService.focus(this.openState ? 0 : -1);
    }
  }
  /**
   * @hidden
   */
  onItemClick(index) {
    this.emitItemClickHandler(index);
    this.togglePopupVisibility();
    if (isDocumentAvailable() && !this.isClosePrevented) {
      this.focusButton();
    }
  }
  ngOnDestroy() {
    this.openState = false;
    this.subs.unsubscribe();
    this.destroyPopup();
  }
  subscribeEvents() {
    if (!isDocumentAvailable()) {
      return;
    }
    this.subscribeListItemFocusEvent();
    this.subscribeComponentBlurredEvent();
    this.subscribeNavigationEvents();
  }
  subscribeListItemFocusEvent() {
    this.subs.add(this.focusService.onFocus.subscribe(() => {
      this._isFocused = true;
    }));
  }
  subscribeComponentBlurredEvent() {
    this._zone.runOutsideAngular(() => {
      this.subs.add(this.navigationService.tab.pipe(filter(() => this._isFocused), tap(() => this.focusButton())).subscribe(this.handleTab.bind(this)));
      this.subs.add(fromEvent(document, 'click').pipe(filter(event => !this.wrapperContains(event.target)), filter(() => this._isFocused)).subscribe(() => this._zone.run(() => this.blurWrapper())));
    });
  }
  subscribeNavigationEvents() {
    this.subs.add(this.navigationService.navigate.subscribe(this.onArrowKeyNavigate.bind(this)));
    this.subs.add(this.navigationService.enterup.subscribe(this.onNavigationEnterUp.bind(this)));
    this.subs.add(this.navigationService.open.subscribe(this.onNavigationOpen.bind(this)));
    this.subs.add(merge(this.navigationService.close, this.navigationService.esc).subscribe(this.onNavigationClose.bind(this)));
  }
  /**
   * Toggles the visibility of the popup.
   * If the `toggle` method is used, the `open` and `close` events are not fired.
   *
   * @param open - The desired state of the popup.
   */
  toggle(open) {
    if (this.disabled) {
      return;
    }
    const value = open ?? !this.openState;
    this._toggle(value, false);
  }
  /**
   * @hidden
   */
  keyDownHandler(event, isHost) {
    this.keyHandler(event, null, isHost);
  }
  /**
   * @hidden
   */
  keyUpHandler(event) {
    this.keyHandler(event, KeyEvents.keyup);
  }
  /**
   * @hidden
   */
  keyHandler(event, keyEvent, isHost) {
    if (this._disabled) {
      return;
    }
    const eventData = event;
    if (!isHost) {
      eventData.stopImmediatePropagation();
    }
    const focused = this.focusService.focused || 0;
    const code = normalizeKeys(eventData);
    const action = this.navigationService.process({
      altKey: eventData.altKey,
      current: focused,
      code: code,
      keyEvent: keyEvent,
      max: this._data ? this._data.length - 1 : 0,
      min: 0,
      target: event.target
    });
    if (action !== NavigationAction.Undefined && action !== NavigationAction.Tab && (action !== NavigationAction.Enter || action === NavigationAction.Enter && this.openState)) {
      if (!(code === Keys.Space && action === NavigationAction.EnterUp)) {
        eventData.preventDefault();
      }
    }
  }
  emitItemClickHandler(index) {
    const dataItem = this._data[index];
    if (this._itemClick && !dataItem.disabled) {
      this._itemClick.emit(dataItem);
    }
    if (dataItem?.click && !dataItem?.disabled) {
      dataItem.click(dataItem);
    }
    this.focusService.focus(index);
  }
  focusWrapper() {
    if (this.openState) {
      this.togglePopupVisibility();
      this.focusButton();
    }
  }
  wrapperContains(element) {
    return this.wrapper === element || this.wrapper.contains(element);
  }
  blurWrapper(emit = true) {
    if (!this._isFocused) {
      return;
    }
    if (this.openState) {
      this.togglePopupVisibility();
    }
    this._isFocused = false;
    if (emit) {
      this._blur.emit();
      this.cdr.markForCheck();
    }
  }
  focusButton() {
    if (this.button) {
      this.button.nativeElement.focus();
    }
  }
  handleTab() {
    this.blurWrapper();
  }
  onNavigationEnterUp(_args) {
    if (!this._disabled && !this.openState) {
      this._active = false;
    }
    if (this.openState) {
      const focused = this.focusService.focused;
      if (isPresent(focused) && focused !== -1) {
        this.emitItemClickHandler(focused);
      }
    }
    this.togglePopupVisibility();
    if (!this.openState && isDocumentAvailable()) {
      this.button.nativeElement.focus();
    }
  }
  onNavigationOpen() {
    if (!this._disabled && !this.openState) {
      this.togglePopupVisibility();
    }
  }
  onNavigationClose(e) {
    if (this.openState && !this.isClosePrevented) {
      this.togglePopupVisibility();
      if (isDocumentAvailable()) {
        if (e?.esc && hasObservers(this.escape)) {
          this.escape.emit();
        }
        this.button.nativeElement.focus();
      }
    }
  }
  onArrowKeyNavigate({
    index
  }) {
    this.focusService.focus(index);
  }
  _toggle(open, emitEvent) {
    if (this.openState === open) {
      return;
    }
    const eventArgs = new PreventableEvent();
    if (emitEvent) {
      if (open && !this.openState) {
        this.open.emit(eventArgs);
      } else if (!open && this.openState) {
        this.close.emit(eventArgs);
      }
      if (eventArgs.isDefaultPrevented()) {
        this.isClosePrevented = true;
        return;
      }
    }
    this.openState = open;
    this.destroyPopup();
    if (this.openState) {
      this.createPopup();
    }
  }
  createPopup() {
    this.popupRef = this.popupService.open({
      anchor: this.elRef,
      anchorAlign: this.anchorAlign,
      animate: this.popupSettings.animate,
      appendTo: this.appendTo,
      content: this.containerService.template,
      popupAlign: this.popupAlign,
      popupClass: this.popupClasses
    });
    this.popupSubs = this.popupRef.popupAnchorViewportLeave.subscribe(() => {
      this.togglePopupVisibility();
    });
  }
  destroyPopup() {
    if (this.popupRef) {
      this.popupRef.close();
      this.popupRef = null;
      this.popupSubs.unsubscribe();
      this.isClosePrevented = false;
    }
  }
  static ɵfac = function ListButton_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListButton)(i0.ɵɵdirectiveInject(FocusService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i3.PopupService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PopupContainerService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ListButton,
    selectors: [["ng-component"]],
    viewQuery: function ListButton_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c5, 5, ElementRef)(_c6, 5)(_c7, 5)(_c8, 5, ViewContainerRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonList = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
      }
    },
    inputs: {
      disabled: "disabled",
      tabIndex: "tabIndex",
      buttonClass: "buttonClass",
      popupSettings: "popupSettings"
    },
    outputs: {
      open: "open",
      close: "close",
      escape: "escape"
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
    decls: 0,
    vars: 0,
    template: function ListButton_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListButton, [{
    type: Component,
    args: [{
      template: ''
    }]
  }], () => [{
    type: FocusService
  }, {
    type: NavigationService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.NgZone
  }, {
    type: i3.PopupService
  }, {
    type: i0.ElementRef
  }, {
    type: i1.LocalizationService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: PopupContainerService
  }], {
    button: [{
      type: ViewChild,
      args: ['button', {
        read: ElementRef
      }]
    }],
    buttonList: [{
      type: ViewChild,
      args: ['buttonList']
    }],
    popupTemplate: [{
      type: ViewChild,
      args: ['popupTemplate']
    }],
    container: [{
      type: ViewChild,
      args: ['container', {
        read: ViewContainerRef
      }]
    }],
    disabled: [{
      type: Input
    }],
    tabIndex: [{
      type: Input
    }],
    buttonClass: [{
      type: Input
    }],
    open: [{
      type: Output
    }],
    close: [{
      type: Output
    }],
    escape: [{
      type: Output
    }],
    popupSettings: [{
      type: Input
    }]
  });
})();
const NAVIGATION_SETTINGS$2 = {
  useLeftRightArrows: true
};
const NAVIGATION_SETTINGS_PROVIDER$2 = {
  provide: NAVIGATION_CONFIG,
  useValue: NAVIGATION_SETTINGS$2
};
/**
 * Represents the Kendo UI DropDownButton component for Angular.
 *
 * Use the DropDownButton to display a button with a popup list of actions.
 *
 * @example
 * ```ts
 * @Component({
 *   selector: 'my-app',
 *   template: `
 *     <kendo-dropdownbutton [data]="data">
 *       User Settings
 *     </kendo-dropdownbutton>
 *   `
 * })
 * class AppComponent {
 *   public data: Array<any> = [
 *     { text: 'My Profile' },
 *     { text: 'Friend Requests' },
 *     { text: 'Account Settings' },
 *     { text: 'Support' },
 *     { text: 'Log Out' }
 *   ];
 * }
 * ```
 */
class DropDownButtonComponent extends ListButton {
  containerService;
  renderer;
  /**
   * Displays the default arrow icon or a custom one.
   * @default false
   */
  arrowIcon = false;
  /**
   * Specifies the name of an existing icon in the Kendo UI theme.
   */
  icon = '';
  /**
   * Specifies an [`SVGIcon`](https://www.telerik.com/kendo-angular-ui/components/icons/api/svgicon) to render within the button.
   */
  svgIcon;
  /**
   * Specifies a list of CSS classes for styling the button with custom icons.
   */
  iconClass = '';
  /**
   * Specifies a URL for styling the button with a custom image.
   */
  imageUrl = '';
  /**
   * Sets the data item field that represents the item text.
   * If the data contains only primitive values, leave this undefined.
   */
  textField;
  /**
   * Sets or gets the data of the DropDownButton. Provide the data as an array-like list.
   */
  set data(data) {
    this._data = data || [];
  }
  get data() {
    return this._data;
  }
  /**
   * Specifies the padding of the DropDownButton. See [DropDownButton Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/dropdownbutton/appearance#size). The default value is set by the Kendo theme.
   */
  size = undefined;
  /**
   * Specifies the border radius of the DropDownButton. See [DropDownButton Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/dropdownbutton/appearance#roundness). The default value is set by the Kendo theme.
   */
  rounded = undefined;
  /**
   * Specifies the background and border styles of the DropDownButton. See [DropDownButton Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/dropdownbutton/appearance#fill-mode). The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this._fillMode = fillMode === 'clear' ? 'flat' : fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Specifies predefined theme colors for the DropDownButton. See [DropDownButton Appearance](https://www.telerik.com/kendo-angular-ui/components/buttons/dropdownbutton/appearance#theme-colors).
   */
  themeColor = undefined;
  /**
   * Sets attributes for the main button.
   */
  set buttonAttributes(buttonAttributes) {
    const newButtonAttributes = buttonAttributes || null;
    this.handleButtonAttributes(newButtonAttributes);
    this._buttonAttributes = newButtonAttributes;
  }
  get buttonAttributes() {
    return this._buttonAttributes;
  }
  /**
   * Fires when the user clicks a drop-down list item.
   * The event data contains the data item bound to the clicked list item.
   */
  itemClick = new EventEmitter();
  /**
   * Fires when the DropDownButton is focused.
   */
  onFocus = new EventEmitter();
  /**
   * Fires when the DropDownButton is blurred.
   */
  onBlur = new EventEmitter();
  get focused() {
    return this._isFocused && !this._disabled;
  }
  hostDisplayStyle = 'inline-flex';
  get dir() {
    return this.direction;
  }
  /**
   * @hidden
   */
  get active() {
    return this._active;
  }
  itemTemplate;
  _fillMode = undefined;
  _buttonAttributes = null;
  documentMouseUpSub;
  /**
   * @hidden
   */
  keydown(event) {
    this.keyDownHandler(event, true);
    const code = normalizeKeys(event);
    if (code === Keys.Space) {
      this._active = true;
    }
    if (code === Keys.Enter) {
      this._active = true;
      event.preventDefault();
    }
  }
  /**
   * @hidden
   */
  keyup(event) {
    this.keyUpHandler(event);
    this._active = false;
  }
  /**
   * @hidden
   */
  mousedown(event) {
    if (this._disabled) {
      event.preventDefault();
    } else {
      this._active = true;
    }
  }
  /**
   * @hidden
   */
  mouseup(event) {
    if (this._disabled) {
      event.preventDefault();
    }
    this._active = false;
  }
  /**
   * @hidden
   */
  openPopup() {
    this._isFocused = true;
    this.togglePopupVisibility();
  }
  /**
   * @hidden
   */
  onButtonBlur() {
    if (!this.openState) {
      this.blurWrapper();
    }
  }
  /**
   * Focuses the DropDownButton.
   */
  focus() {
    if (isDocumentAvailable()) {
      this.button.nativeElement.focus();
    }
  }
  /**
   * Blurs the DropDownButton.
   */
  blur() {
    if (isDocumentAvailable()) {
      this.button.nativeElement.blur();
      this.blurWrapper();
    }
  }
  constructor(focusService, navigationService, wrapperRef, zone, popupService, elRef, localization, cdr, containerService, renderer) {
    super(focusService, navigationService, wrapperRef, zone, popupService, elRef, localization, cdr, containerService);
    this.containerService = containerService;
    this.renderer = renderer;
    this._itemClick = this.itemClick;
    this._blur = this.onBlur;
    zone.runOutsideAngular(() => {
      this.documentMouseUpSub = this.renderer.listen('document', 'mouseup', () => {
        if (this.active) {
          zone.run(() => this._active = false);
        }
      });
    });
  }
  ngAfterViewInit() {
    this.containerService.container = this.container;
    this.containerService.template = this.popupTemplate;
    this.handleButtonAttributes(this.buttonAttributes);
    const arrowWrapper = this.button.nativeElement.querySelector('.k-button-arrow');
    if (arrowWrapper) {
      this.renderer.addClass(arrowWrapper, 'k-menu-button-arrow');
    }
  }
  /**
   * @hidden
   */
  handleFocus(event) {
    if (!this._disabled) {
      if (!this._isFocused) {
        this.onFocus.emit();
      }
      this._isFocused = true;
      this.focusService.resetFocus();
      const relatedTargetInList = event.relatedTarget && closest(event.relatedTarget, '.k-popup kendo-button-list');
      if (this.openState && !relatedTargetInList) {
        this.focusService.focus(0);
      }
    }
  }
  /**
   * @hidden
   */
  wrapperContains(element) {
    return this.wrapper === element || this.wrapper.contains(element) || this.popupRef?.popupElement.contains(element);
  }
  handleButtonAttributes(newButtonAttributes) {
    const mainButton = this.button?.nativeElement;
    if (isPresent$1(this.buttonAttributes) && isPresent$1(mainButton)) {
      for (const attr in this.buttonAttributes) {
        this.renderer.removeAttribute(mainButton, attr, this.buttonAttributes[attr]);
      }
    }
    if (isPresent$1(newButtonAttributes) && isPresent$1(mainButton)) {
      for (const attr in newButtonAttributes) {
        this.renderer.setAttribute(mainButton, attr, newButtonAttributes[attr]);
      }
    }
  }
  /**
   * @hidden
   */
  ngOnDestroy() {
    if (this.documentMouseUpSub) {
      this.documentMouseUpSub();
    }
    super.ngOnDestroy();
  }
  static ɵfac = function DropDownButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownButtonComponent)(i0.ɵɵdirectiveInject(FocusService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i3.PopupService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PopupContainerService), i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DropDownButtonComponent,
    selectors: [["kendo-dropdownbutton"]],
    contentQueries: function DropDownButtonComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ButtonItemTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
      }
    },
    hostVars: 5,
    hostBindings: function DropDownButtonComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function DropDownButtonComponent_keydown_HostBindingHandler($event) {
          return ctx.keydown($event);
        })("keyup", function DropDownButtonComponent_keyup_HostBindingHandler($event) {
          return ctx.keyup($event);
        })("mousedown", function DropDownButtonComponent_mousedown_HostBindingHandler($event) {
          return ctx.mousedown($event);
        })("mouseup", function DropDownButtonComponent_mouseup_HostBindingHandler($event) {
          return ctx.mouseup($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.dir);
        i0.ɵɵstyleProp("display", ctx.hostDisplayStyle);
        i0.ɵɵclassProp("k-focus", ctx.focused);
      }
    },
    inputs: {
      arrowIcon: "arrowIcon",
      icon: "icon",
      svgIcon: "svgIcon",
      iconClass: "iconClass",
      imageUrl: "imageUrl",
      textField: "textField",
      data: "data",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      themeColor: "themeColor",
      buttonAttributes: "buttonAttributes"
    },
    outputs: {
      itemClick: "itemClick",
      onFocus: "focus",
      onBlur: "blur"
    },
    exportAs: ["kendoDropDownButton"],
    features: [i0.ɵɵProvidersFeature([FocusService, NavigationService, NAVIGATION_SETTINGS_PROVIDER$2, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.dropdownbutton'
    }, PopupContainerService]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c1,
    decls: 7,
    vars: 18,
    consts: [["button", ""], ["popupTemplate", ""], ["container", ""], ["buttonList", ""], ["kendoButton", "", "type", "button", 1, "k-menu-button", 3, "click", "focus", "blur", "id", "tabindex", "disabled", "icon", "svgIcon", "arrowIcon", "iconClass", "imageUrl", "ngClass", "size", "rounded", "fillMode", "themeColor"], [3, "onItemClick", "keydown", "keyup", "id", "data", "textField", "itemTemplate", "size"]],
    template: function DropDownButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 4, 0);
        i0.ɵɵlistener("click", function DropDownButtonComponent_Template_button_click_0_listener() {
          return ctx.openPopup();
        })("focus", function DropDownButtonComponent_Template_button_focus_0_listener($event) {
          return ctx.handleFocus($event);
        })("blur", function DropDownButtonComponent_Template_button_blur_0_listener() {
          return ctx.onButtonBlur();
        });
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, DropDownButtonComponent_ng_template_3_Template, 2, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementContainer(5, null, 2);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("k-active", ctx.active);
        i0.ɵɵproperty("id", ctx.buttonId)("tabindex", ctx.componentTabIndex)("disabled", ctx.disabled)("icon", ctx.icon)("svgIcon", ctx.svgIcon)("arrowIcon", ctx.arrowIcon)("iconClass", ctx.iconClass)("imageUrl", ctx.imageUrl)("ngClass", ctx.buttonClass)("size", ctx.size)("rounded", ctx.rounded)("fillMode", ctx.fillMode)("themeColor", ctx.themeColor);
        i0.ɵɵattribute("aria-disabled", ctx.disabled || null)("aria-expanded", ctx.openState)("aria-controls", ctx.openState ? ctx.listId : null);
      }
    },
    dependencies: [ButtonComponent, NgClass, ListComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownButtonComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoDropDownButton',
      providers: [FocusService, NavigationService, NAVIGATION_SETTINGS_PROVIDER$2, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.dropdownbutton'
      }, PopupContainerService],
      selector: 'kendo-dropdownbutton',
      template: `
        <button kendoButton #button
            type="button"
            [id]="buttonId"
            [tabindex]="componentTabIndex"
            class="k-menu-button"
            [class.k-active]="active"
            [disabled]="disabled"
            [icon]="icon"
            [svgIcon]="svgIcon"
            [arrowIcon]="arrowIcon"
            [iconClass]="iconClass"
            [imageUrl]="imageUrl"
            [ngClass]="buttonClass"
            [size]="size"
            [rounded]="rounded"
            [fillMode]="fillMode"
            [themeColor]="themeColor"
            (click)="openPopup()"
            (focus)="handleFocus($event)"
            (blur)="onButtonBlur()"
            [attr.aria-disabled]="disabled || null"
            [attr.aria-expanded]="openState"
            [attr.aria-controls]="openState ? listId : null"
        >
            <ng-content></ng-content>
        </button>
        <ng-template #popupTemplate>
            <kendo-button-list
                #buttonList
                [id]="listId"
                [data]="data"
                [textField]="textField"
                [itemTemplate]="itemTemplate"
                (onItemClick)="onItemClick($event)"
                (keydown)="keyDownHandler($event)"
                (keyup)="keyUpHandler($event)"
                [attr.dir]="dir"
                [attr.aria-labelledby]="buttonId"
                [size]="size"
            >
            </kendo-button-list>
        </ng-template>
        <ng-container #container></ng-container>
    `,
      standalone: true,
      imports: [ButtonComponent, NgClass, ListComponent]
    }]
  }], () => [{
    type: FocusService
  }, {
    type: NavigationService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.NgZone
  }, {
    type: i3.PopupService
  }, {
    type: i0.ElementRef
  }, {
    type: i1.LocalizationService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: PopupContainerService
  }, {
    type: i0.Renderer2
  }], {
    arrowIcon: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    iconClass: [{
      type: Input
    }],
    imageUrl: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    themeColor: [{
      type: Input
    }],
    buttonAttributes: [{
      type: Input
    }],
    itemClick: [{
      type: Output
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    focused: [{
      type: HostBinding,
      args: ['class.k-focus']
    }],
    hostDisplayStyle: [{
      type: HostBinding,
      args: ['style.display']
    }],
    dir: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    itemTemplate: [{
      type: ContentChild,
      args: [ButtonItemTemplateDirective]
    }],
    keydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }],
    keyup: [{
      type: HostListener,
      args: ['keyup', ['$event']]
    }],
    mousedown: [{
      type: HostListener,
      args: ['mousedown', ['$event']]
    }],
    mouseup: [{
      type: HostListener,
      args: ['mouseup', ['$event']]
    }]
  });
})();

/**
 * @hidden
 */
function getAnchorAlign(fabAlign, rtl) {
  const align = {
    horizontal: rtl ? 'right' : 'left',
    vertical: 'bottom'
  };
  if (fabAlign.horizontal === 'end') {
    align.horizontal = rtl ? 'left' : 'right';
  }
  if (fabAlign.vertical === 'bottom') {
    align.vertical = 'top';
  }
  if (fabAlign.vertical === 'bottom' && fabAlign.horizontal === 'end') {
    align.horizontal = rtl ? 'left' : 'right';
    align.vertical = 'top';
  }
  return align;
}
/**
 * @hidden
 */
function getPopupAlign(fabAlign, rtl) {
  const align = {
    horizontal: rtl ? 'right' : 'left',
    vertical: 'top'
  };
  if (fabAlign.horizontal === 'end') {
    align.horizontal = rtl ? 'left' : 'right';
  }
  if (fabAlign.vertical === 'bottom') {
    align.vertical = 'bottom';
  }
  if (fabAlign.vertical === 'bottom' && fabAlign.horizontal === 'end') {
    align.horizontal = rtl ? 'left' : 'right';
    align.vertical = 'bottom';
  }
  return align;
}

/**
 * @hidden
 */
function openAnimation(animationSettings) {
  const isBottom = animationSettings.align.vertical === 'bottom';
  const duration = animationSettings.duration;
  const gap = animationSettings.gap;
  return sequence([query(`.k-fab-item`, [style({
    opacity: 0,
    transform: `translateY(${isBottom ? '8px' : '-8px'})`
  }), stagger(gap, [animate(`${duration}ms ease-in`, style({
    opacity: '*',
    transform: 'translateY(0)'
  }))])], {
    optional: true
  })]);
}
/**
 * @hidden
 */
function closeAnimation(animationSettings) {
  const isBottom = animationSettings.align.vertical === 'bottom';
  const duration = animationSettings.duration;
  const gap = animationSettings.gap;
  return sequence([query(`.k-fab-item`, [style({
    opacity: '*',
    transform: 'translateY(0)'
  }), stagger(-gap, [animate(`${duration}ms ease-in`, style({
    opacity: 0,
    transform: `translateY(${isBottom ? '8px' : '-8px'})`
  }))])], {
    optional: true
  })]);
}

/**
 * Represents a template that defines the content of a dial item.
 * To define the template, nest an `<ng-template>` tag with the `kendoDialItemTemplate` directive inside the `<kendo-floatingactionbutton>` tag
 *([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/templates#dial-item-template)).
 *
 * @example
 * ```html
 * <kendo-floatingactionbutton>
 *     <ng-template kendoDialItemTemplate let-item="item">
 *         {{ item.label }}
 *     </ng-template>
 * </kendo-floatingactionbutton>
 * ```
 */
class DialItemTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function DialItemTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DialItemTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DialItemTemplateDirective,
    selectors: [["", "kendoDialItemTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialItemTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDialItemTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef,
    decorators: [{
      type: Optional
    }]
  }], null);
})();

/**
 * Represents a template that defines the content of the FloatingActionButton.
 * To define the template, nest an `<ng-template>` tag with the `kendoFloatingActionButtonTemplate` directive inside the `<kendo-floatingactionbutton>` tag
 *
 * ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/templates#floatingactionbutton-template)).
 *
 * @example
 * ```html
 * <kendo-floatingactionbutton>
 *     <ng-template kendoFloatingActionButtonTemplate>
 *         Custom Content
 *     </ng-template>
 * </kendo-floatingactionbutton>
 * ```
 */
class FloatingActionButtonTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function FloatingActionButtonTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FloatingActionButtonTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FloatingActionButtonTemplateDirective,
    selectors: [["", "kendoFloatingActionButtonTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FloatingActionButtonTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoFloatingActionButtonTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef,
    decorators: [{
      type: Optional
    }]
  }], null);
})();

/**
 * @hidden
 */
class DialItemComponent {
  element;
  renderer;
  localisationService;
  hostClass = true;
  role = 'menuitem';
  get disabledClass() {
    return this.item.disabled;
  }
  get title() {
    const label = this.item.label;
    return label || this.itemTitle;
  }
  get indexAttr() {
    return this.index;
  }
  cssClass;
  cssStyle;
  isFocused;
  index;
  item;
  dialItemTemplate;
  align;
  constructor(element, renderer, localisationService) {
    this.element = element;
    this.renderer = renderer;
    this.localisationService = localisationService;
  }
  get iconClasses() {
    const classes = [];
    if (this.item.iconClass) {
      classes.push(`${this.item.iconClass}`);
    }
    if (this.item.icon) {
      classes.push(`k-fab-item-icon k-icon k-i-${this.item.icon}`);
    }
    return classes;
  }
  get itemTitle() {
    const icon = this.item.icon;
    const itemTitle = this.item.itemTitle;
    return icon && itemTitle ? itemTitle : icon;
  }
  ngAfterViewInit() {
    const element = this.element.nativeElement;
    const rtl = this.localisationService.rtl;
    const hAlign = this.align.horizontal;
    this.renderer.addClass(element, this.getTextDirectionClass(rtl, hAlign));
  }
  getTextDirectionClass(rtl, hAlign) {
    const dir = rtl ? 'rtl' : 'ltr';
    const align = hAlign === 'end' ? 'end' : 'start';
    const directions = {
      rtl: {
        end: 'k-text-left',
        start: 'k-text-right'
      },
      ltr: {
        start: 'k-text-left',
        end: 'k-text-right'
      }
    };
    return directions[dir][align];
  }
  static ɵfac = function DialItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DialItemComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DialItemComponent,
    selectors: [["", "kendoDialItem", ""]],
    hostVars: 9,
    hostBindings: function DialItemComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role)("aria-disabled", ctx.disabledClass)("title", ctx.title)("aria-label", ctx.title)("data-fab-item-index", ctx.indexAttr);
        i0.ɵɵclassProp("k-fab-item", ctx.hostClass)("k-disabled", ctx.disabledClass);
      }
    },
    inputs: {
      cssClass: "cssClass",
      cssStyle: "cssStyle",
      isFocused: "isFocused",
      index: "index",
      item: "item",
      dialItemTemplate: "dialItemTemplate",
      align: "align"
    },
    attrs: _c9,
    decls: 2,
    vars: 2,
    consts: [[3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "k-fab-item-text"], ["innerCssClass", "k-fab-item-icon", 3, "name", "customFontClass", "svgIcon"]],
    template: function DialItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵconditionalCreate(0, DialItemComponent_Conditional_0_Template, 1, 6, null, 0);
        i0.ɵɵconditionalCreate(1, DialItemComponent_Conditional_1_Template, 2, 2);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.dialItemTemplate ? 0 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.dialItemTemplate ? 1 : -1);
      }
    },
    dependencies: [NgTemplateOutlet, IconWrapperComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialItemComponent, [{
    type: Component,
    args: [{
      selector: '[kendoDialItem]',
      template: `
        @if (dialItemTemplate) {
          <ng-template
            [ngTemplateOutlet]="dialItemTemplate"
            [ngTemplateOutletContext]="{ $implicit: item, index: index, isFocused: isFocused }"
            >
          </ng-template>
        }
        
        @if (!dialItemTemplate) {
          @if (item.label) {
            <span class="k-fab-item-text">{{ item.label }}</span>
          }
          @if (item.icon || item.iconClass || item.svgIcon) {
            <kendo-icon-wrapper
              [name]="item.icon"
              innerCssClass="k-fab-item-icon"
              [customFontClass]="item.iconClass"
            [svgIcon]="item.svgIcon"></kendo-icon-wrapper>
          }
        }
        `,
      standalone: true,
      imports: [NgTemplateOutlet, IconWrapperComponent]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i1.LocalizationService
  }], {
    hostClass: [{
      type: HostBinding,
      args: ['class.k-fab-item']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    disabledClass: [{
      type: HostBinding,
      args: ['attr.aria-disabled']
    }, {
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    title: [{
      type: HostBinding,
      args: ['attr.title']
    }, {
      type: HostBinding,
      args: ['attr.aria-label']
    }],
    indexAttr: [{
      type: HostBinding,
      args: ['attr.data-fab-item-index']
    }],
    cssClass: [{
      type: Input
    }],
    cssStyle: [{
      type: Input
    }],
    isFocused: [{
      type: Input
    }],
    index: [{
      type: Input
    }],
    item: [{
      type: Input
    }],
    dialItemTemplate: [{
      type: Input
    }],
    align: [{
      type: Input
    }]
  });
})();

/**
 * @hidden
 */
class DialListComponent {
  focusService;
  cdr;
  hostClass = true;
  get bottomClass() {
    return this.align.vertical === 'top' || this.align.vertical === 'middle';
  }
  get topClass() {
    return this.align.vertical === 'bottom';
  }
  dialItems;
  dialItemTemplate;
  align;
  subscriptions = new Subscription();
  constructor(focusService, cdr) {
    this.focusService = focusService;
    this.cdr = cdr;
    this.subscriptions.add(this.focusService.onFocus.subscribe(() => this.cdr.detectChanges()));
  }
  isFocused(index) {
    return this.focusService.isFocused(index);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static ɵfac = function DialListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DialListComponent)(i0.ɵɵdirectiveInject(FocusService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DialListComponent,
    selectors: [["", "kendoDialList", ""]],
    hostVars: 6,
    hostBindings: function DialListComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("k-fab-items", ctx.hostClass)("k-fab-items-bottom", ctx.bottomClass)("k-fab-items-top", ctx.topClass);
      }
    },
    inputs: {
      dialItems: "dialItems",
      dialItemTemplate: "dialItemTemplate",
      align: "align"
    },
    attrs: _c11,
    decls: 2,
    vars: 0,
    consts: [["kendoButtonFocusable", "", "kendoDialItem", "", 3, "item", "index", "dialItemTemplate", "isFocused", "ngClass", "ngStyle", "align"]],
    template: function DialListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵrepeaterCreate(0, DialListComponent_For_1_Template, 1, 7, "li", 0, i0.ɵɵrepeaterTrackByIdentity);
      }
      if (rf & 2) {
        i0.ɵɵrepeater(ctx.dialItems);
      }
    },
    dependencies: [FocusableDirective, DialItemComponent, NgClass, NgStyle],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialListComponent, [{
    type: Component,
    args: [{
      selector: '[kendoDialList]',
      template: `
        @for (item of dialItems; track item; let idx = $index) {
          <li
            kendoButtonFocusable
            kendoDialItem
            [item]="dialItems[idx]"
            [index]="idx"
            [dialItemTemplate]="dialItemTemplate"
            [isFocused]="isFocused(idx)"
            [ngClass]='item.cssClass'
            [ngStyle]='item.cssStyle'
            [align]="align"
            >
          </li>
        }
        `,
      standalone: true,
      imports: [FocusableDirective, DialItemComponent, NgClass, NgStyle]
    }]
  }], () => [{
    type: FocusService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    hostClass: [{
      type: HostBinding,
      args: ['class.k-fab-items']
    }],
    bottomClass: [{
      type: HostBinding,
      args: ['class.k-fab-items-bottom']
    }],
    topClass: [{
      type: HostBinding,
      args: ['class.k-fab-items-top']
    }],
    dialItems: [{
      type: Input
    }],
    dialItemTemplate: [{
      type: Input
    }],
    align: [{
      type: Input
    }]
  });
})();
const NAVIGATION_SETTINGS$1 = {
  useLeftRightArrows: false
};
const NAVIGATION_SETTINGS_PROVIDER$1 = {
  provide: NAVIGATION_CONFIG,
  useValue: NAVIGATION_SETTINGS$1
};
const SIZE_CLASSES = {
  small: 'k-fab-sm',
  medium: 'k-fab-md',
  large: 'k-fab-lg'
};
const ROUNDED_CLASSES = {
  small: 'k-rounded-sm',
  medium: 'k-rounded-md',
  large: 'k-rounded-lg',
  full: 'k-rounded-full',
  none: 'k-rounded-none'
};
const THEME_COLOR_PREFIX = 'k-fab';
const DEFAULT_DURATION = 180;
const DEFAULT_ITEM_GAP = 90;
const DEFAULT_OFFSET = '16px';
/**
 * Represents the Kendo UI FloatingActionButton component for Angular.
 * Use it to represent the primary or most common action in an application.
 *
 * @example
 * ```html
 * <kendo-floatingactionbutton
 *     [icon]="'plus'"
 *     [text]="'Add'"
 *     [align]="{ horizontal: 'end', vertical: 'bottom' }">
 * </kendo-floatingactionbutton>
 * ```
 */
class FloatingActionButtonComponent {
  renderer;
  element;
  focusService;
  navigationService;
  ngZone;
  popupService;
  builder;
  localizationService;
  get fixedClass() {
    return this.positionMode === 'fixed';
  }
  get absoluteClass() {
    return this.positionMode === 'absolute';
  }
  direction;
  button;
  popupTemplate;
  dialItemTemplate;
  fabTemplate;
  /**
   * Specifies the theme color of the FloatingActionButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/appearance#theme-colors)). The default value is set by the Kendo theme.
   */
  set themeColor(themeColor) {
    this.handleClasses(themeColor, 'themeColor');
    this._themeColor = themeColor;
  }
  get themeColor() {
    return this._themeColor;
  }
  /**
   * Specifies the size of the FloatingActionButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/appearance#size)). The default value is set by the Kendo theme.
   */
  set size(size) {
    this.handleClasses(size, 'size');
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Specifies the border radius of the FloatingActionButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/appearance#roundness)). The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.handleClasses(rounded, 'rounded');
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Specifies whether the FloatingActionButton is disabled.
   * @default false
   */
  set disabled(disabled) {
    this._disabled = disabled;
  }
  get disabled() {
    return this._disabled;
  }
  /**
   * Specifies the alignment of the FloatingActionButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/positioning#alignment)).
   * @default { horizontal: 'end', vertical: 'top' }
   */
  set align(align) {
    this._align = Object.assign(this._align, align);
  }
  get align() {
    return this._align;
  }
  /**
   * Specifies the offset position of the FloatingActionButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/positioning#offset)).
   * @default { x: '16px', y: '16px' }
   */
  set offset(offset) {
    this._offset = Object.assign(this._offset, offset);
    this.offsetStyles();
  }
  get offset() {
    return this._offset;
  }
  /**
   * Specifies the position mode of the FloatingActionButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/positioning#position-mode)).
   * @default "fixed"
   */
  positionMode = 'fixed';
  /**
   * Defines the name of an existing icon in a Kendo UI theme.
   */
  icon;
  /**
   * Defines an [`SVGIcon`](https://www.telerik.com/kendo-angular-ui/components/icons/api/svgicon) to be rendered within the FloatingActionButton.
   */
  svgIcon;
  /**
   * Defines a CSS class or multiple classes for custom icons.
   */
  iconClass;
  /**
   * The CSS classes that will be rendered on the main button.
   * Supports the type of values that are supported by [`ngClass`](link:site.data.urls.angular['ngclassapi']).
   */
  buttonClass;
  /**
   * The CSS classes that will be rendered on the dial items `ul` element.
   * Supports the type of values that are supported by [`ngClass`](link:site.data.urls.angular['ngclassapi']).
   */
  dialClass;
  /**
   * Specifies the text content of the FloatingActionButton.
   *
   * @remarks
   * This property is related to accessibility.
   */
  text;
  /**
   * Specifies the animation settings of the FloatingActionButton dial items.
   * @default true
   */
  dialItemAnimation = true;
  /**
   * Specifies the [`tabIndex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the FloatingActionButton.
   * @default 0
   */
  tabIndex = 0;
  /**
   * Specifies the collection of dial items rendered in the FloatingActionButton popup.
   */
  dialItems = [];
  /**
   * Fires when the FloatingActionButton is blurred.
   */
  onBlur = new EventEmitter();
  /**
   * Fires when the FloatingActionButton is focused.
   */
  onFocus = new EventEmitter();
  /**
   * Fires when a dial item is clicked.
   */
  dialItemClick = new EventEmitter();
  /**
   * Fires when the popup is about to open. This event is preventable
   *  ([more information and example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/events)).
   */
  open = new EventEmitter();
  /**
   * Fires when the popup is about to close. This event is preventable
   * ([more information and example](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/events)).
   */
  close = new EventEmitter();
  /**
   * @hidden
   */
  get componentTabIndex() {
    return this.disabled ? -1 : this.tabIndex;
  }
  /**
   * @hidden
   */
  id = `k-${guid()}`;
  /**
   * @hidden
   */
  dialListId = `k-dial-list-${guid()}`;
  _themeColor = undefined;
  _size = undefined;
  _rounded = undefined;
  _disabled = false;
  _align = {
    horizontal: 'end',
    vertical: 'bottom'
  };
  _offset = {
    x: DEFAULT_OFFSET,
    y: DEFAULT_OFFSET
  };
  subscriptions = new Subscription();
  popupMouseDownListener;
  rtl = false;
  animationEnd = new EventEmitter();
  popupRef;
  initialSetup = true;
  focusChangedProgrammatically = false;
  constructor(renderer, element, focusService, navigationService, ngZone, popupService, builder, localizationService) {
    this.renderer = renderer;
    this.element = element;
    this.focusService = focusService;
    this.navigationService = navigationService;
    this.ngZone = ngZone;
    this.popupService = popupService;
    this.builder = builder;
    this.localizationService = localizationService;
    validatePackage(packageMetadata);
    this.subscribeNavigationEvents();
    this.subscriptions.add(this.localizationService.changes.subscribe(({
      rtl
    }) => {
      this.rtl = rtl;
      this.direction = this.rtl ? 'rtl' : 'ltr';
    }));
  }
  ngAfterViewInit() {
    ['size', 'rounded', 'themeColor'].forEach(option => this.handleClasses(this[option], option));
    this.renderer.addClass(this.element.nativeElement, this.alignClass());
    this.offsetStyles();
    this.initialSetup = false;
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.isOpen) {
      this.toggleDial(false);
    }
  }
  /**
   * Indicates whether the FloatingActionButton is currently open.
   */
  get isOpen() {
    return isPresent(this.popupRef);
  }
  /**
   * Focuses the FloatingActionButton.
   */
  focus() {
    if (isDocumentAvailable()) {
      this.focusChangedProgrammatically = true;
      this.button.nativeElement.focus();
      this.focusChangedProgrammatically = false;
    }
  }
  /**
   * Blurs the FloatingActionButton.
   */
  blur() {
    if (isDocumentAvailable()) {
      this.focusChangedProgrammatically = true;
      this.button.nativeElement.blur();
      this.focusChangedProgrammatically = false;
    }
  }
  /**
   * Toggles the visibility of the FloatingActionButton dial items popup.
   *
   * If you use the `toggleDial` method to open or close the dial items,
   * the `open` and `close` events do not fire ([more information and examples](https://www.telerik.com/kendo-angular-ui/components/buttons/floatingactionbutton/open_state)).
   *
   * @param open - The state of dial items popup.
   */
  toggleDial(open) {
    if (this.disabled || !this.hasDialItems) {
      return;
    }
    const shouldOpen = isPresent(open) ? open : !this.isOpen;
    if (this.disabled || shouldOpen === this.isOpen) {
      return;
    }
    if (shouldOpen) {
      setTimeout(() => this.openDial());
    } else {
      this.closeDial();
    }
  }
  /**
   * @hidden
   */
  get ariaExpanded() {
    return this.hasDialItems ? this.isOpen : undefined;
  }
  /**
   * @hidden
   */
  get ariaHasPopup() {
    return this.hasDialItems ? 'menu' : undefined;
  }
  /**
   * @hidden
   */
  get ariaControls() {
    if (!this.hasDialItems) {
      return undefined;
    }
    return this.isOpen ? this.dialListId : undefined;
  }
  /**
   * @hidden
   */
  get iconClasses() {
    const classes = [];
    if (this.iconClass) {
      classes.push(`${this.iconClass}`);
    }
    if (this.icon) {
      classes.push(`k-fab-icon k-icon k-i-${this.icon}`);
    }
    return classes;
  }
  /**
   * @hidden
   */
  clickHandler() {
    if (this.disabled || !this.hasDialItems) {
      return;
    }
    this.ngZone.run(() => {
      const shouldOpen = !this.isOpen;
      this.toggleDialWithEvents(shouldOpen);
    });
  }
  /**
   * @hidden
   */
  pointerdownHandler(e) {
    if (this.isOpen) {
      e.preventDefault();
      this.focus();
    }
  }
  /**
   * @hidden
   */
  keyDownHandler(event) {
    if (this.disabled) {
      return;
    }
    const focused = this.focusService.focused || 0;
    const code = normalizeKeys(event);
    const action = this.navigationService.process({
      altKey: event.altKey,
      current: focused,
      code: code,
      max: this.dialItems ? this.dialItems.length - 1 : 0,
      min: 0,
      flipNavigation: this.align.vertical === 'bottom'
    });
    if (action !== NavigationAction.Undefined && action !== NavigationAction.Tab) {
      event.preventDefault();
    }
    if (action === NavigationAction.Tab && event.target.closest(`#${this.dialListId}`)) {
      this.focus();
    }
    if (action === NavigationAction.EnterUp && !this.hasDialItems) {
      this.button.nativeElement.click();
    } else if (action === NavigationAction.Open || action === NavigationAction.Close) {
      const toggleDial = action === NavigationAction.Open;
      this.ngZone.run(() => {
        this.toggleDialWithEvents(toggleDial);
      });
    }
  }
  /**
   * @hidden
   */
  onItemClick(event) {
    const item = closest(event.target, '.k-fab-item');
    if (!item) {
      return;
    }
    const index = parseInt(item.getAttribute('data-fab-item-index'));
    this.emitItemClick(index);
  }
  /**
   * @hidden
   */
  focusHandler() {
    if (!this.disabled && !this.focusChangedProgrammatically) {
      this.onFocus.emit();
    }
  }
  /**
   * @hidden
   */
  blurHandler(e) {
    const focusInList = e.relatedTarget && e.relatedTarget.closest(`#${this.dialListId}`);
    if (focusInList) {
      return;
    }
    if (!this.focusChangedProgrammatically) {
      this.onBlur.emit();
    }
    this.toggleDialWithEvents(false);
  }
  /**
   * @hidden
   */
  focusOutHandler(e) {
    const focusInList = e.relatedTarget && e.relatedTarget.closest(`#${this.dialListId}`);
    const focusOnButton = e.relatedTarget === this.button.nativeElement;
    const shouldClose = !focusInList && !focusOnButton;
    if (shouldClose) {
      this.toggleDialWithEvents(false);
      if (!this.focusChangedProgrammatically) {
        this.onBlur.emit();
      }
    }
  }
  /**
   * @hidden
   */
  onNavigationEnterPress() {
    this.ngZone.run(() => {
      if (this.isOpen) {
        const focusedIndex = this.focusService.focused;
        const focusedItem = this.dialItems[focusedIndex];
        if (focusedItem?.disabled) {
          return;
        }
        if (isPresent(focusedIndex) && focusedIndex !== -1) {
          this.onEnterPressed();
          return;
        }
      }
      if (!this.isOpen && isDocumentAvailable()) {
        this.toggleDialWithEvents(true);
        this.focus();
      }
    });
  }
  /**
   * @hidden
   */
  onNavigationClose() {
    if (this.isOpen) {
      this.ngZone.run(() => {
        this.toggleDialWithEvents(false);
        this.focus();
      });
    }
  }
  handleClasses(inputValue, input) {
    if (isPresent(this.button) && (this[input] !== inputValue || this.initialSetup)) {
      const button = this.button.nativeElement;
      const classesToRemove = {
        themeColor: `${THEME_COLOR_PREFIX}-${this.themeColor}`,
        size: SIZE_CLASSES[this.size],
        rounded: ROUNDED_CLASSES[this.rounded]
      };
      const classesToAdd = {
        themeColor: inputValue ? `${THEME_COLOR_PREFIX}-${inputValue}` : '',
        size: SIZE_CLASSES[inputValue],
        rounded: ROUNDED_CLASSES[inputValue]
      };
      this.renderer.removeClass(button, classesToRemove[input]);
      if (classesToAdd[input]) {
        this.renderer.addClass(button, classesToAdd[input]);
      }
    }
  }
  onEnterPressed() {
    const index = this.focusService.focused;
    this.emitItemClick(index);
  }
  emitItemClick(index) {
    const item = this.dialItems[index];
    if (item && !item.disabled) {
      const clickEventArgs = {
        item: item,
        index: index
      };
      this.dialItemClick.emit(clickEventArgs);
      this.toggleDialWithEvents(false);
      this.focusService.focused = index;
    }
    this.focus();
  }
  subscribeNavigationEvents() {
    this.subscriptions.add(this.navigationService.navigate.subscribe(this.onArrowKeyNavigate.bind(this)));
    this.subscriptions.add(this.navigationService.enter.subscribe(this.onNavigationEnterPress.bind(this)));
    this.subscriptions.add(merge(this.navigationService.close, this.navigationService.esc).subscribe(this.onNavigationClose.bind(this)));
  }
  onArrowKeyNavigate({
    index
  }) {
    this.focusService.focus(index);
  }
  alignClass() {
    return `k-pos-${this.align.vertical}-${this.align.horizontal}`;
  }
  toggleDialWithEvents(open) {
    if (open === this.isOpen) {
      return;
    }
    const event = new PreventableEvent();
    if (open) {
      this.open.emit(event);
    } else {
      this.close.emit(event);
    }
    if (event.isDefaultPrevented()) {
      return;
    }
    if (open) {
      this.openDial();
    } else {
      this.closeDial();
    }
  }
  openPopup() {
    if (this.isOpen) {
      return;
    }
    const isIconFab = this.icon && !this.text;
    const rtl = this.rtl;
    const align = this.align;
    this.popupRef = this.popupService.open({
      anchor: this.element.nativeElement,
      animate: false,
      content: this.popupTemplate,
      anchorAlign: getAnchorAlign(align, rtl),
      popupAlign: getPopupAlign(align, rtl),
      popupClass: 'k-fab-popup k-popup-transparent'
    });
    const popupElement = this.popupRef.popupElement;
    this.renderer.setStyle(popupElement, 'box-shadow', 'none');
    if (isIconFab) {
      this.subscriptions.add(this.popupRef.popupOpen.subscribe(() => this.positionPopup()));
    }
    this.ngZone.runOutsideAngular(() => {
      this.popupMouseDownListener = this.renderer.listen(popupElement, 'mousedown', event => {
        event.preventDefault();
      });
    });
    this.subscriptions.add(this.popupRef.popupAnchorViewportLeave.subscribe(() => this.toggleDialWithEvents(false)));
  }
  closePopup() {
    if (this.isOpen) {
      if (this.popupMouseDownListener) {
        this.popupMouseDownListener();
      }
      this.popupRef.close();
      this.popupRef = null;
    }
  }
  openDial() {
    this.openPopup();
    this.focusService.focus(0);
    if (this.dialItemAnimation && this.isValidAnimation()) {
      this.playAnimation(true);
    }
    this.renderer.setAttribute(this.button.nativeElement, 'aria-expanded', 'true');
  }
  closeDial() {
    if (this.dialItemAnimation && this.isValidAnimation()) {
      this.playAnimation(false);
      this.animationEnd.pipe(take(1)).subscribe(() => this.closePopup());
    } else {
      this.closePopup();
    }
    this.renderer.setAttribute(this.button.nativeElement, 'aria-expanded', 'false');
    this.focusService.resetFocus();
  }
  isValidAnimation() {
    const animation = this.dialItemAnimation;
    if (typeof animation !== 'boolean') {
      return animation.duration !== 0;
    }
    return true;
  }
  positionPopup() {
    if (this.dialItemTemplate) {
      return;
    }
    if (!this.popupRef) {
      return;
    }
    const fab = this.element.nativeElement;
    const fabWidth = fab.getBoundingClientRect().width;
    const popupEl = this.popupRef.popupElement;
    const icon = popupEl.querySelector('.k-fab-item-icon');
    if (!icon) {
      return;
    }
    const iconWidth = icon.getBoundingClientRect().width;
    const left = fabWidth / 2 - iconWidth / 2;
    const popupLeft = popupEl.getBoundingClientRect().left;
    const isEndAlign = this.align.horizontal === 'end';
    const leftValue = isEndAlign ? popupLeft - left : left + popupLeft;
    const rtlLeftValue = isEndAlign ? left + popupLeft : popupLeft - left;
    popupEl.style.left = this.rtl ? `${rtlLeftValue}px` : `${leftValue}px`;
  }
  offsetStyles() {
    const hostElement = this.element.nativeElement;
    this.renderer.setStyle(hostElement, this.horizontalPosition, this.horizontalOffset);
    this.renderer.setStyle(hostElement, this.verticalPosition, this.verticalOffset);
  }
  get hasDialItems() {
    return isPresent(this.dialItems) && this.dialItems.length !== 0;
  }
  /**
   * Gets the CSS prop name of the selected vertical position (`top`/`bottom`);
   */
  get verticalPosition() {
    return {
      top: 'top',
      middle: 'top',
      bottom: 'bottom'
    }[this.align.vertical];
  }
  /**
   * Gets the offset according to the selected vertical position.
   */
  get verticalOffset() {
    if (this.align.vertical === 'middle') {
      return this.offset.y === DEFAULT_OFFSET ? '50%' : `calc(50% + ${this.offset.y})`;
    }
    return this.offset.y;
  }
  /**
   * Gets the CSS prop name of the selected horizontal position (`left`/`right`);
   */
  get horizontalPosition() {
    const {
      horizontal
    } = this.align;
    return {
      end: this.rtl ? 'left' : 'right',
      center: 'left',
      start: this.rtl ? 'right' : 'left'
    }[horizontal];
  }
  /**
   * Gets the offset according to the selected horizontal position.
   */
  get horizontalOffset() {
    if (this.align.horizontal === 'center') {
      return this.offset.x === DEFAULT_OFFSET ? '50%' : `calc(50% + ${this.offset.x})`;
    }
    return this.offset.x;
  }
  playerFor(element, animation) {
    const factory = this.builder.build(animation);
    return factory.create(element);
  }
  playAnimation(open) {
    const durationSettings = this.durationSettings();
    const animationSettings = {
      duration: durationSettings.duration,
      gap: durationSettings.gap,
      align: this.align
    };
    const animation = open ? openAnimation(animationSettings) : closeAnimation(animationSettings);
    let player = this.playerFor(this.popupRef.popupElement, animation);
    player.play();
    player.onDone(() => {
      if (player) {
        this.animationEnd.emit();
        player.destroy();
        player = null;
      }
    });
  }
  durationSettings() {
    return {
      duration: this.animationDuration(),
      gap: this.animationGap()
    };
  }
  animationGap() {
    const animation = this.dialItemAnimation;
    if (typeof animation !== 'boolean' && isPresent(animation.gap)) {
      return animation.gap;
    }
    return DEFAULT_ITEM_GAP;
  }
  animationDuration() {
    const animation = this.dialItemAnimation;
    if (typeof animation !== 'boolean' && isPresent(animation.duration)) {
      return animation.duration;
    }
    return DEFAULT_DURATION;
  }
  static ɵfac = function FloatingActionButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FloatingActionButtonComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(FocusService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i3.PopupService), i0.ɵɵdirectiveInject(i4.AnimationBuilder), i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FloatingActionButtonComponent,
    selectors: [["kendo-floatingactionbutton"]],
    contentQueries: function FloatingActionButtonComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, DialItemTemplateDirective, 5)(dirIndex, FloatingActionButtonTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialItemTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fabTemplate = _t.first);
      }
    },
    viewQuery: function FloatingActionButtonComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c5, 7)(_c7, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
      }
    },
    hostVars: 5,
    hostBindings: function FloatingActionButtonComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.direction);
        i0.ɵɵclassProp("k-pos-fixed", ctx.fixedClass)("k-pos-absolute", ctx.absoluteClass);
      }
    },
    inputs: {
      themeColor: "themeColor",
      size: "size",
      rounded: "rounded",
      disabled: "disabled",
      align: "align",
      offset: "offset",
      positionMode: "positionMode",
      icon: "icon",
      svgIcon: "svgIcon",
      iconClass: "iconClass",
      buttonClass: "buttonClass",
      dialClass: "dialClass",
      text: "text",
      dialItemAnimation: "dialItemAnimation",
      tabIndex: "tabIndex",
      dialItems: "dialItems"
    },
    outputs: {
      onBlur: "blur",
      onFocus: "focus",
      dialItemClick: "dialItemClick",
      open: "open",
      close: "close"
    },
    features: [i0.ɵɵProvidersFeature([FocusService, NavigationService, NAVIGATION_SETTINGS_PROVIDER$1, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.floatingactionbutton'
    }])],
    decls: 6,
    vars: 18,
    consts: [["button", ""], ["popupTemplate", ""], ["type", "button", 1, "k-fab", 3, "focus", "blur", "tabIndex", "ngClass", "disabled", "kendoEventsOutsideAngular", "scope"], [3, "ngTemplateOutlet"], ["innerCssClass", "k-fab-icon", 3, "name", "customFontClass", "svgIcon"], [1, "k-fab-text"], ["kendoDialList", "", "role", "menu", 3, "click", "id", "ngClass", "dialItems", "dialItemTemplate", "align", "kendoEventsOutsideAngular"]],
    template: function FloatingActionButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 2, 0);
        i0.ɵɵlistener("focus", function FloatingActionButtonComponent_Template_button_focus_0_listener() {
          return ctx.focusHandler();
        })("blur", function FloatingActionButtonComponent_Template_button_blur_0_listener($event) {
          return ctx.blurHandler($event);
        });
        i0.ɵɵconditionalCreate(2, FloatingActionButtonComponent_Conditional_2_Template, 1, 1, null, 3);
        i0.ɵɵconditionalCreate(3, FloatingActionButtonComponent_Conditional_3_Template, 2, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, FloatingActionButtonComponent_ng_template_4_Template, 1, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("k-disabled", ctx.disabled);
        i0.ɵɵproperty("tabIndex", ctx.componentTabIndex)("ngClass", ctx.buttonClass)("disabled", ctx.disabled)("kendoEventsOutsideAngular", i0.ɵɵpureFunction3(14, _c12, ctx.keyDownHandler, ctx.clickHandler, ctx.pointerdownHandler))("scope", ctx);
        i0.ɵɵattribute("id", ctx.id)("aria-disabled", ctx.disabled || null)("aria-expanded", ctx.ariaExpanded)("aria-haspopup", ctx.ariaHasPopup)("aria-controls", ctx.ariaControls);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.fabTemplate ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.fabTemplate ? 3 : -1);
      }
    },
    dependencies: [NgClass, EventsOutsideAngularDirective, NgTemplateOutlet, IconWrapperComponent, DialListComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FloatingActionButtonComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-floatingactionbutton',
      providers: [FocusService, NavigationService, NAVIGATION_SETTINGS_PROVIDER$1, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.floatingactionbutton'
      }],
      template: `
        <button
            #button
            [attr.id]="id"
            [tabIndex]="componentTabIndex"
            type="button"
            class="k-fab"
            [class.k-disabled]="disabled"
            [ngClass]="buttonClass"
            [disabled]="disabled"
            [attr.aria-disabled]="disabled || null"
            [attr.aria-expanded]="ariaExpanded"
            [attr.aria-haspopup]="ariaHasPopup"
            [attr.aria-controls]="ariaControls"
            (focus)="focusHandler()"
            (blur)="blurHandler($event)"
            [kendoEventsOutsideAngular]="{
                keydown: keyDownHandler,
                click: clickHandler,
                pointerdown: pointerdownHandler
            }"
          [scope]="this"
          >
          @if (fabTemplate) {
            <ng-template
              [ngTemplateOutlet]="fabTemplate?.templateRef"
              >
            </ng-template>
          }

          @if (!fabTemplate) {
            @if (icon || iconClass || svgIcon) {
              <kendo-icon-wrapper
                [name]="icon"
                innerCssClass="k-fab-icon"
                [customFontClass]="iconClass"
              [svgIcon]="svgIcon"></kendo-icon-wrapper>
            }
            @if (text) {
              <span class="k-fab-text">{{ text }}</span>
            }
          }
        </button>

        <ng-template #popupTemplate>
          <ul
            kendoDialList
            role="menu"
            [id]="dialListId"
            [ngClass]="dialClass"
            [dialItems]="dialItems"
            [dialItemTemplate]='dialItemTemplate?.templateRef'
            [align]="align"
            [attr.aria-labelledby]="id"
            (click)="onItemClick($event)"
                [kendoEventsOutsideAngular]="{
                    keydown: keyDownHandler.bind(this),
                    focusout: focusOutHandler.bind(this)
                }"
            >
          </ul>
        </ng-template>
        `,
      standalone: true,
      imports: [NgClass, EventsOutsideAngularDirective, NgTemplateOutlet, IconWrapperComponent, DialListComponent]
    }]
  }], () => [{
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }, {
    type: FocusService
  }, {
    type: NavigationService
  }, {
    type: i0.NgZone
  }, {
    type: i3.PopupService
  }, {
    type: i4.AnimationBuilder
  }, {
    type: i1.LocalizationService
  }], {
    fixedClass: [{
      type: HostBinding,
      args: ['class.k-pos-fixed']
    }],
    absoluteClass: [{
      type: HostBinding,
      args: ['class.k-pos-absolute']
    }],
    direction: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    button: [{
      type: ViewChild,
      args: ['button', {
        static: true
      }]
    }],
    popupTemplate: [{
      type: ViewChild,
      args: ['popupTemplate', {
        static: true
      }]
    }],
    dialItemTemplate: [{
      type: ContentChild,
      args: [DialItemTemplateDirective, {
        static: false
      }]
    }],
    fabTemplate: [{
      type: ContentChild,
      args: [FloatingActionButtonTemplateDirective, {
        static: false
      }]
    }],
    themeColor: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    align: [{
      type: Input
    }],
    offset: [{
      type: Input
    }],
    positionMode: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    iconClass: [{
      type: Input
    }],
    buttonClass: [{
      type: Input
    }],
    dialClass: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    dialItemAnimation: [{
      type: Input
    }],
    tabIndex: [{
      type: Input
    }],
    dialItems: [{
      type: Input
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    dialItemClick: [{
      type: Output,
      args: ['dialItemClick']
    }],
    open: [{
      type: Output
    }],
    close: [{
      type: Output
    }]
  });
})();

/**
 * @hidden
 */
class Messages extends ComponentMessages {
  /**
   * Specifies the text for the SplitButton `aria-label`.
   *
   * The `aria-label` text consists of two parts: the SplitButton text and a localizable string.
   * For example, for a SplitButton with the text `'Reply'`, the default `aria-label` is `'Reply splitbutton'`.
   *
   * To reorder the SplitButton text and the localizable part, use the `splitButtonLabel` property with a
   * placeholder for the button text, such as `'splitbutton for {buttonText}'`. The `{buttonText}` placeholder
   * is replaced internally with the current SplitButton text. For instance, the resulting `aria-label` is
   * rendered as `'splitbutton for Reply'`.
   *
   * @example
   * ```ts
   * <kendo-splitbutton>
   *     <kendo-splitbutton-messages
   *         splitButtonLabel="splitbutton for {buttonText}">
   *     </kendo-splitbutton-messages>
   * </kendo-splitbutton>
   * ```
   */
  splitButtonLabel;
  /**
   * Specifies the text for the SplitButton toggle button `aria-label`.
   */
  toggleButtonLabel;
  static ɵfac = /* @__PURE__ */(() => {
    let ɵMessages_BaseFactory;
    return function Messages_Factory(__ngFactoryType__) {
      return (ɵMessages_BaseFactory || (ɵMessages_BaseFactory = i0.ɵɵgetInheritedFactory(Messages)))(__ngFactoryType__ || Messages);
    };
  })();
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: Messages,
    selectors: [["kendo-splitbutton-messages-base"]],
    inputs: {
      splitButtonLabel: "splitButtonLabel",
      toggleButtonLabel: "toggleButtonLabel"
    },
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Messages, [{
    type: Directive,
    args: [{
      selector: 'kendo-splitbutton-messages-base'
    }]
  }], null, {
    splitButtonLabel: [{
      type: Input
    }],
    toggleButtonLabel: [{
      type: Input
    }]
  });
})();

/**
 * Represents a custom component for overriding the default SplitButton messages.
 * ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/globalization)).
 */
class SplitButtonCustomMessagesComponent extends Messages {
  service;
  constructor(service) {
    super();
    this.service = service;
  }
  get override() {
    return true;
  }
  static ɵfac = function SplitButtonCustomMessagesComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SplitButtonCustomMessagesComponent)(i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SplitButtonCustomMessagesComponent,
    selectors: [["kendo-splitbutton-messages"]],
    features: [i0.ɵɵProvidersFeature([{
      provide: Messages,
      useExisting: forwardRef(() => SplitButtonCustomMessagesComponent)
    }]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function SplitButtonCustomMessagesComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitButtonCustomMessagesComponent, [{
    type: Component,
    args: [{
      providers: [{
        provide: Messages,
        useExisting: forwardRef(() => SplitButtonCustomMessagesComponent)
      }],
      selector: 'kendo-splitbutton-messages',
      template: ``,
      standalone: true
    }]
  }], () => [{
    type: i1.LocalizationService
  }], null);
})();

/**
 * @hidden
 */
class LocalizedSplitButtonMessagesDirective extends Messages {
  service;
  constructor(service) {
    super();
    this.service = service;
  }
  static ɵfac = function LocalizedSplitButtonMessagesDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LocalizedSplitButtonMessagesDirective)(i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: LocalizedSplitButtonMessagesDirective,
    selectors: [["", "kendoSplitButtonLocalizedMessages", ""]],
    features: [i0.ɵɵProvidersFeature([{
      provide: Messages,
      useExisting: forwardRef(() => LocalizedSplitButtonMessagesDirective)
    }]), i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalizedSplitButtonMessagesDirective, [{
    type: Directive,
    args: [{
      providers: [{
        provide: Messages,
        useExisting: forwardRef(() => LocalizedSplitButtonMessagesDirective)
      }],
      selector: '[kendoSplitButtonLocalizedMessages]',
      standalone: true
    }]
  }], () => [{
    type: i1.LocalizationService
  }], null);
})();
const NAVIGATION_SETTINGS = {
  useLeftRightArrows: true
};
const NAVIGATION_SETTINGS_PROVIDER = {
  provide: NAVIGATION_CONFIG,
  useValue: NAVIGATION_SETTINGS
};
/**
 * Represents the Kendo UI SplitButton component for Angular.
 *
 * @example
 * ```ts
 * @Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-splitbutton [data]="items" (buttonClick)="onSplitButtonClick()">Paste</kendo-splitbutton>
 * `
 * })
 *
 * class AppComponent {
 *   public items: Array<any> = [{
 *       text: 'Keep Text Only',
 *       icon: 'clipboard-text',
 *       click: () => { console.log('Keep Text Only click handler'); }
 *   }, {
 *       text: 'Paste as HTML',
 *       icon: 'clipboard-code'
 *     }
 *  ];
 *
 *   public onSplitButtonClick(dataItem: any): void {
 *       console.log('Paste');
 *   }
 * }
 * ```
 */
class SplitButtonComponent extends ListButton {
  localization;
  renderer;
  /**
   * Sets the text displayed within the SplitButton.
   *
   * @remarks
   * This property is related to accessibility.
   */
  text = '';
  /**
   * Specifies an icon to display next to the button text ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/splitbutton/data-binding#arrays-of-complex-data)).
   */
  icon = '';
  /**
   * Specifies an `SVGIcon` to display next to the button text.
   */
  svgIcon;
  /**
   * Specifies a custom CSS class for the icon displayed next to the button text ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/splitbutton/data-binding#arrays-of-complex-data)).
   */
  iconClass;
  /**
   * Specifies the `type` attribute of the main button.
   */
  type = 'button';
  /**
   * Specifies the URL of an image to display next to the button text ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/splitbutton/data-binding#arrays-of-complex-data)).
   */
  imageUrl = '';
  /**
   * Configures the padding of the SplitButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/api/splitbuttoncomponent#size)). The default value is set by the Kendo theme.
   */
  size = undefined;
  /**
   * Configures the border radius of the SplitButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/api/splitbuttoncomponent#rounded)). The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.handleClasses(rounded, 'rounded');
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Configures the background and border styles of the SplitButton ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/api/splitbuttoncomponent#fillmode)). The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this._fillMode = fillMode === 'clear' ? 'flat' : fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Configures the theme color of the SplitButton. The theme color applies to the background, border, and text ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/api/splitbuttoncomponent#themecolor)). The default value is set by the Kendo theme.
   */
  themeColor = undefined;
  /**
   * Disables the SplitButton when set to `true` ([see example](https://www.telerik.com/kendo-angular-ui/components/buttons/splitbutton/data-binding#arrays-of-complex-data)).
   */
  set disabled(value) {
    if (this.isOpen) {
      this.toggle(false);
    }
    this._disabled = value;
  }
  get disabled() {
    return this._disabled;
  }
  /**
   * Configures the popup settings of the SplitButton.
   */
  set popupSettings(settings) {
    this._popupSettings = {
      animate: true,
      popupClass: '',
      ...settings
    };
  }
  get popupSettings() {
    return this._popupSettings;
  }
  /**
   * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
   *
   * @default 0
   */
  tabIndex = 0;
  /**
   * Configures the text field of the button-list popup.
   */
  textField;
  /**
   * Sets the data for the SplitButton. Provide the data as an array-like list.
   */
  set data(data) {
    this._data = data || [];
  }
  get data() {
    if (!this._data) {
      this.data = [];
    }
    return this._data;
  }
  /**
   * Specifies the CSS classes for the button that opens the popup.
   * Supports values compatible with [`ngClass`](link:site.data.urls.angular['ngclassapi']).
   */
  arrowButtonClass;
  /**
   * Specifies the name of the font icon displayed on the button that opens the popup.
   */
  arrowButtonIcon = 'chevron-down';
  /**
   * Specifies the [`SVGIcon`](https://www.telerik.com/kendo-angular-ui/components/icons/api/svgiconcomponent) displayed on the button that opens the popup.
   */
  arrowButtonSvgIcon = chevronDownIcon;
  /**
   * Sets attributes for the main button.
   */
  set buttonAttributes(buttonAttributes) {
    const newButtonAttributes = buttonAttributes || null;
    this.handleButtonAttributes(newButtonAttributes);
    this._buttonAttributes = newButtonAttributes;
  }
  get buttonAttributes() {
    return this._buttonAttributes;
  }
  /**
   * Emits an event when the main button is clicked.
   */
  buttonClick = new EventEmitter();
  /**
   * Emits an event when an item in the drop-down list is clicked. The event data contains the clicked item's data.
   */
  itemClick = new EventEmitter();
  /**
   * Emits an event when the SplitButton gains focus.
   */
  onFocus = new EventEmitter();
  /**
   * Emits an event when the SplitButton is blurred.
   */
  onBlur = new EventEmitter();
  /**
   * Emits an event before the popup opens. This event is preventable.
   */
  open = new EventEmitter();
  /**
   * Emits an event before the popup closes. This event is preventable.
   */
  close = new EventEmitter();
  /**
   * Specifies a template to customize the content of the items in the drop-down list.
   */
  itemTemplate;
  activeArrow = false;
  listId = guid();
  /**
   * @hidden
   */
  get hasContent() {
    return this.button?.nativeElement.childElementCount > 0;
  }
  /**
   * @hidden
   */
  get active() {
    return this._active;
  }
  /**
   * @hidden
   */
  get componentTabIndex() {
    return this.disabled ? -1 : this.tabIndex;
  }
  buttonText = '';
  arrowButtonClicked = false;
  _rounded = undefined;
  _fillMode = undefined;
  _buttonAttributes = null;
  documentMouseUpSub;
  set isFocused(value) {
    this._isFocused = value;
  }
  get isFocused() {
    return this._isFocused && !this._disabled && isDocumentAvailable() && this.wrapperContains(document.activeElement);
  }
  get widgetClasses() {
    return true;
  }
  get dir() {
    return this.direction;
  }
  /**
   * @hidden
   */
  get ariaLabel() {
    const localizationMsg = this.messageFor('splitButtonLabel') || '';
    return replaceMessagePlaceholder(localizationMsg, 'buttonText', this.buttonText);
  }
  /**
   * @hidden
   */
  messageFor(key) {
    return this.localization.get(key);
  }
  /**
   * @hidden
   */
  onButtonFocus(event) {
    if (!this._disabled) {
      if (!this._isFocused) {
        this.onFocus.emit();
      }
      this._isFocused = true;
      this.focusService.resetFocus();
      const relatedTargetInList = event.relatedTarget && closest(event.relatedTarget, '.k-popup kendo-button-list');
      if (this.openState && !relatedTargetInList) {
        this.focusService.focus(0);
      }
    }
  }
  /**
   * @hidden
   */
  onArrowButtonClick() {
    this.togglePopupVisibility();
    this.arrowButtonClicked = false;
    if (!this.isOpen) {
      this.focus();
    }
  }
  /**
   * @hidden
   */
  toggleButtonActiveState(enable) {
    this._active = enable;
  }
  /**
   * @hidden
   */
  toggleArrowButtonActiveState(enable) {
    this.arrowButtonClicked = true;
    this.activeArrow = enable;
  }
  /**
   * @hidden
   */
  onButtonClick() {
    this.buttonClick.emit();
  }
  /**
   * @hidden
   */
  onButtonBlur() {
    if (!this.isOpen && !this.arrowButtonClicked) {
      this.blurWrapper();
    }
  }
  /**
   * @hidden
   */
  keydown(event) {
    this.keyDownHandler(event, true);
    if (event.code === Keys.Space) {
      this._active = true;
    }
  }
  /**
   * @hidden
   */
  keyup(event) {
    this._active = false;
    if (event.code !== Keys.Space) {
      this.keyUpHandler(event);
    }
  }
  ngDoCheck() {
    this.updateButtonText();
  }
  ngAfterViewInit() {
    this.containerService.container = this.container;
    this.containerService.template = this.popupTemplate;
    this.handleClasses(this.rounded, 'rounded');
    this.handleButtonAttributes(this.buttonAttributes);
  }
  ngOnChanges(changes) {
    if (changes.hasOwnProperty('text')) {
      this.updateButtonText();
    }
    if (anyChanged(['text', 'icon', 'svgIcon', 'iconClass', 'imageUrl'], changes)) {
      this.toggleButtonIconClass();
    }
    if (isChanged('popupSettings', changes) && isPresent(this.popupRef)) {
      const popup = this.popupRef.popup.instance;
      const newSettings = changes['popupSettings'].currentValue;
      popup.popupClass = newSettings.popupClass;
      popup.animate = newSettings.animate;
      popup.popupAlign = this.popupAlign;
    }
  }
  /**
   * @hidden
   */
  ngOnDestroy() {
    if (this.documentMouseUpSub) {
      this.documentMouseUpSub();
    }
    super.ngOnDestroy();
  }
  /**
   * @hidden
   */
  onNavigationEnterUp(args) {
    if (args.target !== this.button.nativeElement) {
      super.onNavigationEnterUp(args);
    }
  }
  /**
   * @hidden
   */
  togglePopupVisibility() {
    if (isDocumentAvailable() && this.wrapperContains(document.activeElement) && this.arrowButtonClicked) {
      this.button.nativeElement.focus();
    }
    super.togglePopupVisibility();
  }
  /**
   * @hidden
   */
  wrapperContains(element) {
    return this.wrapper === element || this.wrapper.contains(element);
  }
  /**
   * @hidden
   */
  get anchorAlign() {
    const align = {
      horizontal: this.popupSettings.align || 'left',
      vertical: 'bottom'
    };
    if (this.direction === 'rtl' && !isPresent(this.popupSettings.align)) {
      align.horizontal = 'right';
    }
    return align;
  }
  /**
   * @hidden
   */
  get popupAlign() {
    const align = {
      horizontal: this.popupSettings.align || 'left',
      vertical: 'top'
    };
    if (this.direction === 'rtl' && !isPresent(this.popupSettings.align)) {
      align.horizontal = 'right';
    }
    return align;
  }
  /**
   * @hidden
   */
  get isIconButton() {
    const hasIcon = this.icon || this.svgIcon || this.iconClass || this.imageUrl;
    const hasTextContent = isDocumentAvailable() && this.button?.nativeElement.textContent.trim().length > 0;
    return hasIcon && !hasTextContent;
  }
  /**
   * Focuses the SplitButton component.
   */
  focus() {
    if (isDocumentAvailable()) {
      this.button.nativeElement.focus();
    }
  }
  /**
   * Blurs the SplitButton component.
   */
  blur() {
    if (isDocumentAvailable()) {
      this.button.nativeElement.blur();
      this.blurWrapper();
    }
  }
  constructor(focusService, navigationService, wrapperRef, zone, popupService, elRef, localization, cdr, renderer, containerService) {
    super(focusService, navigationService, wrapperRef, zone, popupService, elRef, localization, cdr, containerService);
    this.localization = localization;
    this.renderer = renderer;
    this._itemClick = this.itemClick;
    this._blur = this.onBlur;
    zone.runOutsideAngular(() => {
      this.documentMouseUpSub = this.renderer.listen('document', 'mouseup', () => {
        if (this.active) {
          zone.run(() => this._active = false);
        }
        if (this.activeArrow) {
          zone.run(() => this.activeArrow = false);
        }
      });
    });
  }
  /**
   * Returns the current open state of the popup.
   */
  get isOpen() {
    return this.openState;
  }
  updateButtonText() {
    if (isDocumentAvailable()) {
      const innerText = this.wrapper?.innerText.split('\n').join('').trim();
      if (innerText !== this.buttonText) {
        this.buttonText = innerText;
      }
    }
  }
  handleClasses(value, input) {
    const elem = this.wrapperRef.nativeElement;
    const classes = getStylingClasses('button', input, this[input], value);
    if (classes.toRemove) {
      this.renderer.removeClass(elem, classes.toRemove);
    }
    if (classes.toAdd) {
      this.renderer.addClass(elem, classes.toAdd);
    }
  }
  toggleButtonIconClass() {
    this.button.nativeElement.classList[this.isIconButton ? 'add' : 'remove']('k-button-icon');
  }
  handleButtonAttributes(newButtonAttributes) {
    const mainButton = this.button?.nativeElement;
    if (isPresent(this.buttonAttributes) && isPresent(mainButton)) {
      for (const attr in this.buttonAttributes) {
        this.renderer.removeAttribute(mainButton, attr, this.buttonAttributes[attr]);
      }
    }
    if (isPresent(newButtonAttributes) && isPresent(mainButton)) {
      for (const attr in newButtonAttributes) {
        this.renderer.setAttribute(mainButton, attr, newButtonAttributes[attr]);
      }
    }
  }
  static ɵfac = function SplitButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SplitButtonComponent)(i0.ɵɵdirectiveInject(FocusService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i3.PopupService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(PopupContainerService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SplitButtonComponent,
    selectors: [["kendo-splitbutton"]],
    contentQueries: function SplitButtonComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ButtonItemTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
      }
    },
    hostVars: 7,
    hostBindings: function SplitButtonComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function SplitButtonComponent_keydown_HostBindingHandler($event) {
          return ctx.keydown($event);
        })("keyup", function SplitButtonComponent_keyup_HostBindingHandler($event) {
          return ctx.keyup($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.dir);
        i0.ɵɵclassProp("k-focus", ctx.isFocused)("k-split-button", ctx.widgetClasses)("k-button-group", ctx.widgetClasses);
      }
    },
    inputs: {
      text: "text",
      icon: "icon",
      svgIcon: "svgIcon",
      iconClass: "iconClass",
      type: "type",
      imageUrl: "imageUrl",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      themeColor: "themeColor",
      disabled: "disabled",
      popupSettings: "popupSettings",
      tabIndex: "tabIndex",
      textField: "textField",
      data: "data",
      arrowButtonClass: "arrowButtonClass",
      arrowButtonIcon: "arrowButtonIcon",
      arrowButtonSvgIcon: "arrowButtonSvgIcon",
      buttonAttributes: "buttonAttributes"
    },
    outputs: {
      buttonClick: "buttonClick",
      itemClick: "itemClick",
      onFocus: "focus",
      onBlur: "blur",
      open: "open",
      close: "close"
    },
    exportAs: ["kendoSplitButton"],
    features: [i0.ɵɵProvidersFeature([FocusService, NavigationService, NAVIGATION_SETTINGS_PROVIDER, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.splitbutton'
    }, PopupContainerService, {
      provide: MultiTabStop,
      useExisting: forwardRef(() => SplitButtonComponent)
    }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c1,
    decls: 12,
    vars: 31,
    consts: () => {
      let i18n_0;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text for the SplitButton toggle button aria-label
         * @meaning kendo.splitbutton.toggleButtonLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_BUTTONS_FESM2022_PROGRESS_KENDO_ANGULAR_BUTTONS_MJS_0 = goog.getMsg("Toggle options");
        i18n_0 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_BUTTONS_FESM2022_PROGRESS_KENDO_ANGULAR_BUTTONS_MJS_0;
      } else {
        i18n_0 = $localize`:kendo.splitbutton.toggleButtonLabel|The text for the SplitButton toggle button aria-label:Toggle options`;
      }
      let i18n_1;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text for the SplitButton aria-label
         * @meaning kendo.splitbutton.splitButtonLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_BUTTONS_FESM2022_PROGRESS_KENDO_ANGULAR_BUTTONS_MJS_1 = goog.getMsg("{$interpolation}", {
          "interpolation": "\uFFFD0\uFFFD"
        }, {
          original_code: {
            "interpolation": "{{ '{buttonText} splitbutton' }}"
          }
        });
        i18n_1 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_BUTTONS_FESM2022_PROGRESS_KENDO_ANGULAR_BUTTONS_MJS_1;
      } else {
        i18n_1 = $localize`:kendo.splitbutton.splitButtonLabel|The text for the SplitButton aria-label:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
      }
      return [["button", ""], ["arrowButton", ""], ["popupTemplate", ""], ["container", ""], ["splitButtonLabel", i18n_1], ["kendoSplitButtonLocalizedMessages", "", "toggleButtonLabel", i18n_0, 6, "splitButtonLabel"], ["kendoButton", "", 3, "focus", "click", "blur", "mousedown", "mouseup", "type", "tabindex", "disabled", "size", "rounded", "fillMode", "themeColor", "icon", "svgIcon", "iconClass", "imageUrl", "ngClass"], [1, "k-button-text"], ["kendoButton", "", "type", "button", 1, "k-split-button-arrow", 3, "click", "mousedown", "mouseup", "keydown.enter", "ngClass", "disabled", "icon", "svgIcon", "size", "rounded", "fillMode", "themeColor", "tabindex"], [3, "onItemClick", "keydown", "keyup", "id", "data", "textField", "itemTemplate"]];
    },
    template: function SplitButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementContainerStart(0, 5);
        i0.ɵɵi18nAttributes(1, 4);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementStart(2, "button", 6, 0);
        i0.ɵɵlistener("focus", function SplitButtonComponent_Template_button_focus_2_listener($event) {
          return ctx.onButtonFocus($event);
        })("click", function SplitButtonComponent_Template_button_click_2_listener() {
          return ctx.onButtonClick();
        })("blur", function SplitButtonComponent_Template_button_blur_2_listener() {
          return ctx.onButtonBlur();
        })("mousedown", function SplitButtonComponent_Template_button_mousedown_2_listener() {
          return ctx.toggleButtonActiveState(true);
        })("mouseup", function SplitButtonComponent_Template_button_mouseup_2_listener() {
          return ctx.toggleButtonActiveState(false);
        });
        i0.ɵɵconditionalCreate(4, SplitButtonComponent_Conditional_4_Template, 2, 1, "span", 7);
        i0.ɵɵprojection(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "button", 8, 1);
        i0.ɵɵlistener("click", function SplitButtonComponent_Template_button_click_6_listener() {
          return ctx.onArrowButtonClick();
        })("mousedown", function SplitButtonComponent_Template_button_mousedown_6_listener() {
          return ctx.toggleArrowButtonActiveState(true);
        })("mouseup", function SplitButtonComponent_Template_button_mouseup_6_listener() {
          return ctx.toggleArrowButtonActiveState(false);
        })("keydown.enter", function SplitButtonComponent_Template_button_keydown_enter_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          $event.stopImmediatePropagation();
          return i0.ɵɵresetView($event.preventDefault());
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, SplitButtonComponent_ng_template_8_Template, 1, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementContainer(10, null, 3);
      }
      if (rf & 2) {
        i0.ɵɵi18nExp("{buttonText} splitbutton");
        i0.ɵɵi18nApply(1);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("k-active", ctx.active);
        i0.ɵɵproperty("type", ctx.type)("tabindex", ctx.componentTabIndex)("disabled", ctx.disabled)("size", ctx.size)("rounded", ctx.rounded)("fillMode", ctx.fillMode)("themeColor", ctx.themeColor)("icon", ctx.icon)("svgIcon", ctx.svgIcon)("iconClass", ctx.iconClass)("imageUrl", ctx.imageUrl)("ngClass", ctx.buttonClass);
        i0.ɵɵattribute("aria-label", ctx.ariaLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.text ? 4 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("k-active", ctx.activeArrow);
        i0.ɵɵproperty("ngClass", ctx.arrowButtonClass)("disabled", ctx.disabled)("icon", ctx.arrowButtonIcon)("svgIcon", ctx.arrowButtonSvgIcon)("size", ctx.size)("rounded", ctx.rounded)("fillMode", ctx.fillMode)("themeColor", ctx.themeColor)("tabindex", -1);
        i0.ɵɵattribute("aria-label", ctx.messageFor("toggleButtonLabel"))("aria-expanded", ctx.openState)("aria-controls", ctx.openState ? ctx.listId : null);
      }
    },
    dependencies: [LocalizedSplitButtonMessagesDirective, ButtonComponent, NgClass, ListComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitButtonComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoSplitButton',
      providers: [FocusService, NavigationService, NAVIGATION_SETTINGS_PROVIDER, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.splitbutton'
      }, PopupContainerService, {
        provide: MultiTabStop,
        useExisting: forwardRef(() => SplitButtonComponent)
      }],
      selector: 'kendo-splitbutton',
      template: `
        <ng-container kendoSplitButtonLocalizedMessages
          i18n-splitButtonLabel="kendo.splitbutton.splitButtonLabel|The text for the SplitButton aria-label"
          splitButtonLabel="{{ '{buttonText} splitbutton' }}"
          i18n-toggleButtonLabel="kendo.splitbutton.toggleButtonLabel|The text for the SplitButton toggle button aria-label"
          toggleButtonLabel="Toggle options"
        ></ng-container>
        <button
          kendoButton
          #button
          [type]="type"
          [tabindex]="componentTabIndex"
          [disabled]="disabled"
          [size]="size"
          [rounded]="rounded"
          [fillMode]="fillMode"
          [themeColor]="themeColor"
          [icon]="icon"
          [svgIcon]="svgIcon"
          [class.k-active]="active"
          [iconClass]="iconClass"
          [imageUrl]="imageUrl"
          [ngClass]="buttonClass"
          (focus)="onButtonFocus($event)"
          (click)="onButtonClick()"
          (blur)="onButtonBlur()"
          (mousedown)="toggleButtonActiveState(true)"
          (mouseup)="toggleButtonActiveState(false)"
          [attr.aria-label]="ariaLabel"
          >
          @if (text) {
            <span class="k-button-text">
            {{ text }} </span>
            }<ng-content></ng-content>
          </button>
          <button kendoButton #arrowButton type="button"
            class="k-split-button-arrow"
            [class.k-active]="activeArrow"
            [ngClass]="arrowButtonClass"
            [disabled]="disabled"
            [icon]="arrowButtonIcon"
            [svgIcon]="arrowButtonSvgIcon"
            [size]="size"
            [rounded]="rounded"
            [fillMode]="fillMode"
            [themeColor]="themeColor"
            [tabindex]="-1"
            [attr.aria-label]="messageFor('toggleButtonLabel')"
            [attr.aria-expanded]="openState"
            [attr.aria-controls]="openState ? listId : null"
            (click)="onArrowButtonClick()"
            (mousedown)="toggleArrowButtonActiveState(true)"
            (mouseup)="toggleArrowButtonActiveState(false)"
            (keydown.enter)="$event.stopImmediatePropagation(); $event.preventDefault();"
          ></button>
          <ng-template #popupTemplate>
            <kendo-button-list
                [id]="listId"
                [data]="data"
                [textField]="textField"
                [itemTemplate]="itemTemplate"
                (onItemClick)="onItemClick($event)"
                (keydown)="keyDownHandler($event)"
                (keyup)="keyUpHandler($event)"
                [attr.dir]="dir"
            >
            </kendo-button-list>
          </ng-template>
          <ng-container #container></ng-container>
        `,
      standalone: true,
      imports: [LocalizedSplitButtonMessagesDirective, ButtonComponent, NgClass, ListComponent]
    }]
  }], () => [{
    type: FocusService
  }, {
    type: NavigationService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.NgZone
  }, {
    type: i3.PopupService
  }, {
    type: i0.ElementRef
  }, {
    type: i1.LocalizationService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Renderer2
  }, {
    type: PopupContainerService
  }], {
    text: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    iconClass: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    imageUrl: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    themeColor: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    popupSettings: [{
      type: Input
    }],
    tabIndex: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    arrowButtonClass: [{
      type: Input
    }],
    arrowButtonIcon: [{
      type: Input
    }],
    arrowButtonSvgIcon: [{
      type: Input
    }],
    buttonAttributes: [{
      type: Input
    }],
    buttonClick: [{
      type: Output
    }],
    itemClick: [{
      type: Output
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    open: [{
      type: Output
    }],
    close: [{
      type: Output
    }],
    itemTemplate: [{
      type: ContentChild,
      args: [ButtonItemTemplateDirective]
    }],
    isFocused: [{
      type: HostBinding,
      args: ['class.k-focus']
    }],
    widgetClasses: [{
      type: HostBinding,
      args: ['class.k-split-button']
    }, {
      type: HostBinding,
      args: ['class.k-button-group']
    }],
    dir: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    keydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }],
    keyup: [{
      type: HostListener,
      args: ['keyup', ['$event']]
    }]
  });
})();

/**
 * Represents the Kendo UI SpeechToTextButton component for Angular.
 *
 * @example
 * ```html
 * <button kendoSpeechToTextButton></button>
 * ```
 */
class SpeechToTextButtonComponent {
  renderer;
  ngZone;
  /**
   * When `true`, disables the SpeechToTextButton and prevents user interaction.
   *
   * @default false
   */
  set disabled(disabled) {
    //Required, because in FF focused buttons are not blurred on disabled
    if (disabled && isDocumentAvailable() && isFirefox(navigator.userAgent)) {
      this.blur();
    }
    this.isDisabled = disabled;
    this.renderer.setProperty(this.element, 'disabled', disabled);
  }
  get disabled() {
    return this.isDisabled;
  }
  /**
   * Sets the padding of the SpeechToTextButton. The default value is set by the Kendo theme.
   *
   */
  set size(size) {
    this.handleClasses(size, 'size');
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the SpeechToTextButton. The default value is set by the Kendo theme.
   *
   */
  set rounded(rounded) {
    this.handleClasses(rounded, 'rounded');
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the background and border styles of the SpeechToTextButton. The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.handleClasses(fillMode, 'fillMode');
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Sets a predefined theme color for the SpeechToTextButton. The default value is set by the Kendo theme.
   * The theme color applies as a background and border color and adjusts the text color for contrast.
   *
   */
  set themeColor(themeColor) {
    this.handleThemeColor(themeColor);
    this._themeColor = themeColor;
  }
  get themeColor() {
    return this._themeColor;
  }
  /**
   * Specifies which speech recognition engine or integration the component should use. Allows the component to operate in different environments or use alternative implementations.
   */
  integrationMode = 'webSpeech';
  /**
   * Specifies a `BCP 47` language tag (e.g., 'en-US', 'bg-BG') used for speech recognition.
   *
   * @default 'en-US'
   */
  lang = 'en-US';
  /**
   * Specifies whether continuous results are returned for each recognition, or only a single result once recognition stops.
   *
   * @default false
   */
  continuous = false;
  /**
   * Specifies whether interim results should be returned or not. Interim results are results that are not yet final.
   *
   * @default false
   */
  interimResults = false;
  /**
   * Represents the maximum number of alternative transcriptions to return for each result.
   *
   * @default 1
   */
  maxAlternatives = 1;
  /**
   * Fires when the speech recognition service has begun listening to incoming audio.
   */
  start = new EventEmitter();
  /**
   * Fires when the speech recognition service has disconnected.
   */
  end = new EventEmitter();
  /**
   * Fires when the speech recognition service returns a result - a word or phrase has been positively recognized.
   */
  result = new EventEmitter();
  /**
   * Fires when a speech recognition error occurs. The event argument is a string, containing the error message.
   */
  error = new EventEmitter();
  /**
   * Fires when the user clicks the SpeechToTextButton.
   */
  click = new EventEmitter();
  get iconButtonClass() {
    return !this.hasText;
  }
  get listeningClass() {
    return this.isListening;
  }
  speechToTextButtonClass = true;
  classButton = true;
  get classDisabled() {
    return this.isDisabled;
  }
  get getDirection() {
    return this.direction;
  }
  /**
   * @hidden
   */
  onFocus() {
    this.isFocused = true;
  }
  /**
   * @hidden
   */
  onBlur() {
    this.isFocused = false;
  }
  /**
   * Focuses the SpeechToTextButton component.
   */
  focus() {
    if (isDocumentAvailable()) {
      this.element.focus();
      this.isFocused = true;
    }
  }
  /**
   * Removes focus from the SpeechToTextButton component.
   */
  blur() {
    if (isDocumentAvailable()) {
      this.element.blur();
      this.isFocused = false;
    }
  }
  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      this.subs.add(this.renderer.listen(this.element, 'click', this.onClick.bind(this)));
      this.subs.add(this.renderer.listen(this.element, 'mousedown', event => {
        const isBrowserSafari = isDocumentAvailable() && isSafari(navigator.userAgent);
        if (!this.isDisabled && isBrowserSafari) {
          event.preventDefault();
          this.element.focus();
        }
      }));
      if (this.integrationMode !== 'webSpeech') {
        return;
      }
      this.createWebSpeech();
    });
  }
  ngOnChanges(changes) {
    if (isChanged("integrationMode", changes, false)) {
      if (this.integrationMode === 'webSpeech') {
        if (!this.speechRecognition) {
          this.ngZone.runOutsideAngular(() => {
            this.createWebSpeech();
          });
        }
      } else {
        this.destroyWebSpeech();
      }
    }
    if (anyChanged(['lang', 'interimResults', 'maxAlternatives', 'continuous'], changes)) {
      if (this.speechRecognition) {
        this.speechRecognition.setOptions({
          lang: this.lang,
          interimResults: this.interimResults,
          maxAlternatives: this.maxAlternatives,
          continuous: this.continuous
        });
      }
    }
  }
  ngOnDestroy() {
    this.destroyWebSpeech();
    this.subs.unsubscribe();
  }
  constructor(element, renderer, localization, ngZone) {
    this.renderer = renderer;
    this.ngZone = ngZone;
    validatePackage(packageMetadata);
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.subs.add(localization.changes.subscribe(({
      rtl
    }) => this.direction = rtl ? 'rtl' : 'ltr'));
    this.element = element.nativeElement;
  }
  /**
   * Indicates whether the button is actively listening for incoming audio.
   */
  isListening = false;
  /**
   * Indicates whether web speech functionality is supported.
   */
  get isWebSpeechSupported() {
    return this.speechRecognition ? this.speechRecognition.isSupported() : false;
  }
  set isFocused(isFocused) {
    toggleClass('k-focus', isFocused, this.renderer, this.element);
    this._focused = isFocused;
  }
  get isFocused() {
    return this._focused;
  }
  /**
   * @hidden
   */
  get hasText() {
    return isDocumentAvailable() && this.element.textContent.trim().length > 0;
  }
  /**
   * @hidden
   */
  onClick() {
    if (this.isWebSpeechSupported && this.integrationMode === 'webSpeech') {
      this.ngZone.run(() => {
        if (this.isListening) {
          this.speechRecognition.stop();
        } else {
          this.speechRecognition.start();
        }
      });
    } else if (this.integrationMode === 'none') {
      let asyncFactory = () => of(null);
      this.ngZone.run(() => {
        if (this.isListening) {
          this.end.emit(fn => asyncFactory = fn);
        } else {
          this.start.emit(fn => asyncFactory = fn);
        }
        const result = asyncFactory();
        const observable = this.toObservable(result);
        observable.pipe(take(1)).subscribe(() => this.isListening = !this.isListening);
      });
    }
  }
  /**
   * @hidden
   */
  get buttonSvgIcon() {
    return this.isListening ? this.stopSvgIcon : this.microphoneSvgIcon;
  }
  /**
   * @hidden
   */
  get buttonIcon() {
    return this.isListening ? 'stop' : 'microphone';
  }
  /**
   * @hidden
   */
  element;
  /**
   * @hidden
   */
  isDisabled = false;
  /**
   * @hidden
   */
  subs = new Subscription();
  microphoneSvgIcon = microphoneIcon;
  stopSvgIcon = stopIcon;
  speechRecognition;
  _size = undefined;
  _rounded = undefined;
  _fillMode = undefined;
  _themeColor = undefined;
  _focused = false;
  direction;
  handleClasses(value, input) {
    const elem = this.element;
    const classes = getStylingClasses('button', input, this[input], value);
    if (input === 'fillMode') {
      this.handleThemeColor(this.themeColor);
    }
    if (classes.toRemove) {
      this.renderer.removeClass(elem, classes.toRemove);
    }
    if (classes.toAdd) {
      this.renderer.addClass(elem, classes.toAdd);
    }
  }
  handleStart() {
    this.ngZone.run(() => {
      this.isListening = true;
      this.start.emit();
    });
  }
  handleEnd() {
    this.ngZone.run(() => {
      this.isListening = false;
      this.end.emit();
    });
  }
  handleResult(event) {
    const results = event.results;
    const lastResultIndex = results.length - 1;
    const lastResult = results[lastResultIndex];
    const alternatives = [];
    for (let i = 0; i < lastResult.length; i++) {
      alternatives.push({
        transcript: lastResult[i].transcript,
        confidence: lastResult[i].confidence
      });
    }
    const args = {
      isFinal: lastResult.isFinal,
      alternatives: alternatives
    };
    this.ngZone.run(() => {
      this.result.emit(args);
    });
  }
  handleError(ev) {
    const errorMessage = ev.error || ev.message || 'Unknown error';
    this.ngZone.run(() => {
      this.error.emit({
        errorMessage
      });
    });
  }
  toObservable(input) {
    return input instanceof Observable ? input : from(input);
  }
  handleThemeColor(value) {
    const elem = this.element;
    const themeColorClass = getThemeColorClasses('button', this.themeColor, value);
    this.renderer.removeClass(elem, themeColorClass.toRemove);
    if (themeColorClass.toAdd) {
      this.renderer.addClass(elem, themeColorClass.toAdd);
    }
  }
  destroyWebSpeech() {
    if (this.speechRecognition) {
      this.speechRecognition.stop();
      this.speechRecognition.destroy();
      this.speechRecognition = null;
      this.isListening = false;
    }
  }
  createWebSpeech() {
    if (!isDocumentAvailable()) {
      return;
    }
    this.speechRecognition = new KendoSpeechRecognition({
      lang: this.lang,
      interimResults: this.interimResults,
      maxAlternatives: this.maxAlternatives,
      continuous: this.continuous,
      events: {
        start: this.handleStart.bind(this),
        end: this.handleEnd.bind(this),
        result: this.handleResult.bind(this),
        error: this.handleError.bind(this)
      }
    });
  }
  static ɵfac = function SpeechToTextButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SpeechToTextButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SpeechToTextButtonComponent,
    selectors: [["button", "kendoSpeechToTextButton", ""]],
    hostVars: 11,
    hostBindings: function SpeechToTextButtonComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("focus", function SpeechToTextButtonComponent_focus_HostBindingHandler() {
          return ctx.onFocus();
        })("blur", function SpeechToTextButtonComponent_blur_HostBindingHandler() {
          return ctx.onBlur();
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.getDirection);
        i0.ɵɵclassProp("k-icon-button", ctx.iconButtonClass)("k-listening", ctx.listeningClass)("k-speech-to-text-button", ctx.speechToTextButtonClass)("k-button", ctx.classButton)("k-disabled", ctx.classDisabled);
      }
    },
    inputs: {
      disabled: "disabled",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      themeColor: "themeColor",
      integrationMode: "integrationMode",
      lang: "lang",
      continuous: "continuous",
      interimResults: "interimResults",
      maxAlternatives: "maxAlternatives"
    },
    outputs: {
      start: "start",
      end: "end",
      result: "result",
      error: "error",
      click: "click"
    },
    exportAs: ["kendoSpeechToTextButton"],
    features: [i0.ɵɵProvidersFeature([LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.speechtotextbutton'
    }]), i0.ɵɵNgOnChangesFeature],
    attrs: _c14,
    ngContentSelectors: _c1,
    decls: 3,
    vars: 2,
    consts: [["innerCssClass", "k-button-icon", 3, "name", "svgIcon"], [1, "k-button-text"]],
    template: function SpeechToTextButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelement(0, "kendo-icon-wrapper", 0);
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("name", ctx.buttonIcon)("svgIcon", ctx.buttonSvgIcon);
      }
    },
    dependencies: [IconWrapperComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpeechToTextButtonComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoSpeechToTextButton',
      providers: [LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.speechtotextbutton'
      }],
      selector: 'button[kendoSpeechToTextButton]',
      template: `
        <kendo-icon-wrapper
            innerCssClass="k-button-icon"
            [name]="buttonIcon"
            [svgIcon]="buttonSvgIcon">
        </kendo-icon-wrapper>
        <span class="k-button-text"><ng-content></ng-content></span>
    `,
      standalone: true,
      imports: [IconWrapperComponent]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i1.LocalizationService
  }, {
    type: i0.NgZone
  }], {
    disabled: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    themeColor: [{
      type: Input
    }],
    integrationMode: [{
      type: Input
    }],
    lang: [{
      type: Input
    }],
    continuous: [{
      type: Input
    }],
    interimResults: [{
      type: Input
    }],
    maxAlternatives: [{
      type: Input
    }],
    start: [{
      type: Output
    }],
    end: [{
      type: Output
    }],
    result: [{
      type: Output
    }],
    error: [{
      type: Output
    }],
    click: [{
      type: Output
    }],
    iconButtonClass: [{
      type: HostBinding,
      args: ['class.k-icon-button']
    }],
    listeningClass: [{
      type: HostBinding,
      args: ['class.k-listening']
    }],
    speechToTextButtonClass: [{
      type: HostBinding,
      args: ['class.k-speech-to-text-button']
    }],
    classButton: [{
      type: HostBinding,
      args: ['class.k-button']
    }],
    classDisabled: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    getDirection: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    onFocus: [{
      type: HostListener,
      args: ['focus']
    }],
    onBlur: [{
      type: HostListener,
      args: ['blur']
    }]
  });
})();

/**
 * @hidden
 */
const DEFAULT_AI_REQUEST_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  role: 'user',
  method: 'POST',
  responseType: 'json'
};
class SmartPasteRequestStartEvent extends PreventableEvent$1 {
  /**
   * Gets the request data to send to the AI service.
   */
  requestData;
  constructor(requestData) {
    super();
    this.requestData = requestData;
  }
}
class SmartPasteRequestEndEvent extends PreventableEvent$1 {
  /**
   * Gets the HTTP response from the AI service.
   * Contains an error object when the request fails.
   */
  response;
  constructor(response) {
    super();
    this.response = response;
  }
}

/**
 * Checks if a field should be ignored during Smart Paste.
 *
 * @hidden
 */
function isFieldIgnored(element) {
  return element.hasAttribute('type') && element.type === 'hidden' || element.hasAttribute('disabled') || element.hasAttribute('readonly') || element.hasAttribute('aria-disabled') && element.getAttribute('aria-disabled') === 'true' || element.hasAttribute('aria-readonly') && element.getAttribute('aria-readonly') === 'true' || element.hasAttribute('aria-hidden') && element.getAttribute('aria-hidden') === 'true';
}
/**
 * @hidden
 */
const getElementIdentifier = element => {
  if (!isDocumentAvailable()) {
    return null;
  }
  return element.getAttribute('formcontrolname') || element.getAttribute('name') || element.id;
};
/**
 * Specifies custom inputs (Kendo components) to include in Smart Paste.
 * Each custom input has an identifier used to detect the component.
 * Defaults to common Kendo UI components (DropDownList, ComboBox, AutoComplete, MultiSelect, DatePicker, etc.).
 *
 * @hidden
 */
const customInputs = [{
  identifier: '.k-checkbox'
}, {
  identifier: '.k-colorpalette'
}, {
  identifier: '.k-colorgradient'
}, {
  identifier: '.k-flatcolorpicker'
}, {
  identifier: '.k-otp'
}, {
  identifier: '.k-textbox'
}, {
  identifier: '.k-radio'
}, {
  identifier: '.k-slider'
}, {
  identifier: '.k-rating'
}, {
  identifier: '.k-signature'
}, {
  identifier: '.k-switch'
}, {
  identifier: '.k-textarea'
}, {
  identifier: '.k-calendar'
}, {
  identifier: '.k-timepicker'
}, {
  identifier: '.k-dateinput'
}, {
  identifier: '.k-datetimepicker'
}, {
  identifier: '.k-dropdownlist'
}, {
  identifier: '.k-combobox'
}, {
  identifier: '.k-autocomplete'
}, {
  identifier: '.k-multiselect'
}, {
  identifier: '.k-datepicker'
}, {
  identifier: '.k-numerictextbox'
}, {
  identifier: '.k-maskedtextbox'
}, {
  identifier: '.k-colorpicker'
}, {
  identifier: '.k-dropdowntree'
}, {
  identifier: '.k-multiselecttree'
}];
const DATEPICKER_SELECTOR = '.k-datepicker';
const TIMEPICKER_SELECTOR = '.k-timepicker';
const DATETIMEPICKER_SELECTOR = '.k-datetimepicker';
const DATERANGEPICKER_SELECTOR = '.k-daterangepicker';
const CHECKBOX_SELECTOR = '.k-checkbox';
const RADIO_SELECTOR = '.k-radio';
const NUMERICTEXTBOX_SELECTOR = '.k-numerictextbox';
/**
 * @hidden
 */
const requiresDateValue = element => {
  const isDateInput = [DATEPICKER_SELECTOR, TIMEPICKER_SELECTOR, DATETIMEPICKER_SELECTOR, DATERANGEPICKER_SELECTOR];
  return isDateInput.some(selector => element.classList.contains(selector.slice(1)));
};
/**
 * @hidden
 */
const requiresBooleanValue = element => {
  const isBooleanInput = [CHECKBOX_SELECTOR, RADIO_SELECTOR];
  return isBooleanInput.some(selector => element.classList.contains(selector.slice(1)));
};
/**
 * @hidden
 */
const requiresNumericValue = element => {
  const isNumericInput = [NUMERICTEXTBOX_SELECTOR];
  return isNumericInput.some(selector => element.classList.contains(selector.slice(1)));
};
/**
 * @hidden
 */
const populateCustomInputs = (element, value) => {
  const parseNumericValue = requiresNumericValue(element);
  if (parseNumericValue) {
    const numericValue = parseFloat(value);
    return !isNaN(numericValue) ? numericValue : null;
  }
  const parseBooleanValue = requiresBooleanValue(element);
  if (parseBooleanValue) {
    return value.toLowerCase() === 'true';
  }
  const parseDateValue = requiresDateValue(element);
  if (parseDateValue) {
    const dateValue = new Date(value);
    return !isNaN(dateValue.getTime()) ? dateValue : null;
  }
  return value;
};
/**
 * @hidden
 */
const readClipboard = async () => {
  return await navigator.clipboard.readText();
};
/**
 * @hidden
 */
const sendSmartPasteRequest = (http, requestData) => {
  const body = {
    formFields: requestData.formFields,
    content: requestData.content
  };
  const request = new HttpRequest(requestData.requestOptions?.method || 'POST', requestData.url, body, requestData.requestOptions);
  return http.request(request).pipe(filter(event => event.type === HttpEventType.Response));
};
const DEFAULT_SVG_ICON = pasteSparkleIcon;
const DEFAULT_ICON = 'paste-sparkle';
/**
 * Represents the Kendo UI SmartPasteButton component for Angular.
 *
 * Fills form fields with AI-powered data extraction from clipboard content.
 */
class SmartPasteButtonComponent {
  renderer;
  ngZone;
  http;
  controlContainer;
  /**
   * Specifies the form controls to include in Smart Paste.
   * When not set, all form controls are included.
   *
   * @default null
   */
  formFields = null;
  /**
   * When `true`, disables the SmartPasteButton and prevents user interaction.
   *
   * @default false
   */
  set disabled(disabled) {
    if (disabled && isDocumentAvailable() && isFirefox(navigator.userAgent)) {
      this.blur();
    }
    this.isDisabled = disabled;
    this.renderer.setProperty(this.element, 'disabled', disabled);
  }
  get disabled() {
    return this.isDisabled;
  }
  /**
   * Sets the padding of the SmartPasteButton.
   *
   * @default undefined
   */
  set size(size) {
    this.handleClasses(size, 'size');
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the SmartPasteButton.
   *
   * @default undefined
   */
  set rounded(rounded) {
    this.handleClasses(rounded, 'rounded');
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the background and border styles of the SmartPasteButton.
   *
   * @default undefined
   */
  set fillMode(fillMode) {
    this.handleClasses(fillMode, 'fillMode');
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Sets a predefined theme color for the SmartPasteButton.
   * The theme color applies as a background and border color and adjusts the text color.
   *
   * @default undefined
   */
  set themeColor(themeColor) {
    this.handleThemeColor(themeColor);
    this._themeColor = themeColor;
  }
  get themeColor() {
    return this._themeColor;
  }
  /**
   * Sets an SVG icon to display inside the SmartPasteButton.
   */
  set svgIcon(icon) {
    if (isDevMode() && icon && this.iconClass) {
      throw new Error('Setting both icon/svgIcon and iconClass options at the same time is not supported.');
    }
    this._svgIcon = icon;
  }
  get svgIcon() {
    return this._svgIcon;
  }
  /**
   * Specifies a URL for an `img` element inside the SmartPasteButton.
   * The URL can be relative or absolute. When relative, the browser evaluates it relative to the web page URL.
   */
  imageUrl;
  /**
   * Defines one or more CSS classes separated by spaces for a `span` element inside the SmartPasteButton.
   * Use `iconClass` to add custom icons.
   */
  set iconClass(value) {
    const hasCustomIcon = this.icon !== DEFAULT_ICON || this.svgIcon !== DEFAULT_SVG_ICON;
    if (isDevMode() && value && hasCustomIcon) {
      throw new Error('Setting both icon/svgIcon and iconClass options at the same time is not supported.');
    }
    if (!hasCustomIcon) {
      this._icon = null;
      this._svgIcon = null;
    }
    this._iconClass = value;
  }
  get iconClass() {
    return this._iconClass;
  }
  /**
   * Specifies the icon name to display in the SmartPasteButton.
   *
   * @default 'paste-sparkle'
   */
  set icon(name) {
    if (isDevMode() && name && this.iconClass) {
      throw new Error('Setting both icon/svgIcon and iconClass options at the same time is not supported.');
    }
    this._icon = name;
  }
  get icon() {
    return this._icon;
  }
  /**
   * Sets the URL to which Smart Paste sends the AI request.
   * When set, the component sends and handles an HTTP request automatically. Handle the `requestStart` event to modify request options before sending.
   * When not set, the component does not send an HTTP request. Handle the `requestStart` event to send and manage a custom HTTP request.
   */
  requestUrl;
  /**
   * Configures the HTTP request options for the AI request.
   * Use this to customize headers, method, credentials, and other request settings.
   */
  requestOptions;
  /**
   * Sets static form field metadata to bypass DOM extraction when Smart Paste runs.
   * Use this when you want to provide form field configuration directly instead of extracting it from the DOM.
   *
   * @hidden
   * @default null
   */
  smartPasteFormFields = null;
  /**
   * Fires when the Smart Paste request is about to start.
   * Prevent the event to stop the request before sending it.
   */
  requestStart = new EventEmitter();
  /**
   * Fires when the Smart Paste request completes, either successfully or with an error.
   * Prevent the event to cancel populating the form fields with the response data.
   */
  requestEnd = new EventEmitter();
  /**
   * Fires when the user cancels an ongoing Smart Paste request.
   */
  requestCancel = new EventEmitter();
  get iconButtonClass() {
    return !this.hasText;
  }
  classButton = true;
  get classDisabled() {
    return this.isDisabled;
  }
  get getDirection() {
    return this.direction;
  }
  onFocus() {
    this.isFocused = true;
  }
  onBlur() {
    this.isFocused = false;
  }
  /**
   * Focuses the SmartPasteButton.
   */
  focus() {
    if (isDocumentAvailable()) {
      this.element.focus();
      this.isFocused = true;
    }
  }
  /**
   * Removes focus from the SmartPasteButton.
   */
  blur() {
    if (isDocumentAvailable()) {
      this.element.blur();
      this.isFocused = false;
    }
  }
  get hasText() {
    return isDocumentAvailable() && this.element.textContent.trim().length > 0;
  }
  set isFocused(isFocused) {
    toggleClass('k-focus', isFocused, this.renderer, this.element);
    this._focused = isFocused;
  }
  get isFocused() {
    return this._focused;
  }
  element;
  isDisabled = false;
  subs = new Subscription();
  _size = undefined;
  _rounded = undefined;
  _fillMode = undefined;
  _themeColor = undefined;
  _focused = false;
  direction;
  _iconClass;
  _icon = DEFAULT_ICON;
  _svgIcon = DEFAULT_SVG_ICON;
  kendoSmartPaste;
  smartPasteBusy = false;
  currentRequestSubscription = null;
  nativeForm = null;
  constructor(elementRef, renderer, localization, ngZone, http, controlContainer) {
    this.renderer = renderer;
    this.ngZone = ngZone;
    this.http = http;
    this.controlContainer = controlContainer;
    validatePackage(packageMetadata);
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.subs.add(localization.changes.subscribe(({
      rtl
    }) => this.direction = rtl ? 'rtl' : 'ltr'));
    this.element = elementRef.nativeElement;
  }
  ngOnInit() {
    this.nativeForm = this.element.form;
    this.kendoSmartPaste = new KendoSmartPaste({
      getElement: () => this.nativeForm,
      customInputs: customInputs || undefined,
      getSmartPasteField: this.defaultGetSmartPasteField,
      setKendoInputValue: this.defaultSetKendoInputValue
    });
    this.ngZone.runOutsideAngular(() => {
      this.subs.add(this.renderer.listen(this.element, 'click', this.paste.bind(this)));
      this.subs.add(this.renderer.listen(this.element, 'mousedown', event => {
        const isBrowserSafari = isDocumentAvailable() && isSafari(navigator.userAgent);
        if (!this.isDisabled && isBrowserSafari) {
          event.preventDefault();
          this.element.focus();
        }
      }));
    });
  }
  ngOnDestroy() {
    this.unsubscribeCurrentRequest();
    this.subs.unsubscribe();
  }
  /**
   * Starts the Smart Paste operation.
   * Reads clipboard content and sends it to the AI service for processing.
   */
  async paste() {
    if (!this.nativeForm) {
      return;
    }
    if (this.smartPasteBusy) {
      this.requestCancel.emit();
      this.unsubscribeCurrentRequest();
      this.smartPasteBusy = false;
      return;
    }
    let clipboardContent;
    try {
      clipboardContent = await readClipboard();
    } catch (error) {
      this.ngZone.run(() => {
        const responseErrorEvent = new SmartPasteRequestEndEvent(error);
        this.requestEnd.emit(responseErrorEvent);
      });
      return;
    }
    if (!clipboardContent || clipboardContent.trim() === '') {
      return;
    }
    this.smartPasteBusy = true;
    this.unsubscribeCurrentRequest();
    const formFields = this.extractFormFields();
    const requestData = {
      formFields,
      content: clipboardContent,
      url: this.requestUrl,
      requestOptions: {
        ...this.requestOptions
      }
    };
    if (!this.requestUrl) {
      this.smartPasteBusy = false;
      return;
    }
    this.ngZone.run(() => {
      const requestStartEvent = new SmartPasteRequestStartEvent(requestData);
      this.requestStart.emit(requestStartEvent);
      if (requestStartEvent.isDefaultPrevented()) {
        this.smartPasteBusy = false;
        return;
      }
      if (!this.smartPasteBusy) {
        return;
      }
      this.handleSmartPasteRequest(requestData, formFields);
    });
  }
  sendSmartPasteRequest(requestData) {
    const body = {
      formFields: requestData.formFields,
      content: requestData.content
    };
    const request = new HttpRequest(requestData.requestOptions?.method || 'POST', requestData.url, body, requestData.requestOptions);
    return this.http.request(request).pipe(filter(event => event.type === HttpEventType.Response));
  }
  unsubscribeCurrentRequest() {
    if (this.currentRequestSubscription) {
      this.currentRequestSubscription.unsubscribe();
      this.currentRequestSubscription = null;
    }
  }
  defaultGetSmartPasteField = field => {
    const element = field.element;
    if (isFieldIgnored(element)) {
      return null;
    }
    const hasKendoWrapper = customInputs.some(input => {
      if (!element.classList.contains(input.identifier.slice(1)) && element.closest(input.identifier)) {
        return true;
      }
    });
    if (hasKendoWrapper) {
      return null;
    }
    if (field.type === 'kendo-input') {
      const identifier = getElementIdentifier(element);
      if (!identifier) {
        return null;
      }
      if (requiresBooleanValue(element)) {
        field.allowedValues = ['true', 'false'];
      }
      field.field = identifier;
    }
    return field;
  };
  defaultSetKendoInputValue = (field, value) => {
    const element = field.element;
    const controlName = getElementIdentifier(element);
    if (!controlName || !this.controlContainer) {
      return;
    }
    const control = this.controlContainer.control.get?.(controlName);
    if (!control || typeof control.setValue !== 'function') {
      return;
    }
    const updatedValue = populateCustomInputs(element, value);
    if (!isPresent$1(updatedValue)) {
      return;
    }
    this.setControlValue(control, updatedValue);
  };
  setControlValue(control, value) {
    this.ngZone.run(() => {
      control.setValue(value);
      control.markAsDirty();
      control.updateValueAndValidity();
    });
  }
  extractFormFields() {
    if (!this.formFields || this.formFields.length === 0) {
      return this.kendoSmartPaste.extractFormConfig();
    } else {
      const formFields = this.formFields.map(field => {
        const element = this.nativeForm?.querySelector(`#${field.field}`);
        return {
          ...field,
          element
        };
      });
      return formFields;
    }
  }
  handleClasses(value, input) {
    const elem = this.element;
    const classes = getStylingClasses('button', input, this[input], value);
    if (input === 'fillMode') {
      this.handleThemeColor(this.themeColor);
    }
    if (classes.toRemove) {
      this.renderer.removeClass(elem, classes.toRemove);
    }
    if (classes.toAdd) {
      this.renderer.addClass(elem, classes.toAdd);
    }
  }
  handleThemeColor(value) {
    const elem = this.element;
    const themeColorClass = getThemeColorClasses('button', this.themeColor, value);
    if (themeColorClass.toRemove) {
      this.renderer.removeClass(elem, themeColorClass.toRemove);
    }
    if (themeColorClass.toAdd) {
      this.renderer.addClass(elem, themeColorClass.toAdd);
    }
  }
  handleSmartPasteRequest(requestData, formFields) {
    this.currentRequestSubscription = this.sendSmartPasteRequest(requestData).subscribe(response => {
      if (!this.smartPasteBusy) {
        return;
      }
      const responseEvent = new SmartPasteRequestEndEvent(response);
      this.requestEnd.emit(responseEvent);
      if (responseEvent.isDefaultPrevented()) {
        this.smartPasteBusy = false;
        return;
      }
      if (response?.body?.fieldValues) {
        this.kendoSmartPaste.populateFormFields(response.body, formFields);
      }
      this.smartPasteBusy = false;
      this.currentRequestSubscription = null;
    }, error => {
      if (!this.smartPasteBusy) {
        return;
      }
      const responseErrorEvent = new SmartPasteRequestEndEvent(error);
      this.requestEnd.emit(responseErrorEvent);
      this.smartPasteBusy = false;
      this.currentRequestSubscription = null;
    });
  }
  static ɵfac = function SmartPasteButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SmartPasteButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i2.HttpClient), i0.ɵɵdirectiveInject(i3$1.ControlContainer, 12));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SmartPasteButtonComponent,
    selectors: [["button", "kendoSmartPasteButton", ""]],
    hostVars: 7,
    hostBindings: function SmartPasteButtonComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("focus", function SmartPasteButtonComponent_focus_HostBindingHandler() {
          return ctx.onFocus();
        })("blur", function SmartPasteButtonComponent_blur_HostBindingHandler() {
          return ctx.onBlur();
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.getDirection);
        i0.ɵɵclassProp("k-icon-button", ctx.iconButtonClass)("k-button", ctx.classButton)("k-disabled", ctx.classDisabled);
      }
    },
    inputs: {
      formFields: "formFields",
      disabled: "disabled",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      themeColor: "themeColor",
      svgIcon: "svgIcon",
      imageUrl: "imageUrl",
      iconClass: "iconClass",
      icon: "icon",
      requestUrl: "requestUrl",
      requestOptions: "requestOptions",
      smartPasteFormFields: "smartPasteFormFields"
    },
    outputs: {
      requestStart: "requestStart",
      requestEnd: "requestEnd",
      requestCancel: "requestCancel"
    },
    exportAs: ["kendoSmartPasteButton"],
    features: [i0.ɵɵProvidersFeature([LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.smartpastebutton'
    }])],
    attrs: _c15,
    ngContentSelectors: _c1,
    decls: 5,
    vars: 3,
    consts: [["innerCssClass", "k-button-icon", 3, "name", "svgIcon"], [1, "k-button-icon", "k-icon"], [1, "k-button-icon", 3, "ngClass"], [1, "k-button-text"], ["role", "presentation", 1, "k-image", 3, "src"]],
    template: function SmartPasteButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵconditionalCreate(0, SmartPasteButtonComponent_Conditional_0_Template, 1, 2, "kendo-icon-wrapper", 0);
        i0.ɵɵconditionalCreate(1, SmartPasteButtonComponent_Conditional_1_Template, 2, 1, "span", 1);
        i0.ɵɵconditionalCreate(2, SmartPasteButtonComponent_Conditional_2_Template, 1, 1, "span", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.icon || ctx.svgIcon ? 0 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.imageUrl ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.iconClass ? 2 : -1);
      }
    },
    dependencies: [IconWrapperComponent, NgClass],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartPasteButtonComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoSmartPasteButton',
      providers: [LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.smartpastebutton'
      }],
      selector: 'button[kendoSmartPasteButton]',
      standalone: true,
      imports: [IconWrapperComponent, NgClass],
      template: `
        @if (icon || svgIcon) {
          <kendo-icon-wrapper
            innerCssClass="k-button-icon"
            [name]="icon"
            [svgIcon]="svgIcon"></kendo-icon-wrapper>
        }
        @if (imageUrl) {
          <span class="k-button-icon k-icon">
            <img [src]="imageUrl" class="k-image" role="presentation" />
          </span>
        }
        @if (iconClass) {
          <span class="k-button-icon" [ngClass]="iconClass"></span>
        }
        <span class="k-button-text"><ng-content></ng-content></span>
    `
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i1.LocalizationService
  }, {
    type: i0.NgZone
  }, {
    type: i2.HttpClient
  }, {
    type: i3$1.ControlContainer,
    decorators: [{
      type: Optional
    }, {
      type: SkipSelf
    }]
  }], {
    formFields: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    themeColor: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    imageUrl: [{
      type: Input
    }],
    iconClass: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    requestUrl: [{
      type: Input
    }],
    requestOptions: [{
      type: Input
    }],
    smartPasteFormFields: [{
      type: Input
    }],
    requestStart: [{
      type: Output
    }],
    requestEnd: [{
      type: Output
    }],
    requestCancel: [{
      type: Output
    }],
    iconButtonClass: [{
      type: HostBinding,
      args: ['class.k-icon-button']
    }],
    classButton: [{
      type: HostBinding,
      args: ['class.k-button']
    }],
    classDisabled: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    getDirection: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    onFocus: [{
      type: HostListener,
      args: ['focus']
    }],
    onBlur: [{
      type: HostListener,
      args: ['blur']
    }]
  });
})();
const SIZES_MAP = {
  small: 'sm',
  medium: 'md',
  large: 'lg'
};
/**
 * Represents the Kendo UI SegmentedControl component for Angular.
 *
 * Renders a group of buttons where only one can be selected at a time,
 * with a sliding selection indicator.
 */
class SegmentedControlComponent {
  renderer;
  wrapper;
  zone;
  hostClass = true;
  get stretchedClass() {
    return this._layoutMode === 'stretch';
  }
  get direction() {
    return this._direction;
  }
  hostRole = 'group';
  thumb;
  resizeSensor;
  /**
   * Specifies the collection of items to render in the SegmentedControl.
   */
  set items(value) {
    this._items = value;
    this.showSelectionIndicator();
  }
  get items() {
    return this._items;
  }
  /**
   * Specifies the layout mode of the SegmentedControl.
   *
   * @default 'compact'
   */
  set layoutMode(value) {
    this._layoutMode = value;
    this.showSelectionIndicator();
  }
  get layoutMode() {
    return this._layoutMode;
  }
  /**
   * Specifies the size of the SegmentedControl.
   */
  set size(size) {
    const newSize = size;
    this.handleSizeClass(newSize, this._size);
    this._size = newSize;
    this.showSelectionIndicator();
  }
  get size() {
    return this._size;
  }
  /**
   * Specifies the index of the selected button in the `items` array.
   *
   * @default 0
   */
  set selected(value) {
    this.selectedButtonIndex = value;
    this.showSelectionIndicator();
  }
  get selected() {
    return this.selectedButtonIndex;
  }
  /**
   * Fires when the selected button changes. Emits the index of the selected button.
   */
  selectedChange = new EventEmitter();
  /**
   * @hidden
   */
  selectedButtonIndex = 0;
  _items = [];
  _size;
  _layoutMode = 'compact';
  _direction;
  subs = new Subscription();
  constructor(renderer, wrapper, zone, localization) {
    this.renderer = renderer;
    this.wrapper = wrapper;
    this.zone = zone;
    validatePackage(packageMetadata);
    this._direction = localization.rtl ? 'rtl' : 'ltr';
    this.subs.add(localization.changes.subscribe(({
      rtl
    }) => {
      this._direction = rtl ? 'rtl' : 'ltr';
    }));
  }
  ngAfterViewInit() {
    this.handleSizeClass(this._size, null);
    if (this.resizeSensor) {
      this.subs.add(this.resizeSensor.resize.pipe(debounceTime(150)).subscribe(() => {
        this.zone.run(() => {
          this.showSelectionIndicator();
        });
      }));
    }
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  /**
   * @hidden
   */
  handleClick(button, index) {
    if (button.disabled || index === this.selectedButtonIndex) {
      return;
    }
    this.selectedButtonIndex = index;
    this.selectedChange.emit(index);
    this.showSelectionIndicator();
  }
  /**
   * @hidden
   */
  handleKeydown(event, button) {
    if (button.disabled && (event.code === Keys.Enter || event.code === Keys.NumpadEnter || event.code === Keys.Space)) {
      event.preventDefault();
    }
  }
  handleSizeClass(newValue, prevValue) {
    if (!this.wrapper) {
      return;
    }
    const elem = this.wrapper.nativeElement;
    const classToRemove = prevValue ? `k-segmented-control-${SIZES_MAP[prevValue]}` : null;
    const classToAdd = newValue ? `k-segmented-control-${SIZES_MAP[newValue]}` : null;
    classToRemove && this.renderer.removeClass(elem, classToRemove);
    classToAdd && this.renderer.addClass(elem, classToAdd);
  }
  /**
   * Updates the thumb position to reflect the currently selected button.
   */
  showSelectionIndicator() {
    if (!isDocumentAvailable()) {
      return;
    }
    this.zone.onStable.pipe(take(1)).subscribe(() => {
      const element = this.wrapper.nativeElement;
      if (!element?.getBoundingClientRect) {
        return;
      }
      const controlRect = element.getBoundingClientRect();
      const selectedItem = element.querySelector('.k-segmented-control-button.k-selected');
      const selectionIndicator = this.thumb ? this.thumb.nativeElement : null;
      if (!selectedItem || !selectionIndicator) {
        return;
      }
      const itemRect = selectedItem.getBoundingClientRect();
      const left = itemRect.left - controlRect.left;
      const right = controlRect.right - itemRect.right;
      this.renderer.setStyle(selectionIndicator, 'left', `${left}px`);
      this.renderer.setStyle(selectionIndicator, 'right', `${right}px`);
    });
  }
  static ɵfac = function SegmentedControlComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SegmentedControlComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SegmentedControlComponent,
    selectors: [["kendo-segmented-control"]],
    viewQuery: function SegmentedControlComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c16, 5)(_c17, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.thumb = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resizeSensor = _t.first);
      }
    },
    hostVars: 6,
    hostBindings: function SegmentedControlComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.direction)("role", ctx.hostRole);
        i0.ɵɵclassProp("k-segmented-control", ctx.hostClass)("k-segmented-control-stretched", ctx.stretchedClass);
      }
    },
    inputs: {
      items: "items",
      layoutMode: "layoutMode",
      size: "size",
      selected: "selected"
    },
    outputs: {
      selectedChange: "selectedChange"
    },
    features: [i0.ɵɵProvidersFeature([LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.segmentedcontrol'
    }])],
    decls: 6,
    vars: 1,
    consts: [["resizeSensor", ""], ["thumb", ""], [1, "k-segmented-control-thumb"], ["type", "button", 1, "k-segmented-control-button", 3, "k-disabled", "k-selected"], ["type", "button", 1, "k-segmented-control-button", 3, "click", "keydown"], [3, "innerCssClass", "name", "svgIcon"], [1, "k-segmented-control-button-text"]],
    template: function SegmentedControlComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "kendo-resize-sensor", null, 0)(2, "div", 2, 1);
        i0.ɵɵrepeaterCreate(4, SegmentedControlComponent_For_5_Template, 3, 10, "button", 3, i0.ɵɵrepeaterTrackByIndex);
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-hidden", true);
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.items);
      }
    },
    dependencies: [IconWrapperComponent, ResizeSensorComponent],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SegmentedControlComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-segmented-control',
      standalone: true,
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [IconWrapperComponent, ResizeSensorComponent],
      providers: [LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.segmentedcontrol'
      }],
      template: `
        <kendo-resize-sensor #resizeSensor></kendo-resize-sensor>
        <div class="k-segmented-control-thumb" #thumb [attr.aria-hidden]="true"></div>
        @for (button of items; track $index; let idx = $index) {
            <button type="button"
                class="k-segmented-control-button"
                [class.k-disabled]="button.disabled"
                [attr.aria-disabled]="button.disabled ? true : null"
                [attr.title]="button.title"
                [attr.aria-label]="button.title && !button.text ? button.title : null"
                (click)="handleClick(button, idx)"
                (keydown)="handleKeydown($event, button)"
                [class.k-selected]="selectedButtonIndex === idx"
                [attr.aria-pressed]="selectedButtonIndex === idx ? 'true' : 'false'">
                @if (button.icon || button.svgIcon) {
                    <kendo-icon-wrapper
                        [innerCssClass]="button['iconInnerCssClass'] ? 'k-segmented-control-button-icon ' + button['iconInnerCssClass'] : 'k-segmented-control-button-icon'"
                        [name]="button.icon"
                        [svgIcon]="button.svgIcon">
                    </kendo-icon-wrapper>
                }
                @if (button.text) {
                    <span class="k-segmented-control-button-text">{{button.text}}</span>
                }
            </button>
        }
    `
    }]
  }], () => [{
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }, {
    type: i0.NgZone
  }, {
    type: i1.LocalizationService
  }], {
    hostClass: [{
      type: HostBinding,
      args: ['class.k-segmented-control']
    }],
    stretchedClass: [{
      type: HostBinding,
      args: ['class.k-segmented-control-stretched']
    }],
    direction: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    hostRole: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    thumb: [{
      type: ViewChild,
      args: ['thumb']
    }],
    resizeSensor: [{
      type: ViewChild,
      args: ['resizeSensor']
    }],
    items: [{
      type: Input
    }],
    layoutMode: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    selectedChange: [{
      type: Output
    }]
  });
})();

/**
 * Use the `KENDO_BUTTON` utility array to add all Button-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_BUTTON],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_BUTTON = [ButtonComponent];
/**
 * Use the `KENDO_BUTTONGROUP` utility array to add all ButtonGroup-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_BUTTONGROUP],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_BUTTONGROUP = [ButtonComponent, ButtonGroupComponent];
/**
 * Use the `KENDO_DROPDOWNBUTTON` utility array to add all DropDownButton-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_DROPDOWNBUTTON],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_DROPDOWNBUTTON = [DropDownButtonComponent, ButtonItemTemplateDirective];
/**
 * Use the `KENDO_CHIP` utility array to add all Chip-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_CHIP],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_CHIP = [ChipComponent];
/**
 * Use the `KENDO_CHIPLIST` utility array to add all ChipList-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_CHIPLIST],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_CHIPLIST = [ChipComponent, ChipListComponent];
/**
 * Use the `KENDO_FLOATINGACTIONBUTTON` utility array to add all FloatingActionButton-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_FLOATINGACTIONBUTTON],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_FLOATINGACTIONBUTTON = [FloatingActionButtonComponent, DialItemTemplateDirective, FloatingActionButtonTemplateDirective];
/**
 * Use the `KENDO_SPLITBUTTON` utility array to add all SplitButton-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_SPLITBUTTON],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_SPLITBUTTON = [SplitButtonComponent, SplitButtonCustomMessagesComponent, ToggleButtonTabStopDirective, ButtonItemTemplateDirective];
/**
 * Use the `KENDO_SPEECHTOTEXTBUTTON` utility array to add all SpeechToTextButton-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_SPEECHTOTEXTBUTTON],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_SPEECHTOTEXTBUTTON = [SpeechToTextButtonComponent];
/**
 * Use the `KENDO_SMARTPASTEBUTTON` utility array to add all SmartPasteButton-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_SMARTPASTEBUTTON],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_SMARTPASTEBUTTON = [SmartPasteButtonComponent];
/**
 * Use the `KENDO_SEGMENTEDCONTROL` utility array to add all SegmentedControl-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_SEGMENTEDCONTROL],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_SEGMENTEDCONTROL = [SegmentedControlComponent];
/**
 * Use the `KENDO_BUTTONS` utility array to add all `@progress/kendo-angular-buttons`-related components and directives to a standalone Angular component.
 *
 * @example
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [KENDO_BUTTONS],
 *   // ...
 * })
 * export class MyComponent {}
 * ```
 */
const KENDO_BUTTONS = [...KENDO_BUTTON, ...KENDO_BUTTONGROUP, ...KENDO_DROPDOWNBUTTON, ...KENDO_CHIP, ...KENDO_CHIPLIST, ...KENDO_FLOATINGACTIONBUTTON, ...KENDO_SPLITBUTTON, ...KENDO_SPEECHTOTEXTBUTTON, ...KENDO_SMARTPASTEBUTTON, ...KENDO_SEGMENTEDCONTROL];

//IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Represents the [NgModule](link:site.data.urls.angular['ngmodules'])
 * definition for the ButtonGroup directive.
 *
 * Required for adding ButtonGroup features in NgModule-based Angular applications.
 *
 * The package exports:
 * - `ButtonGroupComponent`&mdash;The ButtonGroup component class.
 * - `ButtonComponent`&mdash;The Button component class.
 *
 * @example
 * ```typescript
 * import { ButtonGroupModule } from '@progress/kendo-angular-buttons';
 * import { NgModule } from '@angular/core';
 * import { BrowserModule } from '@angular/platform-browser';
 * import { AppComponent } from './app.component';
 *
 * @NgModule({
 *   declarations: [AppComponent],
 *   imports: [BrowserModule, ButtonGroupModule],
 *   bootstrap: [AppComponent]
 * })
 * export class AppModule {}
 * ```
 */
class ButtonGroupModule {
  static ɵfac = function ButtonGroupModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonGroupModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ButtonGroupModule,
    imports: [ButtonComponent, ButtonGroupComponent],
    exports: [ButtonComponent, ButtonGroupComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService],
    imports: [ButtonComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonGroupModule, [{
    type: NgModule,
    args: [{
      exports: [...KENDO_BUTTONGROUP],
      imports: [...KENDO_BUTTONGROUP],
      providers: [IconsService]
    }]
  }], null, null);
})();

//IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Represents the [NgModule](link:site.data.urls.angular['ngmodules'])
 * definition for the Button directive.
 *
 * Required for adding Button features in NgModule-based Angular applications.
 *
 * @example
 * ```typescript
 * import { ButtonModule } from '@progress/kendo-angular-buttons';
 * import { NgModule } from '@angular/core';
 * import { BrowserModule } from '@angular/platform-browser';
 * import { AppComponent } from './app.component';
 *
 * @NgModule({
 *   declarations: [AppComponent],
 *   imports: [BrowserModule, ButtonModule],
 *   bootstrap: [AppComponent]
 * })
 * export class AppModule {}
 * ```
 */
class ButtonModule {
  static ɵfac = function ButtonModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ButtonModule,
    imports: [ButtonComponent],
    exports: [ButtonComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService],
    imports: [ButtonComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonModule, [{
    type: NgModule,
    args: [{
      imports: [ButtonComponent],
      exports: [ButtonComponent],
      providers: [IconsService]
    }]
  }], null, null);
})();

//IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Represents the [NgModule](link:site.data.urls.angular['ngmodules'])
 * definition for the Buttons components.
 *
 * Required for adding all Button features in NgModule-based Angular applications.
 *
 * @example
 *
 * ```ts-no-run
 * import { ButtonsModule } from '@progress/kendo-angular-buttons';
 * import { NgModule } from '@angular/core';
 * import { AppComponent } from './app.component';
 *
 * @NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, ButtonsModule], // import Buttons module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 * ```
 */
class ButtonsModule {
  static ɵfac = function ButtonsModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonsModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ButtonsModule,
    imports: [ButtonComponent, ButtonComponent, ButtonGroupComponent, DropDownButtonComponent, ButtonItemTemplateDirective, ChipComponent, ChipComponent, ChipListComponent, FloatingActionButtonComponent, DialItemTemplateDirective, FloatingActionButtonTemplateDirective, SplitButtonComponent, SplitButtonCustomMessagesComponent, i12.ToggleButtonTabStopDirective, ButtonItemTemplateDirective, SpeechToTextButtonComponent, SmartPasteButtonComponent, SegmentedControlComponent, i12.ToggleButtonTabStopDirective],
    exports: [ButtonComponent, ButtonComponent, ButtonGroupComponent, DropDownButtonComponent, ButtonItemTemplateDirective, ChipComponent, ChipComponent, ChipListComponent, FloatingActionButtonComponent, DialItemTemplateDirective, FloatingActionButtonTemplateDirective, SplitButtonComponent, SplitButtonCustomMessagesComponent, i12.ToggleButtonTabStopDirective, ButtonItemTemplateDirective, SpeechToTextButtonComponent, SmartPasteButtonComponent, SegmentedControlComponent, i12.ToggleButtonTabStopDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService, PopupService, ResizeBatchService],
    imports: [ButtonComponent, ButtonComponent, DropDownButtonComponent, ChipComponent, ChipComponent, FloatingActionButtonComponent, SplitButtonComponent, SpeechToTextButtonComponent, SmartPasteButtonComponent, SegmentedControlComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonsModule, [{
    type: NgModule,
    args: [{
      imports: [...KENDO_BUTTONS, ...KENDO_TOGGLEBUTTONTABSTOP],
      exports: [...KENDO_BUTTONS, ...KENDO_TOGGLEBUTTONTABSTOP],
      providers: [IconsService, PopupService, ResizeBatchService]
    }]
  }], null, null);
})();

// IMPORTANT: NgModule export kept for backwards compatibility.
/**
 * Represents the exported package module.
 *
 * Required for adding SplitButton features in NgModule-based Angular applications.
 *
 * The package exports:
 * - `SplitButtonComponent`&mdash;The SplitButton component class.
 * - `SplitButtonCustomMessagesComponent`&mdash;The SplitButton custom messages component class.
 */
class SplitButtonModule {
  static ɵfac = function SplitButtonModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SplitButtonModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SplitButtonModule,
    imports: [SplitButtonComponent, SplitButtonCustomMessagesComponent, i12.ToggleButtonTabStopDirective, ButtonItemTemplateDirective, i12.ToggleButtonTabStopDirective],
    exports: [SplitButtonComponent, SplitButtonCustomMessagesComponent, i12.ToggleButtonTabStopDirective, ButtonItemTemplateDirective, i12.ToggleButtonTabStopDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService, PopupService, ResizeBatchService],
    imports: [SplitButtonComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitButtonModule, [{
    type: NgModule,
    args: [{
      exports: [...KENDO_SPLITBUTTON, ...KENDO_TOGGLEBUTTONTABSTOP],
      imports: [...KENDO_SPLITBUTTON, ...KENDO_TOGGLEBUTTONTABSTOP],
      providers: [IconsService, PopupService, ResizeBatchService]
    }]
  }], null, null);
})();

//IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Exports the package module.
 *
 * Required for adding DropDownButton features in NgModule-based Angular applications.
 *
 * The module includes:
 * - `DropDownButtonComponent`&mdash;The component class for the DropDownButton.
 * - `ButtonItemTemplateDirective`&mdash;The directive for the button item template.
 *
 * @example
 * ```typescript
 * import { DropDownButtonModule } from '@progress/kendo-angular-buttons';
 * import { NgModule } from '@angular/core';
 * import { BrowserModule } from '@angular/platform-browser';
 * import { AppComponent } from './app.component';
 *
 * @NgModule({
 *   declarations: [AppComponent],
 *   imports: [BrowserModule, DropDownButtonModule],
 *   bootstrap: [AppComponent]
 * })
 * export class AppModule {}
 * ```
 */
class DropDownButtonModule {
  static ɵfac = function DropDownButtonModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownButtonModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DropDownButtonModule,
    imports: [DropDownButtonComponent, ButtonItemTemplateDirective],
    exports: [DropDownButtonComponent, ButtonItemTemplateDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService, PopupService, ResizeBatchService],
    imports: [DropDownButtonComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownButtonModule, [{
    type: NgModule,
    args: [{
      exports: [...KENDO_DROPDOWNBUTTON],
      imports: [...KENDO_DROPDOWNBUTTON],
      providers: [IconsService, PopupService, ResizeBatchService]
    }]
  }], null, null);
})();

//IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Represents the [NgModule](link:site.data.urls.angular['ngmoduleapi'])
 * definition for the Chip and ChipList components.
 *
 * Required for adding Chip and ChipList features in NgModule-based Angular applications.
 *
 * @example
 * ```typescript
 * import { ChipModule } from '@progress/kendo-angular-buttons';
 * import { NgModule } from '@angular/core';
 * import { BrowserModule } from '@angular/platform-browser';
 * import { AppComponent } from './app.component';
 *
 * @NgModule({
 *   declarations: [AppComponent],
 *   imports: [BrowserModule, ChipModule],
 *   bootstrap: [AppComponent]
 * })
 * export class AppModule {}
 * ```
 */
class ChipModule {
  static ɵfac = function ChipModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChipModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ChipModule,
    imports: [ChipComponent, ChipListComponent],
    exports: [ChipComponent, ChipListComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService],
    imports: [ChipComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChipModule, [{
    type: NgModule,
    args: [{
      exports: [...KENDO_CHIPLIST],
      imports: [...KENDO_CHIPLIST],
      providers: [IconsService]
    }]
  }], null, null);
})();

/**
 * Represents the NgModule definition for the FloatingActionButton component.
 *
 * Required for adding FloatingActionButton features in NgModule-based Angular applications.
 *
 * @example
 * ```ts
 * import { FloatingActionButtonModule } from '@progress/kendo-angular-buttons';
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { NgModule } from '@angular/core';
 * import { AppComponent } from './app.component';
 * import { BrowserModule } from '@angular/platform-browser';
 *
 * @NgModule({
 *     declarations: [AppComponent],
 *     imports: [BrowserModule, FloatingActionButtonModule],
 *     bootstrap: [AppComponent]
 * })
 * export class AppModule {}
 * ```
 */
class FloatingActionButtonModule {
  static ɵfac = function FloatingActionButtonModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FloatingActionButtonModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: FloatingActionButtonModule,
    imports: [FloatingActionButtonComponent, DialItemTemplateDirective, FloatingActionButtonTemplateDirective],
    exports: [FloatingActionButtonComponent, DialItemTemplateDirective, FloatingActionButtonTemplateDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService, PopupService, ResizeBatchService],
    imports: [FloatingActionButtonComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FloatingActionButtonModule, [{
    type: NgModule,
    args: [{
      exports: [...KENDO_FLOATINGACTIONBUTTON],
      imports: [...KENDO_FLOATINGACTIONBUTTON],
      providers: [IconsService, PopupService, ResizeBatchService]
    }]
  }], null, null);
})();

// IMPORTANT: NgModule export kept for backwards compatibility.
/**
 * Represents the exported package module.
 *
 * Required for adding SpeechToTextButton features in NgModule-based Angular applications.
 *
 * The package exports:
 * - `SpeechToTextButtonComponent`&mdash;The SpeechToTextButton component class.
 */
class SpeechToTextButtonModule {
  static ɵfac = function SpeechToTextButtonModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SpeechToTextButtonModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SpeechToTextButtonModule,
    imports: [SpeechToTextButtonComponent],
    exports: [SpeechToTextButtonComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService],
    imports: [KENDO_SPEECHTOTEXTBUTTON]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpeechToTextButtonModule, [{
    type: NgModule,
    args: [{
      exports: [...KENDO_SPEECHTOTEXTBUTTON],
      imports: [...KENDO_SPEECHTOTEXTBUTTON],
      providers: [IconsService]
    }]
  }], null, null);
})();

/**
 * Represents the [NgModule](link:site.data.urls.angular['ngmoduleapi'])
 * definition for the SmartPasteButton component.
 *
 * The module is meant for backward compatibility. For new applications, use the standalone SmartPasteButton component.
 *
 * @example
 * ```ts-no-run
 * import { SmartPasteButtonModule } from '@progress/kendo-angular-buttons';
 *
 * _@NgModule({
 *     imports: [SmartPasteButtonModule]
 * })
 * export class AppModule {}
 * ```
 */
class SmartPasteButtonModule {
  static ɵfac = function SmartPasteButtonModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SmartPasteButtonModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SmartPasteButtonModule,
    imports: [SmartPasteButtonComponent],
    exports: [SmartPasteButtonComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [SmartPasteButtonComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartPasteButtonModule, [{
    type: NgModule,
    args: [{
      exports: [SmartPasteButtonComponent],
      imports: [SmartPasteButtonComponent]
    }]
  }], null, null);
})();

//IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Represents the exported package module.
 *
 * Required for adding SegmentedControl features in NgModule-based Angular applications.
 *
 * The package exports:
 * - `SegmentedControlComponent`&mdash;The SegmentedControl component class.
 */
class SegmentedControlModule {
  static ɵfac = function SegmentedControlModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SegmentedControlModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SegmentedControlModule,
    imports: [SegmentedControlComponent],
    exports: [SegmentedControlComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService],
    imports: [KENDO_SEGMENTEDCONTROL]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SegmentedControlModule, [{
    type: NgModule,
    args: [{
      exports: [...KENDO_SEGMENTEDCONTROL],
      imports: [...KENDO_SEGMENTEDCONTROL],
      providers: [IconsService]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent as Button, ButtonComponent, ButtonComponent as ButtonDirective, ButtonGroupComponent as ButtonGroup, ButtonGroupComponent, ButtonGroupModule, ButtonItemTemplateDirective, ButtonModule, ButtonsModule, ChipComponent, ChipListComponent, ChipModule, DialItemTemplateDirective, DropDownButtonComponent as DropDownButton, DropDownButtonComponent, DropDownButtonModule, FloatingActionButtonComponent, FloatingActionButtonModule, FloatingActionButtonTemplateDirective, FocusableDirective, KENDO_BUTTON, KENDO_BUTTONGROUP, KENDO_BUTTONS, KENDO_CHIP, KENDO_CHIPLIST, KENDO_DROPDOWNBUTTON, KENDO_FLOATINGACTIONBUTTON, KENDO_SEGMENTEDCONTROL, KENDO_SMARTPASTEBUTTON, KENDO_SPEECHTOTEXTBUTTON, KENDO_SPLITBUTTON, KendoButtonService, ListComponent, LocalizedSplitButtonMessagesDirective, PreventableEvent, SegmentedControlComponent, SegmentedControlModule, SmartPasteButtonComponent, SmartPasteButtonModule, SmartPasteRequestEndEvent, SmartPasteRequestStartEvent, SpeechToTextButtonComponent, SpeechToTextButtonModule, SplitButtonComponent as SplitButton, SplitButtonComponent, SplitButtonCustomMessagesComponent, SplitButtonModule };